var Vo = Object.defineProperty;
var qo = (e, t, r) => t in e ? Vo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Xe = (e, t, r) => (qo(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as Y, jsxs as Ae, Fragment as cn } from "react/jsx-runtime";
import Qo, { createContext as rt, useContext as Ce, createElement as Fe, forwardRef as wa, memo as Go, useDebugValue as Br, useMemo as Ne, useEffect as ue, useLayoutEffect as Jo, useRef as re, useState as ce, useCallback as j, useReducer as Kr, cloneElement as pr, Suspense as Zo } from "react";
import * as ei from "@tanstack/react-query";
import { useSuspenseQuery as ti, dehydrate as ri, hydrate as ni, QueryClientProvider as ai, QueryClient as oi } from "@tanstack/react-query";
import { I18nextProvider as ii, useTranslation as si } from "react-i18next";
import "i18next";
import { createPortal as ui } from "react-dom";
var Rt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ma = { exports: {} };
(function(e, t) {
  (function(n, a) {
    e.exports = a(Qo);
  })(Rt, (r) => (
    /******/
    (() => {
      var n = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (s, u) => {
            u.match = v, u.parse = f;
            var d = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, l = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, b = /(em|rem|px|cm|mm|in|pt|pc)?$/, c = /(dpi|dpcm|dppx)?$/;
            function v(g, p) {
              return f(g).some(function(P) {
                var O = P.inverse, x = P.type === "all" || p.type === P.type;
                if (x && O || !(x || O))
                  return !1;
                var T = P.expressions.every(function(S) {
                  var E = S.feature, A = S.modifier, D = S.value, _ = p[E];
                  if (!_)
                    return !1;
                  switch (E) {
                    case "orientation":
                    case "scan":
                      return _.toLowerCase() === D.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      D = M(D), _ = M(_);
                      break;
                    case "resolution":
                      D = y(D), _ = y(_);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      D = h(D), _ = h(_);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      D = parseInt(D, 10) || 1, _ = parseInt(_, 10) || 0;
                      break;
                  }
                  switch (A) {
                    case "min":
                      return _ >= D;
                    case "max":
                      return _ <= D;
                    default:
                      return _ === D;
                  }
                });
                return T && !O || !T && O;
              });
            }
            function f(g) {
              return g.split(",").map(function(p) {
                p = p.trim();
                var P = p.match(d), O = P[1], x = P[2], T = P[3] || "", S = {};
                return S.inverse = !!O && O.toLowerCase() === "not", S.type = x ? x.toLowerCase() : "all", T = T.match(/\([^\)]+\)/g) || [], S.expressions = T.map(function(E) {
                  var A = E.match(l), D = A[1].toLowerCase().match(m);
                  return {
                    modifier: D[1],
                    feature: D[2],
                    value: A[2]
                  };
                }), S;
              });
            }
            function h(g) {
              var p = Number(g), P;
              return p || (P = g.match(/^(\d+)\s*\/\s*(\d+)$/), p = P[1] / P[2]), p;
            }
            function y(g) {
              var p = parseFloat(g), P = String(g).match(c)[1];
              switch (P) {
                case "dpcm":
                  return p / 2.54;
                case "dppx":
                  return p * 96;
                default:
                  return p;
              }
            }
            function M(g) {
              var p = parseFloat(g), P = String(g).match(b)[1];
              switch (P) {
                case "em":
                  return p * 16;
                case "rem":
                  return p * 16;
                case "cm":
                  return p * 96 / 2.54;
                case "mm":
                  return p * 96 / 2.54 / 10;
                case "in":
                  return p * 96;
                case "pt":
                  return p * 72;
                case "pc":
                  return p * 72 / 12;
                default:
                  return p;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (s, u, d) => {
            d.r(u), d.d(u, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            var l = /[A-Z]/g, m = /^ms-/, b = {};
            function c(h) {
              return "-" + h.toLowerCase();
            }
            function v(h) {
              if (b.hasOwnProperty(h))
                return b[h];
              var y = h.replace(l, c);
              return b[h] = m.test(y) ? "-" + y : y;
            }
            const f = v;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (s, u, d) => {
            var l = d(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, m = typeof window < "u" ? window.matchMedia : null;
            function b(v, f, h) {
              var y = this;
              if (m && !h) {
                var M = m.call(window, v);
                this.matches = M.matches, this.media = M.media, M.addListener(P);
              } else
                this.matches = l(v, f), this.media = v;
              this.addListener = g, this.removeListener = p, this.dispose = O;
              function g(x) {
                M && M.addListener(x);
              }
              function p(x) {
                M && M.removeListener(x);
              }
              function P(x) {
                y.matches = x.matches, y.media = x.media;
              }
              function O() {
                M && M.removeListener(P);
              }
            }
            function c(v, f, h) {
              return new b(v, f, h);
            }
            s.exports = c;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (s) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var u = Object.getOwnPropertySymbols, d = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
            function m(c) {
              if (c == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(c);
            }
            function b() {
              try {
                if (!Object.assign)
                  return !1;
                var c = new String("abc");
                if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
                  return !1;
                for (var v = {}, f = 0; f < 10; f++)
                  v["_" + String.fromCharCode(f)] = f;
                var h = Object.getOwnPropertyNames(v).map(function(M) {
                  return v[M];
                });
                if (h.join("") !== "0123456789")
                  return !1;
                var y = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(M) {
                  y[M] = M;
                }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            s.exports = b() ? Object.assign : function(c, v) {
              for (var f, h = m(c), y, M = 1; M < arguments.length; M++) {
                f = Object(arguments[M]);
                for (var g in f)
                  d.call(f, g) && (h[g] = f[g]);
                if (u) {
                  y = u(f);
                  for (var p = 0; p < y.length; p++)
                    l.call(f, y[p]) && (h[y[p]] = f[y[p]]);
                }
              }
              return h;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (s, u, d) => {
            var l = function() {
            };
            {
              var m = d(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), b = {}, c = d(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              l = function(f) {
                var h = "Warning: " + f;
                typeof console < "u" && console.error(h);
                try {
                  throw new Error(h);
                } catch {
                }
              };
            }
            function v(f, h, y, M, g) {
              for (var p in f)
                if (c(f, p)) {
                  var P;
                  try {
                    if (typeof f[p] != "function") {
                      var O = Error(
                        (M || "React class") + ": " + y + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw O.name = "Invariant Violation", O;
                    }
                    P = f[p](h, p, M, y, null, m);
                  } catch (T) {
                    P = T;
                  }
                  if (P && !(P instanceof Error) && l(
                    (M || "React class") + ": type specification of " + y + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof P + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), P instanceof Error && !(P.message in b)) {
                    b[P.message] = !0;
                    var x = g ? g() : "";
                    l(
                      "Failed " + y + " type: " + P.message + (x ?? "")
                    );
                  }
                }
            }
            v.resetWarningCache = function() {
              b = {};
            }, s.exports = v;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (s, u, d) => {
            var l = d(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), m = d(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), b = d(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), c = d(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), v = d(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), f = function() {
            };
            f = function(y) {
              var M = "Warning: " + y;
              typeof console < "u" && console.error(M);
              try {
                throw new Error(M);
              } catch {
              }
            };
            function h() {
              return null;
            }
            s.exports = function(y, M) {
              var g = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
              function P(k) {
                var R = k && (g && k[g] || k[p]);
                if (typeof R == "function")
                  return R;
              }
              var O = "<<anonymous>>", x = {
                array: A("array"),
                bigint: A("bigint"),
                bool: A("boolean"),
                func: A("function"),
                number: A("number"),
                object: A("object"),
                string: A("string"),
                symbol: A("symbol"),
                any: D(),
                arrayOf: _,
                element: I(),
                elementType: C(),
                instanceOf: W,
                node: fe(),
                objectOf: ee,
                oneOf: G,
                oneOfType: te,
                shape: ie,
                exact: pe
              };
              function T(k, R) {
                return k === R ? k !== 0 || 1 / k === 1 / R : k !== k && R !== R;
              }
              function S(k, R) {
                this.message = k, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
              }
              S.prototype = Error.prototype;
              function E(k) {
                var R = {}, q = 0;
                function B(Z, K, X, Q, se, V, $) {
                  if (Q = Q || O, V = V || X, $ !== b) {
                    if (M) {
                      var le = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw le.name = "Invariant Violation", le;
                    } else if (typeof console < "u") {
                      var Ee = Q + ":" + X;
                      !R[Ee] && // Avoid spamming the console because they are often not actionable except for lib authors
                      q < 3 && (f(
                        "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), R[Ee] = !0, q++);
                    }
                  }
                  return K[X] == null ? Z ? K[X] === null ? new S("The " + se + " `" + V + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new S("The " + se + " `" + V + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : k(K, X, Q, se, V);
                }
                var z = B.bind(null, !1);
                return z.isRequired = B.bind(null, !0), z;
              }
              function A(k) {
                function R(q, B, z, Z, K, X) {
                  var Q = q[B], se = J(Q);
                  if (se !== k) {
                    var V = ye(Q);
                    return new S(
                      "Invalid " + Z + " `" + K + "` of type " + ("`" + V + "` supplied to `" + z + "`, expected ") + ("`" + k + "`."),
                      { expectedType: k }
                    );
                  }
                  return null;
                }
                return E(R);
              }
              function D() {
                return E(h);
              }
              function _(k) {
                function R(q, B, z, Z, K) {
                  if (typeof k != "function")
                    return new S("Property `" + K + "` of component `" + z + "` has invalid PropType notation inside arrayOf.");
                  var X = q[B];
                  if (!Array.isArray(X)) {
                    var Q = J(X);
                    return new S("Invalid " + Z + " `" + K + "` of type " + ("`" + Q + "` supplied to `" + z + "`, expected an array."));
                  }
                  for (var se = 0; se < X.length; se++) {
                    var V = k(X, se, z, Z, K + "[" + se + "]", b);
                    if (V instanceof Error)
                      return V;
                  }
                  return null;
                }
                return E(R);
              }
              function I() {
                function k(R, q, B, z, Z) {
                  var K = R[q];
                  if (!y(K)) {
                    var X = J(K);
                    return new S("Invalid " + z + " `" + Z + "` of type " + ("`" + X + "` supplied to `" + B + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return E(k);
              }
              function C() {
                function k(R, q, B, z, Z) {
                  var K = R[q];
                  if (!l.isValidElementType(K)) {
                    var X = J(K);
                    return new S("Invalid " + z + " `" + Z + "` of type " + ("`" + X + "` supplied to `" + B + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return E(k);
              }
              function W(k) {
                function R(q, B, z, Z, K) {
                  if (!(q[B] instanceof k)) {
                    var X = k.name || O, Q = Pe(q[B]);
                    return new S("Invalid " + Z + " `" + K + "` of type " + ("`" + Q + "` supplied to `" + z + "`, expected ") + ("instance of `" + X + "`."));
                  }
                  return null;
                }
                return E(R);
              }
              function G(k) {
                if (!Array.isArray(k))
                  return arguments.length > 1 ? f(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : f("Invalid argument supplied to oneOf, expected an array."), h;
                function R(q, B, z, Z, K) {
                  for (var X = q[B], Q = 0; Q < k.length; Q++)
                    if (T(X, k[Q]))
                      return null;
                  var se = JSON.stringify(k, function($, le) {
                    var Ee = ye(le);
                    return Ee === "symbol" ? String(le) : le;
                  });
                  return new S("Invalid " + Z + " `" + K + "` of value `" + String(X) + "` " + ("supplied to `" + z + "`, expected one of " + se + "."));
                }
                return E(R);
              }
              function ee(k) {
                function R(q, B, z, Z, K) {
                  if (typeof k != "function")
                    return new S("Property `" + K + "` of component `" + z + "` has invalid PropType notation inside objectOf.");
                  var X = q[B], Q = J(X);
                  if (Q !== "object")
                    return new S("Invalid " + Z + " `" + K + "` of type " + ("`" + Q + "` supplied to `" + z + "`, expected an object."));
                  for (var se in X)
                    if (c(X, se)) {
                      var V = k(X, se, z, Z, K + "." + se, b);
                      if (V instanceof Error)
                        return V;
                    }
                  return null;
                }
                return E(R);
              }
              function te(k) {
                if (!Array.isArray(k))
                  return f("Invalid argument supplied to oneOfType, expected an instance of array."), h;
                for (var R = 0; R < k.length; R++) {
                  var q = k[R];
                  if (typeof q != "function")
                    return f(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + we(q) + " at index " + R + "."
                    ), h;
                }
                function B(z, Z, K, X, Q) {
                  for (var se = [], V = 0; V < k.length; V++) {
                    var $ = k[V], le = $(z, Z, K, X, Q, b);
                    if (le == null)
                      return null;
                    le.data && c(le.data, "expectedType") && se.push(le.data.expectedType);
                  }
                  var Ee = se.length > 0 ? ", expected one of type [" + se.join(", ") + "]" : "";
                  return new S("Invalid " + X + " `" + Q + "` supplied to " + ("`" + K + "`" + Ee + "."));
                }
                return E(B);
              }
              function fe() {
                function k(R, q, B, z, Z) {
                  return N(R[q]) ? null : new S("Invalid " + z + " `" + Z + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
                }
                return E(k);
              }
              function oe(k, R, q, B, z) {
                return new S(
                  (k || "React class") + ": " + R + " type `" + q + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + z + "`."
                );
              }
              function ie(k) {
                function R(q, B, z, Z, K) {
                  var X = q[B], Q = J(X);
                  if (Q !== "object")
                    return new S("Invalid " + Z + " `" + K + "` of type `" + Q + "` " + ("supplied to `" + z + "`, expected `object`."));
                  for (var se in k) {
                    var V = k[se];
                    if (typeof V != "function")
                      return oe(z, Z, K, se, ye(V));
                    var $ = V(X, se, z, Z, K + "." + se, b);
                    if ($)
                      return $;
                  }
                  return null;
                }
                return E(R);
              }
              function pe(k) {
                function R(q, B, z, Z, K) {
                  var X = q[B], Q = J(X);
                  if (Q !== "object")
                    return new S("Invalid " + Z + " `" + K + "` of type `" + Q + "` " + ("supplied to `" + z + "`, expected `object`."));
                  var se = m({}, q[B], k);
                  for (var V in se) {
                    var $ = k[V];
                    if (c(k, V) && typeof $ != "function")
                      return oe(z, Z, K, V, ye($));
                    if (!$)
                      return new S(
                        "Invalid " + Z + " `" + K + "` key `" + V + "` supplied to `" + z + "`.\nBad object: " + JSON.stringify(q[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
                      );
                    var le = $(X, V, z, Z, K + "." + V, b);
                    if (le)
                      return le;
                  }
                  return null;
                }
                return E(R);
              }
              function N(k) {
                switch (typeof k) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !k;
                  case "object":
                    if (Array.isArray(k))
                      return k.every(N);
                    if (k === null || y(k))
                      return !0;
                    var R = P(k);
                    if (R) {
                      var q = R.call(k), B;
                      if (R !== k.entries) {
                        for (; !(B = q.next()).done; )
                          if (!N(B.value))
                            return !1;
                      } else
                        for (; !(B = q.next()).done; ) {
                          var z = B.value;
                          if (z && !N(z[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function U(k, R) {
                return k === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
              }
              function J(k) {
                var R = typeof k;
                return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : U(R, k) ? "symbol" : R;
              }
              function ye(k) {
                if (typeof k > "u" || k === null)
                  return "" + k;
                var R = J(k);
                if (R === "object") {
                  if (k instanceof Date)
                    return "date";
                  if (k instanceof RegExp)
                    return "regexp";
                }
                return R;
              }
              function we(k) {
                var R = ye(k);
                switch (R) {
                  case "array":
                  case "object":
                    return "an " + R;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + R;
                  default:
                    return R;
                }
              }
              function Pe(k) {
                return !k.constructor || !k.constructor.name ? O : k.constructor.name;
              }
              return x.checkPropTypes = v, x.resetWarningCache = v.resetWarningCache, x.PropTypes = x, x;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (s, u, d) => {
            {
              var l = d(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = !0;
              s.exports = d(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(l.isElement, m);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (s) => {
            var u = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            s.exports = u;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (s) => {
            s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (s, u) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var d = typeof Symbol == "function" && Symbol.for, l = d ? Symbol.for("react.element") : 60103, m = d ? Symbol.for("react.portal") : 60106, b = d ? Symbol.for("react.fragment") : 60107, c = d ? Symbol.for("react.strict_mode") : 60108, v = d ? Symbol.for("react.profiler") : 60114, f = d ? Symbol.for("react.provider") : 60109, h = d ? Symbol.for("react.context") : 60110, y = d ? Symbol.for("react.async_mode") : 60111, M = d ? Symbol.for("react.concurrent_mode") : 60111, g = d ? Symbol.for("react.forward_ref") : 60112, p = d ? Symbol.for("react.suspense") : 60113, P = d ? Symbol.for("react.suspense_list") : 60120, O = d ? Symbol.for("react.memo") : 60115, x = d ? Symbol.for("react.lazy") : 60116, T = d ? Symbol.for("react.block") : 60121, S = d ? Symbol.for("react.fundamental") : 60117, E = d ? Symbol.for("react.responder") : 60118, A = d ? Symbol.for("react.scope") : 60119;
              function D($) {
                return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                $ === b || $ === M || $ === v || $ === c || $ === p || $ === P || typeof $ == "object" && $ !== null && ($.$$typeof === x || $.$$typeof === O || $.$$typeof === f || $.$$typeof === h || $.$$typeof === g || $.$$typeof === S || $.$$typeof === E || $.$$typeof === A || $.$$typeof === T);
              }
              function _($) {
                if (typeof $ == "object" && $ !== null) {
                  var le = $.$$typeof;
                  switch (le) {
                    case l:
                      var Ee = $.type;
                      switch (Ee) {
                        case y:
                        case M:
                        case b:
                        case v:
                        case c:
                        case p:
                          return Ee;
                        default:
                          var Ie = Ee && Ee.$$typeof;
                          switch (Ie) {
                            case h:
                            case g:
                            case x:
                            case O:
                            case f:
                              return Ie;
                            default:
                              return le;
                          }
                      }
                    case m:
                      return le;
                  }
                }
              }
              var I = y, C = M, W = h, G = f, ee = l, te = g, fe = b, oe = x, ie = O, pe = m, N = v, U = c, J = p, ye = !1;
              function we($) {
                return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Pe($) || _($) === y;
              }
              function Pe($) {
                return _($) === M;
              }
              function k($) {
                return _($) === h;
              }
              function R($) {
                return _($) === f;
              }
              function q($) {
                return typeof $ == "object" && $ !== null && $.$$typeof === l;
              }
              function B($) {
                return _($) === g;
              }
              function z($) {
                return _($) === b;
              }
              function Z($) {
                return _($) === x;
              }
              function K($) {
                return _($) === O;
              }
              function X($) {
                return _($) === m;
              }
              function Q($) {
                return _($) === v;
              }
              function se($) {
                return _($) === c;
              }
              function V($) {
                return _($) === p;
              }
              u.AsyncMode = I, u.ConcurrentMode = C, u.ContextConsumer = W, u.ContextProvider = G, u.Element = ee, u.ForwardRef = te, u.Fragment = fe, u.Lazy = oe, u.Memo = ie, u.Portal = pe, u.Profiler = N, u.StrictMode = U, u.Suspense = J, u.isAsyncMode = we, u.isConcurrentMode = Pe, u.isContextConsumer = k, u.isContextProvider = R, u.isElement = q, u.isForwardRef = B, u.isFragment = z, u.isLazy = Z, u.isMemo = K, u.isPortal = X, u.isProfiler = Q, u.isStrictMode = se, u.isSuspense = V, u.isValidElementType = D, u.typeOf = _;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (s, u, d) => {
            s.exports = d(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (s, u, d) => {
            d.r(u), d.d(u, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                m
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                l
              )
              /* harmony export */
            });
            function l(b, c) {
              if (b === c)
                return !0;
              if (!b || !c)
                return !1;
              var v = Object.keys(b), f = Object.keys(c), h = v.length;
              if (f.length !== h)
                return !1;
              for (var y = 0; y < h; y++) {
                var M = v[y];
                if (b[M] !== c[M] || !Object.prototype.hasOwnProperty.call(c, M))
                  return !1;
              }
              return !0;
            }
            function m(b, c) {
              if (b === c)
                return !0;
              if (!b || !c)
                return !1;
              var v = b.length;
              if (c.length !== v)
                return !1;
              for (var f = 0; f < v; f++)
                if (b[f] !== c[f])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(s, u, d) {
            var l = this && this.__rest || function(v, f) {
              var h = {};
              for (var y in v)
                Object.prototype.hasOwnProperty.call(v, y) && f.indexOf(y) < 0 && (h[y] = v[y]);
              if (v != null && typeof Object.getOwnPropertySymbols == "function")
                for (var M = 0, y = Object.getOwnPropertySymbols(v); M < y.length; M++)
                  f.indexOf(y[M]) < 0 && Object.prototype.propertyIsEnumerable.call(v, y[M]) && (h[y[M]] = v[y[M]]);
              return h;
            }, m = this && this.__importDefault || function(v) {
              return v && v.__esModule ? v : { default: v };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var b = m(d(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), c = function(v) {
              var f = v.children, h = v.device, y = v.onChange, M = l(v, ["children", "device", "onChange"]), g = (0, b.default)(M, h, y);
              return typeof f == "function" ? f(g) : g ? f : null;
            };
            u.default = c;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (s, u, d) => {
            Object.defineProperty(u, "__esModule", { value: !0 });
            var l = d(
              /*! react */
              "react"
            ), m = (0, l.createContext)(void 0);
            u.default = m;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(s, u, d) {
            var l = this && this.__importDefault || function(f) {
              return f && f.__esModule ? f : { default: f };
            };
            Object.defineProperty(u, "__esModule", { value: !0 }), u.Context = u.toQuery = u.useMediaQuery = u.default = void 0;
            var m = l(d(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            u.useMediaQuery = m.default;
            var b = l(d(
              /*! ./Component */
              "./src/Component.ts"
            ));
            u.default = b.default;
            var c = l(d(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            u.toQuery = c.default;
            var v = l(d(
              /*! ./Context */
              "./src/Context.ts"
            ));
            u.Context = v.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(s, u, d) {
            var l = this && this.__assign || function() {
              return l = Object.assign || function(p) {
                for (var P, O = 1, x = arguments.length; O < x; O++) {
                  P = arguments[O];
                  for (var T in P)
                    Object.prototype.hasOwnProperty.call(P, T) && (p[T] = P[T]);
                }
                return p;
              }, l.apply(this, arguments);
            }, m = this && this.__rest || function(p, P) {
              var O = {};
              for (var x in p)
                Object.prototype.hasOwnProperty.call(p, x) && P.indexOf(x) < 0 && (O[x] = p[x]);
              if (p != null && typeof Object.getOwnPropertySymbols == "function")
                for (var T = 0, x = Object.getOwnPropertySymbols(p); T < x.length; T++)
                  P.indexOf(x[T]) < 0 && Object.prototype.propertyIsEnumerable.call(p, x[T]) && (O[x[T]] = p[x[T]]);
              return O;
            }, b = this && this.__importDefault || function(p) {
              return p && p.__esModule ? p : { default: p };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var c = b(d(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), v = c.default.oneOfType([
              c.default.string,
              c.default.number
            ]), f = {
              all: c.default.bool,
              grid: c.default.bool,
              aural: c.default.bool,
              braille: c.default.bool,
              handheld: c.default.bool,
              print: c.default.bool,
              projection: c.default.bool,
              screen: c.default.bool,
              tty: c.default.bool,
              tv: c.default.bool,
              embossed: c.default.bool
            }, h = {
              orientation: c.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: c.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: c.default.string,
              deviceAspectRatio: c.default.string,
              height: v,
              deviceHeight: v,
              width: v,
              deviceWidth: v,
              color: c.default.bool,
              colorIndex: c.default.bool,
              monochrome: c.default.bool,
              resolution: v,
              type: Object.keys(f)
            };
            h.type;
            var y = m(
              h,
              ["type"]
            ), M = l({ minAspectRatio: c.default.string, maxAspectRatio: c.default.string, minDeviceAspectRatio: c.default.string, maxDeviceAspectRatio: c.default.string, minHeight: v, maxHeight: v, minDeviceHeight: v, maxDeviceHeight: v, minWidth: v, maxWidth: v, minDeviceWidth: v, maxDeviceWidth: v, minColor: c.default.number, maxColor: c.default.number, minColorIndex: c.default.number, maxColorIndex: c.default.number, minMonochrome: c.default.number, maxMonochrome: c.default.number, minResolution: v, maxResolution: v }, y), g = l(l({}, f), M);
            u.default = {
              all: g,
              types: f,
              matchers: h,
              features: M
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(s, u, d) {
            var l = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = l(d(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), b = l(d(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), c = function(y) {
              return "not ".concat(y);
            }, v = function(y, M) {
              var g = (0, m.default)(y);
              return typeof M == "number" && (M = "".concat(M, "px")), M === !0 ? g : M === !1 ? c(g) : "(".concat(g, ": ").concat(M, ")");
            }, f = function(y) {
              return y.join(" and ");
            }, h = function(y) {
              var M = [];
              return Object.keys(b.default.all).forEach(function(g) {
                var p = y[g];
                p != null && M.push(v(g, p));
              }), f(M);
            };
            u.default = h;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(s, u, d) {
            var l = this && this.__importDefault || function(S) {
              return S && S.__esModule ? S : { default: S };
            };
            Object.defineProperty(u, "__esModule", { value: !0 });
            var m = d(
              /*! react */
              "react"
            ), b = l(d(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), c = l(d(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), v = d(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), f = l(d(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), h = l(d(
              /*! ./Context */
              "./src/Context.ts"
            )), y = function(S) {
              return S.query || (0, f.default)(S);
            }, M = function(S) {
              if (S) {
                var E = Object.keys(S);
                return E.reduce(function(A, D) {
                  return A[(0, c.default)(D)] = S[D], A;
                }, {});
              }
            }, g = function() {
              var S = (0, m.useRef)(!1);
              return (0, m.useEffect)(function() {
                S.current = !0;
              }, []), S.current;
            }, p = function(S) {
              var E = (0, m.useContext)(h.default), A = function() {
                return M(S) || M(E);
              }, D = (0, m.useState)(A), _ = D[0], I = D[1];
              return (0, m.useEffect)(function() {
                var C = A();
                (0, v.shallowEqualObjects)(_, C) || I(C);
              }, [S, E]), _;
            }, P = function(S) {
              var E = function() {
                return y(S);
              }, A = (0, m.useState)(E), D = A[0], _ = A[1];
              return (0, m.useEffect)(function() {
                var I = E();
                D !== I && _(I);
              }, [S]), D;
            }, O = function(S, E) {
              var A = function() {
                return (0, b.default)(S, E || {}, !!E);
              }, D = (0, m.useState)(A), _ = D[0], I = D[1], C = g();
              return (0, m.useEffect)(function() {
                if (C) {
                  var W = A();
                  return I(W), function() {
                    W && W.dispose();
                  };
                }
              }, [S, E]), _;
            }, x = function(S) {
              var E = (0, m.useState)(S.matches), A = E[0], D = E[1];
              return (0, m.useEffect)(function() {
                var _ = function(I) {
                  D(I.matches);
                };
                return S.addListener(_), D(S.matches), function() {
                  S.removeListener(_);
                };
              }, [S]), A;
            }, T = function(S, E, A) {
              var D = p(E), _ = P(S);
              if (!_)
                throw new Error("Invalid or missing MediaQuery!");
              var I = O(_, D), C = x(I), W = g();
              return (0, m.useEffect)(function() {
                W && A && A(C);
              }, [C]), (0, m.useEffect)(function() {
                return function() {
                  I && I.dispose();
                };
              }, []), C;
            };
            u.default = T;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (s) => {
            s.exports = r;
          }
        )
        /******/
      }, a = {};
      function o(s) {
        var u = a[s];
        if (u !== void 0)
          return u.exports;
        var d = a[s] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return n[s].call(d.exports, d, d.exports, o), d.exports;
      }
      o.d = (s, u) => {
        for (var d in u)
          o.o(u, d) && !o.o(s, d) && Object.defineProperty(s, d, { enumerable: !0, get: u[d] });
      }, o.o = (s, u) => Object.prototype.hasOwnProperty.call(s, u), o.r = (s) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
      };
      var i = o("./src/index.ts");
      return i;
    })()
  ));
})(Ma);
var di = Ma.exports;
function li(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function fn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fn(Object(r), !0).forEach(function(n) {
      li(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ne(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function ci(e, t) {
  if (e) {
    if (typeof e == "string")
      return mn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return mn(e, t);
  }
}
function mn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function vt(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = ci(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
var Ur = /* @__PURE__ */ rt({});
function fi(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function vn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Pt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vn(Object(r), !0).forEach(function(n) {
      fi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Cr(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function mi(e, t) {
  if (e) {
    if (typeof e == "string")
      return hn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return hn(e, t);
  }
}
function hn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pn(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = mi(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
function vi(e) {
  return typeof e == "function";
}
var xt = function(t, r, n) {
  n === void 0 && (n = r.children);
  var a = Ce(Ur);
  if (a.useCreateElement)
    return a.useCreateElement(t, r, n);
  if (typeof t == "string" && vi(n)) {
    r.children;
    var o = Cr(r, ["children"]);
    return n(o);
  }
  return /* @__PURE__ */ Fe(t, r, n);
};
function hi(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function bn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ze(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bn(Object(r), !0).forEach(function(n) {
      hi(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pi(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function bi(e, t) {
  if (e) {
    if (typeof e == "string")
      return gn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return gn(e, t);
  }
}
function gn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function gi(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = bi(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
function Xr(e) {
  return typeof e == "object" && e != null;
}
function xr(e) {
  var t;
  if (!Xr(e))
    return !1;
  var r = Object.getPrototypeOf(e);
  return r == null ? !0 : ((t = r.constructor) === null || t === void 0 ? void 0 : t.toString()) === Object.toString();
}
function yn(e, t) {
  for (var r = Object.keys(e), n = {}, a = {}, o = 0, i = r; o < i.length; o++) {
    var s = i[o];
    t.indexOf(s) >= 0 ? n[s] = e[s] : a[s] = e[s];
  }
  return [n, a];
}
function wn(e, t) {
  if (t === void 0 && (t = []), !xr(e.state))
    return yn(e, t);
  var r = yn(e, [].concat(t, ["state"])), n = r[0], a = r[1], o = n.state, i = pi(n, ["state"]);
  return [Ze(Ze({}, o), i), a];
}
function Lt(e, t) {
  if (e === t)
    return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var o = 0, i = r; o < i.length; o++) {
    var s = i[o];
    if (e[s] !== t[s])
      return !1;
  }
  return !0;
}
function Mn(e) {
  return e.name === "normalizePropsAreEqualInner" ? e : function(r, n) {
    return !xr(r.state) || !xr(n.state) ? e(r, n) : e(Ze(Ze({}, r.state), r), Ze(Ze({}, n.state), n));
  };
}
function yi(e) {
  return /* @__PURE__ */ wa(e);
}
function wi(e, t) {
  return /* @__PURE__ */ Go(e, t);
}
function be(e) {
  var t = e.as, r = e.useHook, n = e.memo, a = e.propsAreEqual, o = a === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : a, i = e.keys, s = i === void 0 ? (r == null ? void 0 : r.__keys) || [] : i, u = e.useCreateElement, d = u === void 0 ? xt : u, l = function(b, c) {
    var v = b.as, f = v === void 0 ? t : v, h = Cr(b, ["as"]);
    if (r) {
      var y, M = wn(h, s), g = M[0], p = M[1], P = r(g, Pt({
        ref: c
      }, p)), O = P.wrapElement, x = Cr(P, ["wrapElement"]), T = ((y = f.render) === null || y === void 0 ? void 0 : y.__keys) || f.__keys, S = T && wn(h, T)[0], E = S ? Pt(Pt({}, x), S) : x, A = d(f, E);
      return O ? O(A) : A;
    }
    return d(f, Pt({
      ref: c
    }, h));
  };
  return process.env.NODE_ENV !== "production" && r && (l.displayName = r.name.replace(/^(unstable_)?use/, "")), l = yi(l), n && (l = wi(l, o && Mn(o))), l.__keys = s, l.unstable_propsAreEqual = Mn(o || Lt), l;
}
function Ea(e, t) {
  Br(e);
  var r = Ce(Ur);
  return r[e] != null ? r[e] : t;
}
function Mi(e, t, r) {
  t === void 0 && (t = {}), r === void 0 && (r = {});
  var n = "use" + e + "Props";
  Br(n);
  var a = Ea(n);
  return a ? a(t, r) : r;
}
function Ei(e, t, r) {
  t === void 0 && (t = {}), r === void 0 && (r = {});
  var n = "use" + e + "Options";
  Br(n);
  var a = Ea(n);
  return a ? Pt(Pt({}, t), a(t, r)) : t;
}
function Pi(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function ge(e) {
  var t, r, n = Pi(e.compose), a = function(u, d) {
    if (e.useOptions && (u = e.useOptions(u, d)), e.name && (u = Ei(e.name, u, d)), e.compose)
      for (var l = pn(n), m; !(m = l()).done; ) {
        var b = m.value;
        u = b.__useOptions(u, d);
      }
    return u;
  }, o = function(u, d, l) {
    if (u === void 0 && (u = {}), d === void 0 && (d = {}), l === void 0 && (l = !1), l || (u = a(u, d)), e.useProps && (d = e.useProps(u, d)), e.name && (d = Mi(e.name, u, d)), e.compose)
      if (e.useComposeOptions && (u = e.useComposeOptions(u, d)), e.useComposeProps)
        d = e.useComposeProps(u, d);
      else
        for (var m = pn(n), b; !(b = m()).done; ) {
          var c = b.value;
          d = c(u, d, !0);
        }
    var v = {}, f = d || {};
    for (var h in f)
      f[h] !== void 0 && (v[h] = f[h]);
    return v;
  };
  o.__useOptions = a;
  var i = n.reduce(function(s, u) {
    return s.push.apply(s, u.__keys || []), s;
  }, []);
  return o.__keys = [].concat(i, ((t = e.useState) === null || t === void 0 ? void 0 : t.__keys) || [], e.keys || []), o.unstable_propsAreEqual = e.propsAreEqual || ((r = n[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || Lt, process.env.NODE_ENV !== "production" && e.name && Object.defineProperty(o, "name", {
    value: "use" + e.name
  }), o;
}
function En(e, t) {
  t === void 0 && (t = null), e && (typeof e == "function" ? e(t) : e.current = t);
}
function Ke(e, t) {
  return Ne(function() {
    return e == null && t == null ? null : function(r) {
      En(e, r), En(t, r);
    };
  }, [e, t]);
}
var Si = ["button", "color", "file", "image", "reset", "submit"];
function fr(e) {
  if (e.tagName === "BUTTON")
    return !0;
  if (e.tagName === "INPUT") {
    var t = e;
    return Si.indexOf(t.type) !== -1;
  }
  return !1;
}
function Pa(e) {
  for (var t = [], r = gi(e), n; !(n = r()).done; ) {
    var a = n.value;
    Array.isArray(a) ? t.push.apply(t, Pa(a)) : t.push(a);
  }
  return t;
}
function _e(e) {
  if (process.env.NODE_ENV !== "production") {
    var t;
    if (!e)
      return;
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var o = Pa(n.map(function(i) {
      return [i, `
`];
    }));
    (t = console).warn.apply(t, o.slice(0, -1));
    try {
      throw Error(o.join(""));
    } catch {
    }
  }
}
function Oi(e) {
  return Xr(e) && "current" in e;
}
function Kt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  process.env.NODE_ENV !== "production" && ue(function() {
    process.env.NODE_ENV !== "production" && _e.apply(void 0, [e].concat(r.map(function(a) {
      return Oi(a) ? a.current : a;
    })));
  }, [e]);
}
function Me(e) {
  return e ? e.ownerDocument || e : document;
}
var kr;
try {
  kr = window;
} catch {
}
function Sa(e) {
  return e && Me(e).defaultView || kr;
}
function Di() {
  var e = Sa();
  return !!(typeof e < "u" && e.document && e.document.createElement);
}
var kt = Di(), nt = kt ? Jo : ue;
function ae(e) {
  var t = re(e);
  return nt(function() {
    t.current = e;
  }), t;
}
function je(e) {
  return e.target === e.currentTarget;
}
function At(e) {
  var t = Me(e), r = t.activeElement;
  return r != null && r.nodeName ? r : null;
}
function He(e, t) {
  return e === t || e.contains(t);
}
function Ut(e) {
  var t = At(e);
  if (!t)
    return !1;
  if (He(e, t))
    return !0;
  var r = t.getAttribute("aria-activedescendant");
  return r ? r === e.id ? !0 : !!e.querySelector("#" + r) : !1;
}
function Vr(e) {
  return !He(e.currentTarget, e.target);
}
function st(e) {
  return kt ? window.navigator.userAgent.indexOf(e) !== -1 : !1;
}
function Oa(e, t) {
  return "matches" in e ? e.matches(t) : "msMatchesSelector" in e ? e.msMatchesSelector(t) : e.webkitMatchesSelector(t);
}
function Da(e, t) {
  if ("closest" in e)
    return e.closest(t);
  do {
    if (Oa(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
var _a = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function _i(e) {
  var t = e;
  return t.offsetWidth > 0 || t.offsetHeight > 0 || e.getClientRects().length > 0;
}
function Ti(e) {
  var t = parseInt(e.getAttribute("tabindex") || "0", 10);
  return t < 0;
}
function Ta(e) {
  return Oa(e, _a) && _i(e);
}
function Ar(e) {
  return Ta(e) && !Ti(e);
}
function Ca(e, t) {
  var r = Array.from(e.querySelectorAll(_a)), n = r.filter(Ar);
  return Ar(e) && n.unshift(e), !n.length && t ? r : n;
}
function xa(e, t) {
  var r = Ca(e, t), n = r[0];
  return n || null;
}
function Ci(e, t) {
  var r = Ca(e, t);
  return r[r.length - 1] || null;
}
var xi = ["unstable_system"], Xt = ge({
  name: "Role",
  keys: xi,
  propsAreEqual: function(t, r) {
    var n = t.unstable_system, a = ne(t, ["unstable_system"]), o = r.unstable_system, i = ne(r, ["unstable_system"]);
    return n !== o && !Lt(n, o) ? !1 : Lt(a, i);
  }
});
be({
  as: "div",
  useHook: Xt
});
var ki = ["disabled", "focusable"], Ai = st("Mac") && !st("Chrome") && (st("Safari") || st("Firefox"));
function Pn(e) {
  !Ut(e) && Ta(e) && e.focus();
}
function $i(e) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(e.tagName);
}
function Wi(e) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(e.tagName);
}
function Ri(e, t, r, n) {
  return e ? t && !r ? -1 : void 0 : t ? n : n || 0;
}
function br(e, t) {
  return j(function(r) {
    var n;
    (n = e.current) === null || n === void 0 || n.call(e, r), !r.defaultPrevented && t && (r.stopPropagation(), r.preventDefault());
  }, [e, t]);
}
var or = ge({
  name: "Tabbable",
  compose: Xt,
  keys: ki,
  useOptions: function(t, r) {
    var n = r.disabled;
    return w({
      disabled: n
    }, t);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.tabIndex, o = r.onClickCapture, i = r.onMouseDownCapture, s = r.onMouseDown, u = r.onKeyPressCapture, d = r.style, l = ne(r, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), m = re(null), b = ae(o), c = ae(i), v = ae(s), f = ae(u), h = !!t.disabled && !t.focusable, y = ce(!0), M = y[0], g = y[1], p = ce(!0), P = p[0], O = p[1], x = t.disabled ? w({
      pointerEvents: "none"
    }, d) : d;
    nt(function() {
      var D = m.current;
      if (!D) {
        process.env.NODE_ENV !== "production" && _e(!0, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable");
        return;
      }
      $i(D) || g(!1), Wi(D) || O(!1);
    }, []);
    var T = br(b, t.disabled), S = br(c, t.disabled), E = br(f, t.disabled), A = j(function(D) {
      var _;
      (_ = v.current) === null || _ === void 0 || _.call(v, D);
      var I = D.currentTarget;
      if (!D.defaultPrevented && Ai && !Vr(D) && fr(I)) {
        var C = requestAnimationFrame(function() {
          I.removeEventListener("mouseup", W, !0), Pn(I);
        }), W = function() {
          cancelAnimationFrame(C), Pn(I);
        };
        I.addEventListener("mouseup", W, {
          once: !0,
          capture: !0
        });
      }
    }, []);
    return w({
      ref: Ke(m, n),
      style: x,
      tabIndex: Ri(h, M, P, a),
      disabled: h && P ? !0 : void 0,
      "aria-disabled": t.disabled ? !0 : void 0,
      onClickCapture: T,
      onMouseDownCapture: S,
      onMouseDown: A,
      onKeyPressCapture: E
    }, l);
  }
});
be({
  as: "div",
  useHook: or
});
var Ii = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function ji(e) {
  var t = e.currentTarget;
  return e.isTrusted ? fr(t) || t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "A" || t.tagName === "SELECT" : !1;
}
var It = ge({
  name: "Clickable",
  compose: or,
  keys: Ii,
  useOptions: function(t) {
    var r = t.unstable_clickOnEnter, n = r === void 0 ? !0 : r, a = t.unstable_clickOnSpace, o = a === void 0 ? !0 : a, i = ne(t, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
    return w({
      unstable_clickOnEnter: n,
      unstable_clickOnSpace: o
    }, i);
  },
  useProps: function(t, r) {
    var n = r.onKeyDown, a = r.onKeyUp, o = ne(r, ["onKeyDown", "onKeyUp"]), i = ce(!1), s = i[0], u = i[1], d = ae(n), l = ae(a), m = j(function(c) {
      var v;
      if ((v = d.current) === null || v === void 0 || v.call(d, c), !c.defaultPrevented && !t.disabled && !c.metaKey && je(c)) {
        var f = t.unstable_clickOnEnter && c.key === "Enter", h = t.unstable_clickOnSpace && c.key === " ";
        if (f || h) {
          if (ji(c))
            return;
          c.preventDefault(), f ? c.currentTarget.click() : h && u(!0);
        }
      }
    }, [t.disabled, t.unstable_clickOnEnter, t.unstable_clickOnSpace]), b = j(function(c) {
      var v;
      if ((v = l.current) === null || v === void 0 || v.call(l, c), !c.defaultPrevented && !t.disabled && !c.metaKey) {
        var f = t.unstable_clickOnSpace && c.key === " ";
        s && f && (u(!1), c.currentTarget.click());
      }
    }, [t.disabled, t.unstable_clickOnSpace, s]);
    return w({
      "data-active": s || void 0,
      onKeyDown: m,
      onKeyUp: b
    }, o);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: It
});
var Ni = [], ka = ge({
  name: "Button",
  compose: It,
  keys: Ni,
  useProps: function(t, r) {
    var n = r.ref, a = ne(r, ["ref"]), o = re(null), i = ce(void 0), s = i[0], u = i[1], d = ce("button"), l = d[0], m = d[1];
    return ue(function() {
      var b = o.current;
      if (!b) {
        process.env.NODE_ENV !== "production" && _e(!0, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button");
        return;
      }
      fr(b) || (b.tagName !== "A" && u("button"), m(void 0));
    }, []), w({
      ref: Ke(o, n),
      role: s,
      type: l
    }, a);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: ka
});
function Fi(e, t) {
  return t === -1 ? e : [].concat(e.slice(0, t), e.slice(t + 1));
}
function Aa(e, t, r) {
  if (typeof Event == "function")
    return new Event(t, r);
  var n = Me(e).createEvent("Event");
  return n.initEvent(t, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), n;
}
function ht(e) {
  var t = ce(e), r = t[0];
  return r;
}
function $a(e, t) {
  var r = re(!1);
  ue(function() {
    if (r.current)
      return e();
    r.current = !0;
  }, t);
}
function Sn(e, t, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(t, r) : Aa(e, t, r);
}
function gr(e, t) {
  var r = Sn(e, "blur", t), n = e.dispatchEvent(r), a = Ze(Ze({}, t), {}, {
    bubbles: !0
  });
  return e.dispatchEvent(Sn(e, "focusout", a)), n;
}
function Hi(e, t, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function")
    return new KeyboardEvent(t, r);
  var n = Me(e).createEvent("KeyboardEvent");
  return n.initKeyboardEvent(t, r.bubbles, r.cancelable, Sa(e), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), n;
}
function Li(e, t, r) {
  return e.dispatchEvent(Hi(e, t, r));
}
var zi = kt && "msCrypto" in window;
function Wa(e) {
  if (zi) {
    var t = At(e.currentTarget);
    return t;
  }
  return e.relatedTarget;
}
function ir(e) {
  for (var t = [[]], r = function() {
    var i = a.value, s = t.find(function(u) {
      return !u[0] || u[0].groupId === i.groupId;
    });
    s ? s.push(i) : t.push([i]);
  }, n = vt(e), a; !(a = n()).done; )
    r();
  return t;
}
function $r(e) {
  for (var t = [], r = vt(e), n; !(n = r()).done; ) {
    var a = n.value;
    t.push.apply(t, a);
  }
  return t;
}
function Mt(e) {
  return e.slice().reverse();
}
function Ve(e, t) {
  return t ? e.find(function(r) {
    return !r.disabled && r.id !== t;
  }) : e.find(function(r) {
    return !r.disabled;
  });
}
function it(e, t) {
  var r;
  return t || t === null ? t : e.currentId || e.currentId === null ? e.currentId : (r = Ve(e.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function Ra(e, t) {
  if (t)
    return e == null ? void 0 : e.find(function(r) {
      return r.id === t && !r.disabled;
    });
}
var Yi = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], Ia = Yi, Bi = Ia, Ki = Bi;
function ja(e) {
  e.userFocus = !0, e.focus(), e.userFocus = !1;
}
function Ui(e) {
  return !!e.userFocus;
}
function On(e, t) {
  e.userFocus = t;
}
var Xi = kt && "msCrypto" in window;
function Vi(e) {
  return !(!je(e) || e.metaKey || e.key === "Tab");
}
function Dn(e, t, r) {
  var n = ae(r);
  return j(function(a) {
    var o;
    if ((o = n.current) === null || o === void 0 || o.call(n, a), !a.defaultPrevented && e && Vi(a)) {
      var i = t == null ? void 0 : t.ref.current;
      i && (Li(i, a.type, a) || a.preventDefault(), a.currentTarget.contains(i) && a.stopPropagation());
    }
  }, [e, t]);
}
function qi(e) {
  var t = re(null);
  return ue(function() {
    var r = Me(e.current), n = function(o) {
      var i = o.target;
      t.current = i;
    };
    return r.addEventListener("focus", n, !0), function() {
      r.removeEventListener("focus", n, !0);
    };
  }, []), t;
}
function Qi(e) {
  return Ve($r(Mt(ir(e))));
}
function yr(e, t) {
  return e == null ? void 0 : e.some(function(r) {
    return !!t && r.ref.current === t;
  });
}
function Gi(e) {
  var t = ae(e), r = Kr(function(o) {
    return o + 1;
  }, 0), n = r[0], a = r[1];
  return ue(function() {
    var o, i = (o = t.current) === null || o === void 0 ? void 0 : o.ref.current;
    n && i && ja(i);
  }, [n]), a;
}
var Na = ge({
  name: "Composite",
  compose: [or],
  keys: Ia,
  useOptions: function(t) {
    return w(w({}, t), {}, {
      currentId: it(t)
    });
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onFocusCapture, o = r.onFocus, i = r.onBlurCapture, s = r.onKeyDown, u = r.onKeyDownCapture, d = r.onKeyUpCapture, l = ne(r, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), m = re(null), b = Ra(t.items, t.currentId), c = re(null), v = ae(a), f = ae(o), h = ae(i), y = ae(s), M = Gi(b), g = Xi ? qi(m) : void 0;
    ue(function() {
      var E = m.current;
      t.unstable_moves && !b && (process.env.NODE_ENV !== "production" && _e(!E, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite"), E == null || E.focus());
    }, [t.unstable_moves, b]);
    var p = Dn(t.unstable_virtual, b, u), P = Dn(t.unstable_virtual, b, d), O = j(function(E) {
      var A;
      if ((A = v.current) === null || A === void 0 || A.call(v, E), !E.defaultPrevented && t.unstable_virtual) {
        var D = (g == null ? void 0 : g.current) || E.relatedTarget, _ = yr(t.items, D);
        je(E) && _ && (E.stopPropagation(), c.current = D);
      }
    }, [t.unstable_virtual, t.items]), x = j(function(E) {
      var A;
      if ((A = f.current) === null || A === void 0 || A.call(f, E), !E.defaultPrevented) {
        if (t.unstable_virtual)
          je(E) && M();
        else if (je(E)) {
          var D;
          (D = t.setCurrentId) === null || D === void 0 || D.call(t, null);
        }
      }
    }, [t.unstable_virtual, t.setCurrentId]), T = j(function(E) {
      var A;
      if ((A = h.current) === null || A === void 0 || A.call(h, E), !E.defaultPrevented && t.unstable_virtual) {
        var D = (b == null ? void 0 : b.ref.current) || null, _ = Wa(E), I = yr(t.items, _);
        if (je(E) && I)
          _ === D ? c.current && c.current !== _ && gr(c.current, E) : D && gr(D, E), E.stopPropagation();
        else {
          var C = yr(t.items, E.target);
          !C && D && gr(D, E);
        }
      }
    }, [t.unstable_virtual, t.items, b]), S = j(function(E) {
      var A, D;
      if ((A = y.current) === null || A === void 0 || A.call(y, E), !E.defaultPrevented && t.currentId === null && je(E)) {
        var _ = t.orientation !== "horizontal", I = t.orientation !== "vertical", C = !!((D = t.groups) !== null && D !== void 0 && D.length), W = function() {
          if (C) {
            var fe = Qi(t.items);
            if (fe != null && fe.id) {
              var oe;
              (oe = t.move) === null || oe === void 0 || oe.call(t, fe.id);
            }
          } else {
            var ie;
            (ie = t.last) === null || ie === void 0 || ie.call(t);
          }
        }, G = {
          ArrowUp: (C || _) && W,
          ArrowRight: (C || I) && t.first,
          ArrowDown: (C || _) && t.first,
          ArrowLeft: (C || I) && t.last,
          Home: t.first,
          End: t.last,
          PageUp: t.first,
          PageDown: t.last
        }, ee = G[E.key];
        ee && (E.preventDefault(), ee());
      }
    }, [t.currentId, t.orientation, t.groups, t.items, t.move, t.last, t.first]);
    return w({
      ref: Ke(m, n),
      id: t.baseId,
      onFocus: x,
      onFocusCapture: O,
      onBlurCapture: T,
      onKeyDownCapture: p,
      onKeyDown: S,
      onKeyUpCapture: P,
      "aria-activedescendant": t.unstable_virtual && (b == null ? void 0 : b.id) || void 0
    }, l);
  },
  useComposeProps: function(t, r) {
    r = Xt(t, r, !0);
    var n = or(t, r, !0);
    return t.unstable_virtual || t.currentId === null ? w({
      tabIndex: 0
    }, n) : w(w({}, r), {}, {
      ref: n.ref
    });
  }
});
be({
  as: "div",
  useHook: Na,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Kt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite"), xt(t, r, n);
  }
});
function _n(e) {
  try {
    var t = e instanceof HTMLInputElement && e.selectionStart !== null, r = e.tagName === "TEXTAREA", n = e.contentEditable === "true";
    return t || r || n || !1;
  } catch {
    return !1;
  }
}
function Ji(e) {
  var t = At(e);
  if (!t)
    return !1;
  if (t === e)
    return !0;
  var r = t.getAttribute("aria-activedescendant");
  return r ? r === e.id : !1;
}
function zt(e, t) {
  var r = t === void 0 ? {} : t, n = r.preventScroll, a = r.isActive, o = a === void 0 ? Ji : a;
  return o(e) || (e.focus({
    preventScroll: n
  }), o(e)) ? -1 : requestAnimationFrame(function() {
    e.focus({
      preventScroll: n
    });
  });
}
var Fa = "id";
function Zi(e) {
  return e === void 0 && (e = Fa), (e ? e + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var qr = /* @__PURE__ */ rt(Zi);
function es(e) {
  var t = e.children, r = e.prefix, n = r === void 0 ? Fa : r, a = re(0), o = j(function(i) {
    return i === void 0 && (i = n), (i ? i + "-" : "") + ++a.current;
  }, [n]);
  return /* @__PURE__ */ Fe(qr.Provider, {
    value: o
  }, t);
}
var ts = ["baseId", "unstable_idCountRef", "setBaseId"], rs = [].concat(ts, ["id"]), Ha = ge({
  keys: rs,
  useOptions: function(t, r) {
    var n = Ce(qr), a = ce(function() {
      return t.unstable_idCountRef ? (t.unstable_idCountRef.current += 1, "-" + t.unstable_idCountRef.current) : t.baseId ? "-" + n("") : "";
    }), o = a[0], i = Ne(function() {
      return t.baseId || n();
    }, [t.baseId, n]), s = r.id || t.id || "" + i + o;
    return w(w({}, t), {}, {
      id: s
    });
  },
  useProps: function(t, r) {
    return w({
      id: t.id
    }, r);
  }
});
be({
  as: "div",
  useHook: Ha
});
function ns(e, t, r) {
  return e.dispatchEvent(Aa(e, t, r));
}
function Tn(e, t) {
  if (e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement) {
    var r, n = Object.getPrototypeOf(e), a = (r = Object.getOwnPropertyDescriptor(n, "value")) === null || r === void 0 ? void 0 : r.set;
    a && (a.call(e, t), ns(e, "input", {
      bubbles: !0
    }));
  }
}
function wr(e) {
  return e.querySelector("[data-composite-item-widget]");
}
function as(e) {
  return Ne(function() {
    var t;
    return (t = e.items) === null || t === void 0 ? void 0 : t.find(function(r) {
      return e.id && r.id === e.id;
    });
  }, [e.items, e.id]);
}
function os(e, t) {
  if (je(e))
    return !1;
  for (var r = vt(t), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.ref.current === e.target)
      return !0;
  }
  return !1;
}
var Wr = ge({
  name: "CompositeItem",
  compose: [It, Ha],
  keys: Ki,
  propsAreEqual: function(t, r) {
    if (!r.id || t.id !== r.id)
      return It.unstable_propsAreEqual(t, r);
    var n = t.currentId, a = t.unstable_moves, o = ne(t, ["currentId", "unstable_moves"]), i = r.currentId, s = r.unstable_moves, u = ne(r, ["currentId", "unstable_moves"]);
    if (i !== n) {
      if (r.id === i || r.id === n)
        return !1;
    } else if (a !== s)
      return !1;
    return It.unstable_propsAreEqual(o, u);
  },
  useOptions: function(t) {
    return w(w({}, t), {}, {
      id: t.id,
      currentId: it(t),
      unstable_clickOnSpace: t.unstable_hasActiveWidget ? !1 : t.unstable_clickOnSpace
    });
  },
  useProps: function(t, r) {
    var n, a = r.ref, o = r.tabIndex, i = o === void 0 ? 0 : o, s = r.onMouseDown, u = r.onFocus, d = r.onBlurCapture, l = r.onKeyDown, m = r.onClick, b = ne(r, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), c = re(null), v = t.id, f = t.disabled && !t.focusable, h = t.currentId === v, y = ae(h), M = re(!1), g = as(t), p = ae(s), P = ae(u), O = ae(d), x = ae(l), T = ae(m), S = !t.unstable_virtual && !t.unstable_hasActiveWidget && h || // We don't want to set tabIndex="-1" when using CompositeItem as a
    // standalone component, without state props.
    !((n = t.items) !== null && n !== void 0 && n.length);
    ue(function() {
      var C;
      if (v)
        return (C = t.registerItem) === null || C === void 0 || C.call(t, {
          id: v,
          ref: c,
          disabled: !!f
        }), function() {
          var W;
          (W = t.unregisterItem) === null || W === void 0 || W.call(t, v);
        };
    }, [v, f, t.registerItem, t.unregisterItem]), ue(function() {
      var C = c.current;
      if (!C) {
        process.env.NODE_ENV !== "production" && _e(!0, "Can't focus composite item component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite");
        return;
      }
      t.unstable_moves && y.current && ja(C);
    }, [t.unstable_moves]);
    var E = j(function(C) {
      var W;
      (W = p.current) === null || W === void 0 || W.call(p, C), On(C.currentTarget, !0);
    }, []), A = j(function(C) {
      var W, G, ee = Ui(C.currentTarget);
      if (On(C.currentTarget, !1), (W = P.current) === null || W === void 0 || W.call(P, C), !C.defaultPrevented && !Vr(C) && v && !os(C, t.items) && ((G = t.setCurrentId) === null || G === void 0 || G.call(t, v), ee && t.unstable_virtual && t.baseId && je(C))) {
        var te = C.target, fe = Me(te).getElementById(t.baseId);
        fe && (M.current = !0, zt(fe));
      }
    }, [v, t.items, t.setCurrentId, t.unstable_virtual, t.baseId]), D = j(function(C) {
      var W;
      (W = O.current) === null || W === void 0 || W.call(O, C), !C.defaultPrevented && t.unstable_virtual && M.current && (M.current = !1, C.preventDefault(), C.stopPropagation());
    }, [t.unstable_virtual]), _ = j(function(C) {
      var W;
      if (je(C)) {
        var G = t.orientation !== "horizontal", ee = t.orientation !== "vertical", te = !!(g != null && g.groupId), fe = {
          ArrowUp: (te || G) && t.up,
          ArrowRight: (te || ee) && t.next,
          ArrowDown: (te || G) && t.down,
          ArrowLeft: (te || ee) && t.previous,
          Home: function() {
            if (!te || C.ctrlKey) {
              var U;
              (U = t.first) === null || U === void 0 || U.call(t);
            } else {
              var J;
              (J = t.previous) === null || J === void 0 || J.call(t, !0);
            }
          },
          End: function() {
            if (!te || C.ctrlKey) {
              var U;
              (U = t.last) === null || U === void 0 || U.call(t);
            } else {
              var J;
              (J = t.next) === null || J === void 0 || J.call(t, !0);
            }
          },
          PageUp: function() {
            if (te) {
              var U;
              (U = t.up) === null || U === void 0 || U.call(t, !0);
            } else {
              var J;
              (J = t.first) === null || J === void 0 || J.call(t);
            }
          },
          PageDown: function() {
            if (te) {
              var U;
              (U = t.down) === null || U === void 0 || U.call(t, !0);
            } else {
              var J;
              (J = t.last) === null || J === void 0 || J.call(t);
            }
          }
        }, oe = fe[C.key];
        if (oe) {
          C.preventDefault(), oe();
          return;
        }
        if ((W = x.current) === null || W === void 0 || W.call(x, C), !C.defaultPrevented) {
          if (C.key.length === 1 && C.key !== " ") {
            var ie = wr(C.currentTarget);
            ie && _n(ie) && (ie.focus(), Tn(ie, ""));
          } else if (C.key === "Delete" || C.key === "Backspace") {
            var pe = wr(C.currentTarget);
            pe && _n(pe) && (C.preventDefault(), Tn(pe, ""));
          }
        }
      }
    }, [t.orientation, g, t.up, t.next, t.down, t.previous, t.first, t.last]), I = j(function(C) {
      var W;
      if ((W = T.current) === null || W === void 0 || W.call(T, C), !C.defaultPrevented) {
        var G = C.currentTarget, ee = wr(G);
        ee && !Ut(ee) && ee.focus();
      }
    }, []);
    return w({
      ref: Ke(c, a),
      id: v,
      tabIndex: S ? i : -1,
      "aria-selected": t.unstable_virtual && h ? !0 : void 0,
      onMouseDown: E,
      onFocus: A,
      onBlurCapture: D,
      onKeyDown: _,
      onClick: I
    }, b);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: Wr
});
function is(e) {
  return typeof e == "function";
}
function Qe(e, t) {
  return is(e) ? e(t) : e;
}
function La(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.baseId, n = Ce(qr), a = re(0), o = ce(function() {
    return r || n();
  }), i = o[0], s = o[1];
  return {
    baseId: i,
    setBaseId: s,
    unstable_idCountRef: a
  };
}
function za(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function Cn(e, t) {
  return e.findIndex(function(r) {
    return !r.ref.current || !t.ref.current ? !1 : za(t.ref.current, r.ref.current);
  });
}
function Ya(e) {
  for (var t = 0, r = vt(e), n; !(n = r()).done; ) {
    var a = n.value.length;
    a > t && (t = a);
  }
  return t;
}
function xn(e) {
  for (var t = ir(e), r = Ya(t), n = [], a = 0; a < r; a += 1)
    for (var o = vt(t), i; !(i = o()).done; ) {
      var s = i.value;
      s[a] && n.push(w(w({}, s[a]), {}, {
        // If there's no groupId, it means that it's not a grid composite,
        // but a single row instead. So, instead of verticalizing it, that
        // is, assigning a different groupId based on the column index, we
        // keep it undefined so they will be part of the same group.
        // It's useful when using up/down on one-dimensional composites.
        groupId: s[a].groupId ? "" + a : void 0
      }));
    }
  return n;
}
function ss(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    ref: {
      current: null
    },
    groupId: e
  };
}
function kn(e, t, r) {
  for (var n = Ya(e), a = vt(e), o; !(o = a()).done; )
    for (var i = o.value, s = 0; s < n; s += 1) {
      var u = i[s];
      if (!u || r && u.disabled) {
        var d = s === 0, l = d && r ? Ve(i) : i[s - 1];
        i[s] = l && t !== (l == null ? void 0 : l.id) && r ? l : ss(l == null ? void 0 : l.groupId);
      }
    }
  return e;
}
var us = {
  id: null,
  ref: {
    current: null
  }
};
function ds(e, t, r) {
  var n = e.findIndex(function(a) {
    return a.id === t;
  });
  return [].concat(e.slice(n + 1), r ? [us] : [], e.slice(0, n));
}
function Mr(e, t) {
  return e.filter(function(r) {
    return r.groupId === t;
  });
}
var ls = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function cs(e) {
  return e && ls[e];
}
function An(e, t, r) {
  return r in e ? [].concat(e.slice(0, r), [t], e.slice(r)) : [].concat(e, [t]);
}
function Rr(e) {
  var t = e.map(function(n, a) {
    return [a, n];
  }), r = !1;
  return t.sort(function(n, a) {
    var o = n[0], i = n[1], s = a[0], u = a[1], d = i.ref.current, l = u.ref.current;
    return !d || !l ? 0 : za(d, l) ? (o > s && (r = !0), -1) : (o < s && (r = !0), 1);
  }), r ? t.map(function(n) {
    n[0];
    var a = n[1];
    return a;
  }) : e;
}
function Ba(e, t) {
  var r = Rr(e);
  e !== r && t(r);
}
function fs(e) {
  for (var t, r = e[0], n = e.slice(1), a = r == null || (t = r.ref.current) === null || t === void 0 ? void 0 : t.parentElement, o = function() {
    var u = a;
    if (n.every(function(d) {
      return u.contains(d.ref.current);
    }))
      return {
        v: a
      };
    a = a.parentElement;
  }; a; ) {
    var i = o();
    if (typeof i == "object")
      return i.v;
  }
  return Me(a).body;
}
function ms(e, t) {
  var r = re([]);
  ue(function() {
    for (var n = function() {
      var l = !!r.current.length;
      l && Ba(e, t), r.current = e;
    }, a = fs(e), o = new IntersectionObserver(n, {
      root: a
    }), i = vt(e), s; !(s = i()).done; ) {
      var u = s.value;
      u.ref.current && o.observe(u.ref.current);
    }
    return function() {
      o.disconnect();
    };
  }, [e]);
}
function vs(e, t) {
  ue(function() {
    var r = function() {
      return Ba(e, t);
    }, n = setTimeout(r, 250);
    return function() {
      return clearTimeout(n);
    };
  });
}
function hs(e, t) {
  typeof IntersectionObserver == "function" ? ms(e, t) : vs(e, t);
}
function Te(e, t) {
  var r = e.unstable_virtual, n = e.rtl, a = e.orientation, o = e.items, i = e.groups, s = e.currentId, u = e.loop, d = e.wrap, l = e.pastIds, m = e.shift, b = e.unstable_moves, c = e.unstable_includesBaseElement, v = e.initialVirtual, f = e.initialRTL, h = e.initialOrientation, y = e.initialCurrentId, M = e.initialLoop, g = e.initialWrap, p = e.initialShift, P = e.hasSetCurrentId;
  switch (t.type) {
    case "registerGroup": {
      var O = t.group;
      if (i.length === 0)
        return w(w({}, e), {}, {
          groups: [O]
        });
      var x = Cn(i, O);
      return w(w({}, e), {}, {
        groups: An(i, O, x)
      });
    }
    case "unregisterGroup": {
      var T = t.id, S = i.filter(function(ke) {
        return ke.id !== T;
      });
      return S.length === i.length ? e : w(w({}, e), {}, {
        groups: S
      });
    }
    case "registerItem": {
      var E = t.item, A = i.find(function(ke) {
        var hr;
        return (hr = ke.ref.current) === null || hr === void 0 ? void 0 : hr.contains(E.ref.current);
      }), D = w({
        groupId: A == null ? void 0 : A.id
      }, E), _ = Cn(o, D), I = w(w({}, e), {}, {
        items: An(o, D, _)
      });
      if (!P && !b && y === void 0) {
        var C;
        return w(w({}, I), {}, {
          currentId: (C = Ve(I.items)) === null || C === void 0 ? void 0 : C.id
        });
      }
      return I;
    }
    case "unregisterItem": {
      var W = t.id, G = o.filter(function(ke) {
        return ke.id !== W;
      });
      if (G.length === o.length)
        return e;
      var ee = l.filter(function(ke) {
        return ke !== W;
      }), te = w(w({}, e), {}, {
        pastIds: ee,
        items: G
      });
      if (s && s === W) {
        var fe = c ? null : it(w(w({}, te), {}, {
          currentId: ee[0]
        }));
        return w(w({}, te), {}, {
          currentId: fe
        });
      }
      return te;
    }
    case "move": {
      var oe = t.id;
      if (oe === void 0)
        return e;
      var ie = l.filter(function(ke) {
        return ke !== s && ke !== oe;
      }), pe = s ? [s].concat(ie) : ie, N = w(w({}, e), {}, {
        pastIds: pe
      });
      if (oe === null)
        return w(w({}, N), {}, {
          unstable_moves: b + 1,
          currentId: it(N, oe)
        });
      var U = Ra(o, oe);
      return w(w({}, N), {}, {
        unstable_moves: U ? b + 1 : b,
        currentId: it(N, U == null ? void 0 : U.id)
      });
    }
    case "next": {
      if (s == null)
        return Te(e, w(w({}, t), {}, {
          type: "first"
        }));
      var J = a !== "vertical", ye = n && J, we = ye ? Mt(o) : o, Pe = we.find(function(ke) {
        return ke.id === s;
      });
      if (!Pe)
        return Te(e, w(w({}, t), {}, {
          type: "first"
        }));
      var k = !!Pe.groupId, R = we.indexOf(Pe), q = we.slice(R + 1), B = Mr(q, Pe.groupId);
      if (t.allTheWay) {
        var z = Ve(ye ? Mr(we, Pe.groupId) : Mt(B));
        return Te(e, w(w({}, t), {}, {
          type: "move",
          id: z == null ? void 0 : z.id
        }));
      }
      var Z = cs(
        // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        k ? a || "horizontal" : a
      ), K = u && u !== Z, X = k && d && d !== Z, Q = (
        // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        t.hasNullItem || !k && K && c
      );
      if (K) {
        var se = X && !Q ? we : Mr(we, Pe.groupId), V = ds(se, s, Q), $ = Ve(V, s);
        return Te(e, w(w({}, t), {}, {
          type: "move",
          id: $ == null ? void 0 : $.id
        }));
      }
      if (X) {
        var le = Ve(
          // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          Q ? B : q,
          s
        ), Ee = Q ? (le == null ? void 0 : le.id) || null : le == null ? void 0 : le.id;
        return Te(e, w(w({}, t), {}, {
          type: "move",
          id: Ee
        }));
      }
      var Ie = Ve(B, s);
      return !Ie && Q ? Te(e, w(w({}, t), {}, {
        type: "move",
        id: null
      })) : Te(e, w(w({}, t), {}, {
        type: "move",
        id: Ie == null ? void 0 : Ie.id
      }));
    }
    case "previous": {
      var Gt = !!i.length, Jt = !Gt && c, Zt = Te(w(w({}, e), {}, {
        items: Mt(o)
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: Jt
      }));
      return w(w({}, Zt), {}, {
        items: o
      });
    }
    case "down": {
      var er = m && !t.allTheWay, No = xn($r(kn(ir(o), s, er))), Fo = u && u !== "horizontal", Ho = Fo && c, Lo = Te(w(w({}, e), {}, {
        orientation: "vertical",
        items: No
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: Ho
      }));
      return w(w({}, Lo), {}, {
        orientation: a,
        items: o
      });
    }
    case "up": {
      var zo = m && !t.allTheWay, Yo = xn(Mt($r(kn(ir(o), s, zo)))), Bo = c, Ko = Te(w(w({}, e), {}, {
        orientation: "vertical",
        items: Yo
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: Bo
      }));
      return w(w({}, Ko), {}, {
        orientation: a,
        items: o
      });
    }
    case "first": {
      var vr = Ve(o);
      return Te(e, w(w({}, t), {}, {
        type: "move",
        id: vr == null ? void 0 : vr.id
      }));
    }
    case "last": {
      var Uo = Te(w(w({}, e), {}, {
        items: Mt(o)
      }), w(w({}, t), {}, {
        type: "first"
      }));
      return w(w({}, Uo), {}, {
        items: o
      });
    }
    case "sort":
      return w(w({}, e), {}, {
        items: Rr(o),
        groups: Rr(i)
      });
    case "setVirtual":
      return w(w({}, e), {}, {
        unstable_virtual: Qe(t.virtual, r)
      });
    case "setRTL":
      return w(w({}, e), {}, {
        rtl: Qe(t.rtl, n)
      });
    case "setOrientation":
      return w(w({}, e), {}, {
        orientation: Qe(t.orientation, a)
      });
    case "setCurrentId": {
      var Xo = it(w(w({}, e), {}, {
        currentId: Qe(t.currentId, s)
      }));
      return w(w({}, e), {}, {
        currentId: Xo,
        hasSetCurrentId: !0
      });
    }
    case "setLoop":
      return w(w({}, e), {}, {
        loop: Qe(t.loop, u)
      });
    case "setWrap":
      return w(w({}, e), {}, {
        wrap: Qe(t.wrap, d)
      });
    case "setShift":
      return w(w({}, e), {}, {
        shift: Qe(t.shift, m)
      });
    case "setIncludesBaseElement":
      return w(w({}, e), {}, {
        unstable_includesBaseElement: Qe(t.includesBaseElement, c)
      });
    case "reset":
      return w(w({}, e), {}, {
        unstable_virtual: v,
        rtl: f,
        orientation: h,
        currentId: it(w(w({}, e), {}, {
          currentId: y
        })),
        loop: M,
        wrap: g,
        shift: p,
        unstable_moves: 0,
        pastIds: []
      });
    case "setItems":
      return w(w({}, e), {}, {
        items: t.items
      });
    default:
      throw new Error();
  }
}
function he(e) {
  return j(e, []);
}
function ps() {
  var e = re(!1);
  return nt(function() {
    return function() {
      e.current = !0;
    };
  }, []), e;
}
function bs(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.unstable_virtual, n = r === void 0 ? !1 : r, a = t.rtl, o = a === void 0 ? !1 : a, i = t.orientation, s = t.currentId, u = t.loop, d = u === void 0 ? !1 : u, l = t.wrap, m = l === void 0 ? !1 : l, b = t.shift, c = b === void 0 ? !1 : b, v = t.unstable_includesBaseElement, f = ne(t, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), h = La(f), y = Kr(Te, {
    unstable_virtual: n,
    rtl: o,
    orientation: i,
    items: [],
    groups: [],
    currentId: s,
    loop: d,
    wrap: m,
    shift: c,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: v ?? s === null,
    initialVirtual: n,
    initialRTL: o,
    initialOrientation: i,
    initialCurrentId: s,
    initialLoop: d,
    initialWrap: m,
    initialShift: c
  }), M = y[0];
  M.pastIds, M.initialVirtual, M.initialRTL, M.initialOrientation, M.initialCurrentId, M.initialLoop, M.initialWrap, M.initialShift, M.hasSetCurrentId;
  var g = ne(M, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), p = y[1], P = ce(!1), O = P[0], x = P[1], T = ps(), S = j(function(E) {
    return p({
      type: "setItems",
      items: E
    });
  }, []);
  return hs(g.items, S), w(w(w({}, h), g), {}, {
    unstable_hasActiveWidget: O,
    unstable_setHasActiveWidget: x,
    registerItem: he(function(E) {
      T.current || p({
        type: "registerItem",
        item: E
      });
    }),
    unregisterItem: he(function(E) {
      T.current || p({
        type: "unregisterItem",
        id: E
      });
    }),
    registerGroup: he(function(E) {
      T.current || p({
        type: "registerGroup",
        group: E
      });
    }),
    unregisterGroup: he(function(E) {
      T.current || p({
        type: "unregisterGroup",
        id: E
      });
    }),
    move: he(function(E) {
      return p({
        type: "move",
        id: E
      });
    }),
    next: he(function(E) {
      return p({
        type: "next",
        allTheWay: E
      });
    }),
    previous: he(function(E) {
      return p({
        type: "previous",
        allTheWay: E
      });
    }),
    up: he(function(E) {
      return p({
        type: "up",
        allTheWay: E
      });
    }),
    down: he(function(E) {
      return p({
        type: "down",
        allTheWay: E
      });
    }),
    first: he(function() {
      return p({
        type: "first"
      });
    }),
    last: he(function() {
      return p({
        type: "last"
      });
    }),
    sort: he(function() {
      return p({
        type: "sort"
      });
    }),
    unstable_setVirtual: he(function(E) {
      return p({
        type: "setVirtual",
        virtual: E
      });
    }),
    setRTL: he(function(E) {
      return p({
        type: "setRTL",
        rtl: E
      });
    }),
    setOrientation: he(function(E) {
      return p({
        type: "setOrientation",
        orientation: E
      });
    }),
    setCurrentId: he(function(E) {
      return p({
        type: "setCurrentId",
        currentId: E
      });
    }),
    setLoop: he(function(E) {
      return p({
        type: "setLoop",
        loop: E
      });
    }),
    setWrap: he(function(E) {
      return p({
        type: "setWrap",
        wrap: E
      });
    }),
    setShift: he(function(E) {
      return p({
        type: "setShift",
        shift: E
      });
    }),
    unstable_setIncludesBaseElement: he(function(E) {
      return p({
        type: "setIncludesBaseElement",
        includesBaseElement: E
      });
    }),
    reset: he(function() {
      return p({
        type: "reset"
      });
    })
  });
}
var Oe = "top", We = "bottom", Re = "right", De = "left", Qr = "auto", Vt = [Oe, We, Re, De], St = "start", Yt = "end", gs = "clippingParents", Ka = "viewport", Wt = "popper", ys = "reference", $n = /* @__PURE__ */ Vt.reduce(function(e, t) {
  return e.concat([t + "-" + St, t + "-" + Yt]);
}, []), Ua = /* @__PURE__ */ [].concat(Vt, [Qr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + St, t + "-" + Yt]);
}, []), ws = "beforeRead", Ms = "read", Es = "afterRead", Ps = "beforeMain", Ss = "main", Os = "afterMain", Ds = "beforeWrite", _s = "write", Ts = "afterWrite", Cs = [ws, Ms, Es, Ps, Ss, Os, Ds, _s, Ts];
function Be(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function xe(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function lt(e) {
  var t = xe(e).Element;
  return e instanceof t || e instanceof Element;
}
function $e(e) {
  var t = xe(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Gr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = xe(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xs(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, o = t.elements[r];
    !$e(o) || !Be(o) || (Object.assign(o.style, n), Object.keys(a).forEach(function(i) {
      var s = a[i];
      s === !1 ? o.removeAttribute(i) : o.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function ks(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], o = t.attributes[n] || {}, i = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = i.reduce(function(u, d) {
        return u[d] = "", u;
      }, {});
      !$e(a) || !Be(a) || (Object.assign(a.style, s), Object.keys(o).forEach(function(u) {
        a.removeAttribute(u);
      }));
    });
  };
}
const As = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xs,
  effect: ks,
  requires: ["computeStyles"]
};
function Ye(e) {
  return e.split("-")[0];
}
var ut = Math.max, sr = Math.min, Ot = Math.round;
function Ir() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Xa() {
  return !/^((?!chrome|android).)*safari/i.test(Ir());
}
function Dt(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, o = 1;
  t && $e(e) && (a = e.offsetWidth > 0 && Ot(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Ot(n.height) / e.offsetHeight || 1);
  var i = lt(e) ? xe(e) : window, s = i.visualViewport, u = !Xa() && r, d = (n.left + (u && s ? s.offsetLeft : 0)) / a, l = (n.top + (u && s ? s.offsetTop : 0)) / o, m = n.width / a, b = n.height / o;
  return {
    width: m,
    height: b,
    top: l,
    right: d + m,
    bottom: l + b,
    left: d,
    x: d,
    y: l
  };
}
function Jr(e) {
  var t = Dt(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Va(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Gr(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function qe(e) {
  return xe(e).getComputedStyle(e);
}
function $s(e) {
  return ["table", "td", "th"].indexOf(Be(e)) >= 0;
}
function at(e) {
  return ((lt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function mr(e) {
  return Be(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Gr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    at(e)
  );
}
function Wn(e) {
  return !$e(e) || // https://github.com/popperjs/popper-core/issues/837
  qe(e).position === "fixed" ? null : e.offsetParent;
}
function Ws(e) {
  var t = /firefox/i.test(Ir()), r = /Trident/i.test(Ir());
  if (r && $e(e)) {
    var n = qe(e);
    if (n.position === "fixed")
      return null;
  }
  var a = mr(e);
  for (Gr(a) && (a = a.host); $e(a) && ["html", "body"].indexOf(Be(a)) < 0; ) {
    var o = qe(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function qt(e) {
  for (var t = xe(e), r = Wn(e); r && $s(r) && qe(r).position === "static"; )
    r = Wn(r);
  return r && (Be(r) === "html" || Be(r) === "body" && qe(r).position === "static") ? t : r || Ws(e) || t;
}
function Zr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function jt(e, t, r) {
  return ut(e, sr(t, r));
}
function Rs(e, t, r) {
  var n = jt(e, t, r);
  return n > r ? r : n;
}
function qa() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Qa(e) {
  return Object.assign({}, qa(), e);
}
function Ga(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var Is = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, Qa(typeof t != "number" ? t : Ga(t, Vt));
};
function js(e) {
  var t, r = e.state, n = e.name, a = e.options, o = r.elements.arrow, i = r.modifiersData.popperOffsets, s = Ye(r.placement), u = Zr(s), d = [De, Re].indexOf(s) >= 0, l = d ? "height" : "width";
  if (!(!o || !i)) {
    var m = Is(a.padding, r), b = Jr(o), c = u === "y" ? Oe : De, v = u === "y" ? We : Re, f = r.rects.reference[l] + r.rects.reference[u] - i[u] - r.rects.popper[l], h = i[u] - r.rects.reference[u], y = qt(o), M = y ? u === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, g = f / 2 - h / 2, p = m[c], P = M - b[l] - m[v], O = M / 2 - b[l] / 2 + g, x = jt(p, O, P), T = u;
    r.modifiersData[n] = (t = {}, t[T] = x, t.centerOffset = x - O, t);
  }
}
function Ns(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || Va(t.elements.popper, a) && (t.elements.arrow = a));
}
const Fs = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: js,
  effect: Ns,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function _t(e) {
  return e.split("-")[1];
}
var Hs = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ls(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: Ot(r * a) / a || 0,
    y: Ot(n * a) / a || 0
  };
}
function Rn(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, o = e.variation, i = e.offsets, s = e.position, u = e.gpuAcceleration, d = e.adaptive, l = e.roundOffsets, m = e.isFixed, b = i.x, c = b === void 0 ? 0 : b, v = i.y, f = v === void 0 ? 0 : v, h = typeof l == "function" ? l({
    x: c,
    y: f
  }) : {
    x: c,
    y: f
  };
  c = h.x, f = h.y;
  var y = i.hasOwnProperty("x"), M = i.hasOwnProperty("y"), g = De, p = Oe, P = window;
  if (d) {
    var O = qt(r), x = "clientHeight", T = "clientWidth";
    if (O === xe(r) && (O = at(r), qe(O).position !== "static" && s === "absolute" && (x = "scrollHeight", T = "scrollWidth")), O = O, a === Oe || (a === De || a === Re) && o === Yt) {
      p = We;
      var S = m && O === P && P.visualViewport ? P.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[x]
      );
      f -= S - n.height, f *= u ? 1 : -1;
    }
    if (a === De || (a === Oe || a === We) && o === Yt) {
      g = Re;
      var E = m && O === P && P.visualViewport ? P.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[T]
      );
      c -= E - n.width, c *= u ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: s
  }, d && Hs), D = l === !0 ? Ls({
    x: c,
    y: f
  }, xe(r)) : {
    x: c,
    y: f
  };
  if (c = D.x, f = D.y, u) {
    var _;
    return Object.assign({}, A, (_ = {}, _[p] = M ? "0" : "", _[g] = y ? "0" : "", _.transform = (P.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + f + "px)" : "translate3d(" + c + "px, " + f + "px, 0)", _));
  }
  return Object.assign({}, A, (t = {}, t[p] = M ? f + "px" : "", t[g] = y ? c + "px" : "", t.transform = "", t));
}
function zs(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, o = r.adaptive, i = o === void 0 ? !0 : o, s = r.roundOffsets, u = s === void 0 ? !0 : s, d = {
    placement: Ye(t.placement),
    variation: _t(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Rn(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Rn(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Ys = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: zs,
  data: {}
};
var tr = {
  passive: !0
};
function Bs(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, o = a === void 0 ? !0 : a, i = n.resize, s = i === void 0 ? !0 : i, u = xe(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && d.forEach(function(l) {
    l.addEventListener("scroll", r.update, tr);
  }), s && u.addEventListener("resize", r.update, tr), function() {
    o && d.forEach(function(l) {
      l.removeEventListener("scroll", r.update, tr);
    }), s && u.removeEventListener("resize", r.update, tr);
  };
}
const Ks = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Bs,
  data: {}
};
var Us = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ar(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Us[t];
  });
}
var Xs = {
  start: "end",
  end: "start"
};
function In(e) {
  return e.replace(/start|end/g, function(t) {
    return Xs[t];
  });
}
function en(e) {
  var t = xe(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function tn(e) {
  return Dt(at(e)).left + en(e).scrollLeft;
}
function Vs(e, t) {
  var r = xe(e), n = at(e), a = r.visualViewport, o = n.clientWidth, i = n.clientHeight, s = 0, u = 0;
  if (a) {
    o = a.width, i = a.height;
    var d = Xa();
    (d || !d && t === "fixed") && (s = a.offsetLeft, u = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s + tn(e),
    y: u
  };
}
function qs(e) {
  var t, r = at(e), n = en(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, o = ut(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = ut(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + tn(e), u = -n.scrollTop;
  return qe(a || r).direction === "rtl" && (s += ut(r.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: s,
    y: u
  };
}
function rn(e) {
  var t = qe(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function Ja(e) {
  return ["html", "body", "#document"].indexOf(Be(e)) >= 0 ? e.ownerDocument.body : $e(e) && rn(e) ? e : Ja(mr(e));
}
function Nt(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Ja(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), o = xe(n), i = a ? [o].concat(o.visualViewport || [], rn(n) ? n : []) : n, s = t.concat(i);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Nt(mr(i)))
  );
}
function jr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Qs(e, t) {
  var r = Dt(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function jn(e, t, r) {
  return t === Ka ? jr(Vs(e, r)) : lt(t) ? Qs(t, r) : jr(qs(at(e)));
}
function Gs(e) {
  var t = Nt(mr(e)), r = ["absolute", "fixed"].indexOf(qe(e).position) >= 0, n = r && $e(e) ? qt(e) : e;
  return lt(n) ? t.filter(function(a) {
    return lt(a) && Va(a, n) && Be(a) !== "body";
  }) : [];
}
function Js(e, t, r, n) {
  var a = t === "clippingParents" ? Gs(e) : [].concat(t), o = [].concat(a, [r]), i = o[0], s = o.reduce(function(u, d) {
    var l = jn(e, d, n);
    return u.top = ut(l.top, u.top), u.right = sr(l.right, u.right), u.bottom = sr(l.bottom, u.bottom), u.left = ut(l.left, u.left), u;
  }, jn(e, i, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Za(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? Ye(n) : null, o = n ? _t(n) : null, i = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, u;
  switch (a) {
    case Oe:
      u = {
        x: i,
        y: t.y - r.height
      };
      break;
    case We:
      u = {
        x: i,
        y: t.y + t.height
      };
      break;
    case Re:
      u = {
        x: t.x + t.width,
        y: s
      };
      break;
    case De:
      u = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var d = a ? Zr(a) : null;
  if (d != null) {
    var l = d === "y" ? "height" : "width";
    switch (o) {
      case St:
        u[d] = u[d] - (t[l] / 2 - r[l] / 2);
        break;
      case Yt:
        u[d] = u[d] + (t[l] / 2 - r[l] / 2);
        break;
    }
  }
  return u;
}
function Bt(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, o = r.strategy, i = o === void 0 ? e.strategy : o, s = r.boundary, u = s === void 0 ? gs : s, d = r.rootBoundary, l = d === void 0 ? Ka : d, m = r.elementContext, b = m === void 0 ? Wt : m, c = r.altBoundary, v = c === void 0 ? !1 : c, f = r.padding, h = f === void 0 ? 0 : f, y = Qa(typeof h != "number" ? h : Ga(h, Vt)), M = b === Wt ? ys : Wt, g = e.rects.popper, p = e.elements[v ? M : b], P = Js(lt(p) ? p : p.contextElement || at(e.elements.popper), u, l, i), O = Dt(e.elements.reference), x = Za({
    reference: O,
    element: g,
    strategy: "absolute",
    placement: a
  }), T = jr(Object.assign({}, g, x)), S = b === Wt ? T : O, E = {
    top: P.top - S.top + y.top,
    bottom: S.bottom - P.bottom + y.bottom,
    left: P.left - S.left + y.left,
    right: S.right - P.right + y.right
  }, A = e.modifiersData.offset;
  if (b === Wt && A) {
    var D = A[a];
    Object.keys(E).forEach(function(_) {
      var I = [Re, We].indexOf(_) >= 0 ? 1 : -1, C = [Oe, We].indexOf(_) >= 0 ? "y" : "x";
      E[_] += D[C] * I;
    });
  }
  return E;
}
function Zs(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, o = r.rootBoundary, i = r.padding, s = r.flipVariations, u = r.allowedAutoPlacements, d = u === void 0 ? Ua : u, l = _t(n), m = l ? s ? $n : $n.filter(function(v) {
    return _t(v) === l;
  }) : Vt, b = m.filter(function(v) {
    return d.indexOf(v) >= 0;
  });
  b.length === 0 && (b = m);
  var c = b.reduce(function(v, f) {
    return v[f] = Bt(e, {
      placement: f,
      boundary: a,
      rootBoundary: o,
      padding: i
    })[Ye(f)], v;
  }, {});
  return Object.keys(c).sort(function(v, f) {
    return c[v] - c[f];
  });
}
function eu(e) {
  if (Ye(e) === Qr)
    return [];
  var t = ar(e);
  return [In(e), t, In(t)];
}
function tu(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, o = a === void 0 ? !0 : a, i = r.altAxis, s = i === void 0 ? !0 : i, u = r.fallbackPlacements, d = r.padding, l = r.boundary, m = r.rootBoundary, b = r.altBoundary, c = r.flipVariations, v = c === void 0 ? !0 : c, f = r.allowedAutoPlacements, h = t.options.placement, y = Ye(h), M = y === h, g = u || (M || !v ? [ar(h)] : eu(h)), p = [h].concat(g).reduce(function(N, U) {
      return N.concat(Ye(U) === Qr ? Zs(t, {
        placement: U,
        boundary: l,
        rootBoundary: m,
        padding: d,
        flipVariations: v,
        allowedAutoPlacements: f
      }) : U);
    }, []), P = t.rects.reference, O = t.rects.popper, x = /* @__PURE__ */ new Map(), T = !0, S = p[0], E = 0; E < p.length; E++) {
      var A = p[E], D = Ye(A), _ = _t(A) === St, I = [Oe, We].indexOf(D) >= 0, C = I ? "width" : "height", W = Bt(t, {
        placement: A,
        boundary: l,
        rootBoundary: m,
        altBoundary: b,
        padding: d
      }), G = I ? _ ? Re : De : _ ? We : Oe;
      P[C] > O[C] && (G = ar(G));
      var ee = ar(G), te = [];
      if (o && te.push(W[D] <= 0), s && te.push(W[G] <= 0, W[ee] <= 0), te.every(function(N) {
        return N;
      })) {
        S = A, T = !1;
        break;
      }
      x.set(A, te);
    }
    if (T)
      for (var fe = v ? 3 : 1, oe = function(U) {
        var J = p.find(function(ye) {
          var we = x.get(ye);
          if (we)
            return we.slice(0, U).every(function(Pe) {
              return Pe;
            });
        });
        if (J)
          return S = J, "break";
      }, ie = fe; ie > 0; ie--) {
        var pe = oe(ie);
        if (pe === "break")
          break;
      }
    t.placement !== S && (t.modifiersData[n]._skip = !0, t.placement = S, t.reset = !0);
  }
}
const ru = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: tu,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Nn(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Fn(e) {
  return [Oe, Re, We, De].some(function(t) {
    return e[t] >= 0;
  });
}
function nu(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, o = t.modifiersData.preventOverflow, i = Bt(t, {
    elementContext: "reference"
  }), s = Bt(t, {
    altBoundary: !0
  }), u = Nn(i, n), d = Nn(s, a, o), l = Fn(u), m = Fn(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: d,
    isReferenceHidden: l,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": l,
    "data-popper-escaped": m
  });
}
const au = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: nu
};
function ou(e, t, r) {
  var n = Ye(e), a = [De, Oe].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, i = o[0], s = o[1];
  return i = i || 0, s = (s || 0) * a, [De, Re].indexOf(n) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function iu(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, o = a === void 0 ? [0, 0] : a, i = Ua.reduce(function(l, m) {
    return l[m] = ou(m, t.rects, o), l;
  }, {}), s = i[t.placement], u = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += d), t.modifiersData[n] = i;
}
const su = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: iu
};
function uu(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Za({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const du = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: uu,
  data: {}
};
function lu(e) {
  return e === "x" ? "y" : "x";
}
function cu(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, o = a === void 0 ? !0 : a, i = r.altAxis, s = i === void 0 ? !1 : i, u = r.boundary, d = r.rootBoundary, l = r.altBoundary, m = r.padding, b = r.tether, c = b === void 0 ? !0 : b, v = r.tetherOffset, f = v === void 0 ? 0 : v, h = Bt(t, {
    boundary: u,
    rootBoundary: d,
    padding: m,
    altBoundary: l
  }), y = Ye(t.placement), M = _t(t.placement), g = !M, p = Zr(y), P = lu(p), O = t.modifiersData.popperOffsets, x = t.rects.reference, T = t.rects.popper, S = typeof f == "function" ? f(Object.assign({}, t.rects, {
    placement: t.placement
  })) : f, E = typeof S == "number" ? {
    mainAxis: S,
    altAxis: S
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, S), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (O) {
    if (o) {
      var _, I = p === "y" ? Oe : De, C = p === "y" ? We : Re, W = p === "y" ? "height" : "width", G = O[p], ee = G + h[I], te = G - h[C], fe = c ? -T[W] / 2 : 0, oe = M === St ? x[W] : T[W], ie = M === St ? -T[W] : -x[W], pe = t.elements.arrow, N = c && pe ? Jr(pe) : {
        width: 0,
        height: 0
      }, U = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : qa(), J = U[I], ye = U[C], we = jt(0, x[W], N[W]), Pe = g ? x[W] / 2 - fe - we - J - E.mainAxis : oe - we - J - E.mainAxis, k = g ? -x[W] / 2 + fe + we + ye + E.mainAxis : ie + we + ye + E.mainAxis, R = t.elements.arrow && qt(t.elements.arrow), q = R ? p === "y" ? R.clientTop || 0 : R.clientLeft || 0 : 0, B = (_ = A == null ? void 0 : A[p]) != null ? _ : 0, z = G + Pe - B - q, Z = G + k - B, K = jt(c ? sr(ee, z) : ee, G, c ? ut(te, Z) : te);
      O[p] = K, D[p] = K - G;
    }
    if (s) {
      var X, Q = p === "x" ? Oe : De, se = p === "x" ? We : Re, V = O[P], $ = P === "y" ? "height" : "width", le = V + h[Q], Ee = V - h[se], Ie = [Oe, De].indexOf(y) !== -1, Gt = (X = A == null ? void 0 : A[P]) != null ? X : 0, Jt = Ie ? le : V - x[$] - T[$] - Gt + E.altAxis, Zt = Ie ? V + x[$] + T[$] - Gt - E.altAxis : Ee, er = c && Ie ? Rs(Jt, V, Zt) : jt(c ? Jt : le, V, c ? Zt : Ee);
      O[P] = er, D[P] = er - V;
    }
    t.modifiersData[n] = D;
  }
}
const fu = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: cu,
  requiresIfExists: ["offset"]
};
function mu(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function vu(e) {
  return e === xe(e) || !$e(e) ? en(e) : mu(e);
}
function hu(e) {
  var t = e.getBoundingClientRect(), r = Ot(t.width) / e.offsetWidth || 1, n = Ot(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function pu(e, t, r) {
  r === void 0 && (r = !1);
  var n = $e(t), a = $e(t) && hu(t), o = at(t), i = Dt(e, a, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Be(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  rn(o)) && (s = vu(t)), $e(t) ? (u = Dt(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : o && (u.x = tn(o))), {
    x: i.left + s.scrollLeft - u.x,
    y: i.top + s.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function bu(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function a(o) {
    r.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(s) {
      if (!r.has(s)) {
        var u = t.get(s);
        u && a(u);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || a(o);
  }), n;
}
function gu(e) {
  var t = bu(e);
  return Cs.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function yu(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function wu(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Hn = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ln() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Mu(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, o = a === void 0 ? Hn : a;
  return function(s, u, d) {
    d === void 0 && (d = o);
    var l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Hn, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: u
      },
      attributes: {},
      styles: {}
    }, m = [], b = !1, c = {
      state: l,
      setOptions: function(y) {
        var M = typeof y == "function" ? y(l.options) : y;
        f(), l.options = Object.assign({}, o, l.options, M), l.scrollParents = {
          reference: lt(s) ? Nt(s) : s.contextElement ? Nt(s.contextElement) : [],
          popper: Nt(u)
        };
        var g = gu(wu([].concat(n, l.options.modifiers)));
        return l.orderedModifiers = g.filter(function(p) {
          return p.enabled;
        }), v(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var y = l.elements, M = y.reference, g = y.popper;
          if (Ln(M, g)) {
            l.rects = {
              reference: pu(M, qt(g), l.options.strategy === "fixed"),
              popper: Jr(g)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(E) {
              return l.modifiersData[E.name] = Object.assign({}, E.data);
            });
            for (var p = 0; p < l.orderedModifiers.length; p++) {
              if (l.reset === !0) {
                l.reset = !1, p = -1;
                continue;
              }
              var P = l.orderedModifiers[p], O = P.fn, x = P.options, T = x === void 0 ? {} : x, S = P.name;
              typeof O == "function" && (l = O({
                state: l,
                options: T,
                name: S,
                instance: c
              }) || l);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: yu(function() {
        return new Promise(function(h) {
          c.forceUpdate(), h(l);
        });
      }),
      destroy: function() {
        f(), b = !0;
      }
    };
    if (!Ln(s, u))
      return c;
    c.setOptions(d).then(function(h) {
      !b && d.onFirstUpdate && d.onFirstUpdate(h);
    });
    function v() {
      l.orderedModifiers.forEach(function(h) {
        var y = h.name, M = h.options, g = M === void 0 ? {} : M, p = h.effect;
        if (typeof p == "function") {
          var P = p({
            state: l,
            name: y,
            instance: c,
            options: g
          }), O = function() {
          };
          m.push(P || O);
        }
      });
    }
    function f() {
      m.forEach(function(h) {
        return h();
      }), m = [];
    }
    return c;
  };
}
var Eu = [Ks, du, Ys, As, su, ru, fu, Fs, au], Pu = /* @__PURE__ */ Mu({
  defaultModifiers: Eu
});
function Su(e) {
  var t = re(null);
  return nt(function() {
    t.current = e;
  }, [e]), t;
}
function Ou(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.visible, n = r === void 0 ? !1 : r, a = t.animated, o = a === void 0 ? !1 : a, i = ne(t, ["visible", "animated"]), s = La(i), u = ce(n), d = u[0], l = u[1], m = ce(o), b = m[0], c = m[1], v = ce(!1), f = v[0], h = v[1], y = Su(d), M = y.current != null && y.current !== d;
  b && !f && M && h(!0), ue(function() {
    if (typeof b == "number" && f) {
      var x = setTimeout(function() {
        return h(!1);
      }, b);
      return function() {
        clearTimeout(x);
      };
    }
    if (b && f && process.env.NODE_ENV === "development") {
      var T = setTimeout(function() {
        process.env.NODE_ENV !== "production" && _e(f, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?");
      }, 8e3);
      return function() {
        clearTimeout(T);
      };
    }
    return function() {
    };
  }, [b, f]);
  var g = j(function() {
    return l(!0);
  }, []), p = j(function() {
    return l(!1);
  }, []), P = j(function() {
    return l(function(x) {
      return !x;
    });
  }, []), O = j(function() {
    return h(!1);
  }, []);
  return w(w({}, s), {}, {
    visible: d,
    animated: b,
    animating: f,
    show: g,
    hide: p,
    toggle: P,
    setVisible: l,
    setAnimated: c,
    stopAnimation: O
  });
}
function Du(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.modal, n = r === void 0 ? !0 : r, a = ne(t, ["modal"]), o = Ou(a), i = ce(n), s = i[0], u = i[1], d = re(null);
  return w(w({}, o), {}, {
    modal: s,
    setModal: u,
    unstable_disclosureRef: d
  });
}
var _u = st("Mac") && !st("Chrome") && st("Safari");
function zn(e) {
  return function(t) {
    return e && !Lt(t, e) ? e : t;
  };
}
function Tu(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.gutter, n = r === void 0 ? 12 : r, a = t.placement, o = a === void 0 ? "bottom" : a, i = t.unstable_flip, s = i === void 0 ? !0 : i, u = t.unstable_offset, d = t.unstable_preventOverflow, l = d === void 0 ? !0 : d, m = t.unstable_fixed, b = m === void 0 ? !1 : m, c = t.modal, v = c === void 0 ? !1 : c, f = ne(t, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), h = re(null), y = re(null), M = re(null), g = re(null), p = ce(o), P = p[0], O = p[1], x = ce(o), T = x[0], S = x[1], E = ce(u || [0, n]), A = E[0], D = ce({
    position: "fixed",
    left: "100%",
    top: "100%"
  }), _ = D[0], I = D[1], C = ce({}), W = C[0], G = C[1], ee = Du(w({
    modal: v
  }, f)), te = j(function() {
    return h.current ? (h.current.forceUpdate(), !0) : !1;
  }, []), fe = j(function(oe) {
    oe.placement && S(oe.placement), oe.styles && (I(zn(oe.styles.popper)), g.current && G(zn(oe.styles.arrow)));
  }, []);
  return nt(function() {
    return y.current && M.current && (h.current = Pu(y.current, M.current, {
      // https://popper.js.org/docs/v2/constructors/#options
      placement: P,
      strategy: b ? "fixed" : "absolute",
      // Safari needs styles to be applied in the first render, otherwise
      // hovering over the popover when it gets visible for the first time
      // will change its dimensions unexpectedly.
      onFirstUpdate: _u ? fe : void 0,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/event-listeners/
        name: "eventListeners",
        enabled: ee.visible
      }, {
        // https://popper.js.org/docs/v2/modifiers/apply-styles/
        name: "applyStyles",
        enabled: !1
      }, {
        // https://popper.js.org/docs/v2/modifiers/flip/
        name: "flip",
        enabled: s,
        options: {
          padding: 8
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/offset/
        name: "offset",
        options: {
          offset: A
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
        name: "preventOverflow",
        enabled: l,
        options: {
          tetherOffset: function() {
            var ie;
            return ((ie = g.current) === null || ie === void 0 ? void 0 : ie.clientWidth) || 0;
          }
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: "arrow",
        enabled: !!g.current,
        options: {
          element: g.current
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
        name: "updateState",
        phase: "write",
        requires: ["computeStyles"],
        enabled: ee.visible && process.env.NODE_ENV !== "test",
        fn: function(ie) {
          var pe = ie.state;
          return fe(pe);
        }
      }]
    })), function() {
      h.current && (h.current.destroy(), h.current = null);
    };
  }, [P, b, ee.visible, s, A, l]), ue(function() {
    if (ee.visible) {
      var oe = window.requestAnimationFrame(function() {
        var ie;
        (ie = h.current) === null || ie === void 0 || ie.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(oe);
      };
    }
  }, [ee.visible]), w(w({}, ee), {}, {
    unstable_referenceRef: y,
    unstable_popoverRef: M,
    unstable_arrowRef: g,
    unstable_popoverStyles: _,
    unstable_arrowStyles: W,
    unstable_update: te,
    unstable_originalPlacement: P,
    placement: T,
    place: O
  });
}
var Cu = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], eo = Cu, xu = eo, to = ge({
  name: "DisclosureContent",
  compose: Xt,
  keys: xu,
  useProps: function(t, r) {
    var n = r.onTransitionEnd, a = r.onAnimationEnd, o = r.style, i = ne(r, ["onTransitionEnd", "onAnimationEnd", "style"]), s = t.animated && t.animating, u = ce(null), d = u[0], l = u[1], m = !t.visible && !s, b = m ? w({
      display: "none"
    }, o) : o, c = ae(n), v = ae(a), f = re(0);
    ue(function() {
      if (t.animated)
        return f.current = window.requestAnimationFrame(function() {
          f.current = window.requestAnimationFrame(function() {
            t.visible ? l("enter") : l(s ? "leave" : null);
          });
        }), function() {
          return window.cancelAnimationFrame(f.current);
        };
    }, [t.animated, t.visible, s]);
    var h = j(function(g) {
      if (je(g) && s && t.animated === !0) {
        var p;
        (p = t.stopAnimation) === null || p === void 0 || p.call(t);
      }
    }, [t.animated, s, t.stopAnimation]), y = j(function(g) {
      var p;
      (p = c.current) === null || p === void 0 || p.call(c, g), h(g);
    }, [h]), M = j(function(g) {
      var p;
      (p = v.current) === null || p === void 0 || p.call(v, g), h(g);
    }, [h]);
    return w({
      id: t.baseId,
      "data-enter": d === "enter" ? "" : void 0,
      "data-leave": d === "leave" ? "" : void 0,
      onTransitionEnd: y,
      onAnimationEnd: M,
      hidden: m,
      style: b
    }, i);
  }
});
be({
  as: "div",
  useHook: to
});
function ro() {
  return kt ? document.body : null;
}
var Yn = /* @__PURE__ */ rt(ro());
function Tt(e) {
  var t = e.children, r = Ce(Yn) || ro(), n = ce(function() {
    if (kt) {
      var o = document.createElement("div");
      return o.className = Tt.__className, o;
    }
    return null;
  }), a = n[0];
  return nt(function() {
    if (!(!a || !r))
      return r.appendChild(a), function() {
        r.removeChild(a);
      };
  }, [a, r]), a ? /* @__PURE__ */ ui(/* @__PURE__ */ Fe(Yn.Provider, {
    value: a
  }, t), a) : null;
}
Tt.__className = "__reakit-portal";
Tt.__selector = "." + Tt.__className;
function Nr(e, t) {
  var r = e.indexOf(t);
  return Fi(e, r);
}
var tt = /* @__PURE__ */ rt(null);
function ku(e, t, r) {
  var n = "unstable_orphan" in r && r.unstable_orphan, a = Ce(tt), o = ce([]), i = o[0], s = o[1], u = a || {}, d = u.addChild, l = u.removeChild, m = j(function(f) {
    return s(function(h) {
      return [].concat(h, [f]);
    });
  }, []), b = j(function(f) {
    return s(function(h) {
      return Nr(h, f);
    });
  }, []);
  ue(function() {
    if (!(!d || n))
      return d(e), function() {
        l == null || l(e);
      };
  }, [e, d, l, n]);
  var c = Ne(function() {
    return {
      orientation: r.orientation,
      next: r.next,
      previous: r.previous,
      ref: e,
      role: t,
      parent: a,
      children: i,
      addChild: m,
      removeChild: b
    };
  }, [r.orientation, r.next, r.previous, e, t, a, i, m, b]), v = j(function(f) {
    return /* @__PURE__ */ Fe(tt.Provider, {
      value: c
    }, f);
  }, [c]);
  return v;
}
function Au(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var nn = !1;
if (typeof window < "u") {
  var Bn = {
    get passive() {
      nn = !0;
    }
  };
  window.addEventListener("testPassive", null, Bn), window.removeEventListener("testPassive", null, Bn);
}
var no = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), et = [], ur = !1, ao = -1, Ft = void 0, Ht = void 0, oo = function(t) {
  return et.some(function(r) {
    return !!(r.options.allowTouchMove && r.options.allowTouchMove(t));
  });
}, dr = function(t) {
  var r = t || window.event;
  return oo(r.target) || r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}, $u = function(t) {
  if (Ht === void 0) {
    var r = !!t && t.reserveScrollBarGap === !0, n = window.innerWidth - document.documentElement.clientWidth;
    r && n > 0 && (Ht = document.body.style.paddingRight, document.body.style.paddingRight = n + "px");
  }
  Ft === void 0 && (Ft = document.body.style.overflow, document.body.style.overflow = "hidden");
}, Wu = function() {
  Ht !== void 0 && (document.body.style.paddingRight = Ht, Ht = void 0), Ft !== void 0 && (document.body.style.overflow = Ft, Ft = void 0);
}, Ru = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, Iu = function(t, r) {
  var n = t.targetTouches[0].clientY - ao;
  return oo(t.target) ? !1 : r && r.scrollTop === 0 && n > 0 || Ru(r) && n < 0 ? dr(t) : (t.stopPropagation(), !0);
}, ju = function(t, r) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!et.some(function(a) {
    return a.targetElement === t;
  })) {
    var n = {
      targetElement: t,
      options: r || {}
    };
    et = [].concat(Au(et), [n]), no ? (t.ontouchstart = function(a) {
      a.targetTouches.length === 1 && (ao = a.targetTouches[0].clientY);
    }, t.ontouchmove = function(a) {
      a.targetTouches.length === 1 && Iu(a, t);
    }, ur || (document.addEventListener("touchmove", dr, nn ? { passive: !1 } : void 0), ur = !0)) : $u(r);
  }
}, Nu = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  et = et.filter(function(r) {
    return r.targetElement !== t;
  }), no ? (t.ontouchstart = null, t.ontouchmove = null, ur && et.length === 0 && (document.removeEventListener("touchmove", dr, nn ? { passive: !1 } : void 0), ur = !1)) : et.length || Wu();
}, Fu = /* @__PURE__ */ rt(void 0);
function Hu(e) {
  return Array.isArray(e) ? !e.length : Xr(e) ? !Object.keys(e).length : e == null || e === "";
}
var io = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], Lu = [].concat(io, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), zu = io, Yu = zu;
function Bu(e, t) {
  var r = re(null), n = !!(t.animated && t.animating);
  return ue(function() {
    if (!(t.visible || n)) {
      var a = function(s) {
        var u = s.target;
        "focus" in u && (r.current = u, t.unstable_disclosureRef && (t.unstable_disclosureRef.current = u));
      }, o = Me(e.current);
      return o.addEventListener("focusin", a), function() {
        return o.removeEventListener("focusin", a);
      };
    }
  }, [t.visible, n, t.unstable_disclosureRef, e]), ue(function() {
    var a;
    if (!(!t.visible || n)) {
      var o = function(u) {
        var d = u.currentTarget;
        fr(d) && (u.preventDefault(), d.focus());
      }, i = ((a = t.unstable_disclosureRef) === null || a === void 0 ? void 0 : a.current) || r.current;
      return i == null || i.addEventListener("mousedown", o), function() {
        return i == null ? void 0 : i.removeEventListener("mousedown", o);
      };
    }
  }, [t.visible, n, t.unstable_disclosureRef]), t.unstable_disclosureRef || r;
}
function Ku(e, t) {
  var r = !!(t.preventBodyScroll && t.visible);
  ue(function() {
    var n = e.current;
    if (!(!n || !r))
      return ju(n, {
        reserveScrollBarGap: !0
      }), function() {
        return Nu(n);
      };
  }, [e, r]);
}
function Uu(e, t, r) {
  var n = r.unstable_initialFocusRef, a = r.visible && r.unstable_autoFocusOnShow, o = !!(r.animated && r.animating);
  $a(function() {
    var i = e.current;
    if (process.env.NODE_ENV !== "production" && _e(!!a && !i, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog"), !!a && i && !o && !t.some(function(d) {
      return d.current && !d.current.hidden;
    }))
      if (n != null && n.current)
        n.current.focus({
          preventScroll: !0
        });
      else {
        var s = xa(i, !0), u = function() {
          return Ut(i);
        };
        s ? zt(s, {
          preventScroll: !0,
          isActive: u
        }) : (zt(i, {
          preventScroll: !0,
          isActive: u
        }), process.env.NODE_ENV !== "production" && _e(i.tabIndex === void 0 || i.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", i));
      }
  }, [e, a, o, t, n]);
}
function Xu(e, t) {
  var r = re(null);
  return ue(function() {
    var n = e.current;
    !n || !t.visible || (r.current = Da(n, Tt.__selector));
  }, [e, t.visible]), r;
}
function Kn(e) {
  e.parentNode != null && e.parentNode.removeChild(e);
}
var so = "__reakit-focus-trap";
function Vu(e) {
  var t;
  return (t = e.classList) === null || t === void 0 ? void 0 : t.contains(so);
}
function qu(e, t, r) {
  var n = Xu(e, r), a = r.visible && r.modal, o = re(null), i = re(null);
  ue(function() {
    if (a) {
      var s = n.current;
      if (!s) {
        process.env.NODE_ENV !== "production" && _e(!0, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog");
        return;
      }
      if (!o.current) {
        var u = Me(s);
        o.current = u.createElement("div"), o.current.className = so, o.current.tabIndex = 0, o.current.style.position = "fixed", o.current.setAttribute("aria-hidden", "true");
      }
      return i.current || (i.current = o.current.cloneNode()), s.insertAdjacentElement("beforebegin", o.current), s.insertAdjacentElement("afterend", i.current), function() {
        o.current && Kn(o.current), i.current && Kn(i.current);
      };
    }
  }, [n, a]), ue(function() {
    var s = o.current, u = i.current;
    if (!(!a || !s || !u)) {
      var d = function(m) {
        var b = e.current;
        if (!(!b || t.length)) {
          m.preventDefault();
          var c = m.target === u, v = c ? xa(b) : Ci(b);
          v ? v.focus() : b.focus();
        }
      };
      return s.addEventListener("focus", d), u.addEventListener("focus", d), function() {
        s.removeEventListener("focus", d), u.removeEventListener("focus", d);
      };
    }
  }, [e, t, a]);
}
function Qu(e) {
  var t = e.current;
  if (!t)
    return !1;
  var r = At(t);
  return !r || He(t, r) ? !1 : !!(Ar(r) || r.getAttribute("data-dialog") === "true");
}
function Gu(e, t, r) {
  var n = r.unstable_autoFocusOnHide && !r.visible, a = !!(r.animated && r.animating);
  $a(function() {
    var o;
    if (n && !a && !Qu(e)) {
      var i = ((o = r.unstable_finalFocusRef) === null || o === void 0 ? void 0 : o.current) || t.current;
      if (i) {
        if (i.id) {
          var s = Me(i), u = s.querySelector("[aria-activedescendant='" + i.id + "']");
          if (u) {
            zt(u);
            return;
          }
        }
        zt(i);
        return;
      }
      process.env.NODE_ENV !== "production" && _e(!0, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", e.current);
    }
  }, [n, a, e, t]);
}
var Un = /* @__PURE__ */ rt({});
function Ju(e, t) {
  var r = Ce(Un), n = ce([]), a = n[0], o = n[1], i = ce(a), s = i[0], u = i[1], d = j(function(f) {
    var h;
    (h = r.addDialog) === null || h === void 0 || h.call(r, f), o(function(y) {
      return [].concat(y, [f]);
    });
  }, [r.addDialog]), l = j(function(f) {
    var h;
    (h = r.removeDialog) === null || h === void 0 || h.call(r, f), o(function(y) {
      return Nr(y, f);
    });
  }, [r.removeDialog]), m = j(function(f) {
    var h;
    (h = r.showDialog) === null || h === void 0 || h.call(r, f), u(function(y) {
      return [].concat(y, [f]);
    });
  }, [r.showDialog]), b = j(function(f) {
    var h;
    (h = r.hideDialog) === null || h === void 0 || h.call(r, f), u(function(y) {
      return Nr(y, f);
    });
  }, [r.hideDialog]);
  ue(function() {
    var f;
    if (!t.unstable_orphan)
      return (f = r.addDialog) === null || f === void 0 || f.call(r, e), function() {
        var h;
        (h = r.removeDialog) === null || h === void 0 || h.call(r, e);
      };
  }, [t.unstable_orphan, r.addDialog, e, r.removeDialog]), ue(function() {
    var f;
    if (!t.unstable_orphan && t.modal && t.visible)
      return (f = r.showDialog) === null || f === void 0 || f.call(r, e), function() {
        var h;
        (h = r.hideDialog) === null || h === void 0 || h.call(r, e);
      };
  }, [t.unstable_orphan, t.modal, t.visible, r.showDialog, e, r.hideDialog]), ue(function() {
    if (r.visible === !1 && t.visible && !t.unstable_orphan) {
      var f;
      (f = t.hide) === null || f === void 0 || f.call(t);
    }
  }, [r.visible, t.visible, t.hide, t.unstable_orphan]);
  var c = Ne(function() {
    return {
      visible: t.visible,
      addDialog: d,
      removeDialog: l,
      showDialog: m,
      hideDialog: b
    };
  }, [t.visible, d, l, m, b]), v = j(function(f) {
    return /* @__PURE__ */ Fe(Un.Provider, {
      value: c
    }, f);
  }, [c]);
  return {
    dialogs: a,
    visibleModals: s,
    wrap: v
  };
}
function Zu(e) {
  return function(t) {
    var r = t.current;
    if (!r)
      return !1;
    if (He(r, e))
      return !0;
    var n = Me(r), a = n.querySelector('[data-dialog-ref="' + r.id + '"]');
    return a ? He(a, e) : !1;
  };
}
function ed(e, t) {
  return He(t, e);
}
function td(e) {
  var t = Me(e);
  return e.tagName === "HTML" ? !0 : He(t.body, e);
}
function Fr(e, t, r, n, a, o, i) {
  var s = ae(a);
  ue(function() {
    if (o) {
      var u = function(m) {
        if (s.current) {
          var b = e.current, c = t.current, v = m.target;
          if (!b) {
            process.env.NODE_ENV !== "production" && _e(!0, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog");
            return;
          }
          td(v) && (He(b, v) || c && ed(v, c) || Vu(v) || r.some(Zu(v)) || s.current(m));
        }
      }, d = Me(e.current);
      return d.addEventListener(n, u, i), function() {
        return d.removeEventListener(n, u, i);
      };
    }
  }, [e, t, r, n, o, s]);
}
function rd(e, t) {
  var r = re();
  return ue(function() {
    if (t.visible && t.hideOnClickOutside) {
      var n = Me(e.current), a = function(i) {
        r.current = i.target;
      };
      return n.addEventListener("mousedown", a), function() {
        return n.removeEventListener("mousedown", a);
      };
    }
  }, [t.visible, t.hideOnClickOutside, e]), r;
}
function nd(e, t, r, n) {
  var a = rd(e, n);
  Fr(e, t, r, "click", function(o) {
    if (a.current === o.target) {
      var i;
      (i = n.hide) === null || i === void 0 || i.call(n);
    }
  }, n.visible && n.hideOnClickOutside), Fr(e, t, r, "focusin", function(o) {
    var i = Me(e.current);
    if (o.target !== i && o.target !== i.body) {
      var s;
      (s = n.hide) === null || s === void 0 || s.call(n);
    }
  }, n.visible && n.hideOnClickOutside);
}
function ad(e, t, r) {
  var n = function(o) {
    return Fr(e, {
      current: null
    }, t, o, function(i) {
      i.stopPropagation(), i.preventDefault();
    }, r.visible && r.modal, !0);
  };
  n("mouseover"), n("mousemove"), n("mouseout");
}
function od(e, t) {
  ue(function() {
    var r = e.current;
    if (!(!t.visible || !r)) {
      var n = new MutationObserver(function(a) {
        var o = a[0].target;
        if (o === r) {
          var i = Me(r), s = At(r);
          (s === i.body || Hu(s)) && r.focus();
        }
      });
      return n.observe(r, {
        childList: !0,
        subtree: !0
      }), function() {
        n.disconnect();
      };
    }
  }, [t.visible, e]);
}
function Xn(e) {
  return e && e.tagName && e.tagName !== "HTML" && e !== Me(e).body;
}
function id(e, t) {
  var r = Kr(function(i) {
    return i + 1;
  }, 0), n = r[0], a = r[1];
  nt(function() {
    var i = e.current;
    t.visible && n && (Xn(At(i)) || (process.env.NODE_ENV !== "production" && _e(!i, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), i == null || i.focus()));
  }, [n, e]);
  var o = j(function(i) {
    if (t.visible) {
      var s = Wa(i);
      Xn(s) || a();
    }
  }, [t.visible]);
  return o;
}
var uo = ge({
  name: "Dialog",
  compose: to,
  keys: Lu,
  useOptions: function(t) {
    var r = t.modal, n = r === void 0 ? !0 : r, a = t.hideOnEsc, o = a === void 0 ? !0 : a, i = t.hideOnClickOutside, s = i === void 0 ? !0 : i, u = t.preventBodyScroll, d = u === void 0 ? n : u, l = t.unstable_autoFocusOnShow, m = l === void 0 ? !0 : l, b = t.unstable_autoFocusOnHide, c = b === void 0 ? !0 : b, v = t.unstable_orphan, f = ne(t, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
    return w({
      modal: n,
      hideOnEsc: o,
      hideOnClickOutside: s,
      preventBodyScroll: n && d,
      unstable_autoFocusOnShow: m,
      unstable_autoFocusOnHide: c,
      unstable_orphan: n && v
    }, f);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onKeyDown, o = r.onBlur, i = r.wrapElement, s = r.tabIndex, u = ne(r, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), d = re(null), l = Ce(Fu), m = l && l === t.baseId, b = Bu(d, t), c = ae(a), v = ae(o), f = id(d, t), h = Ju(d, t), y = h.dialogs, M = h.visibleModals, g = h.wrap, p = t.modal && !M.length ? !0 : void 0;
    Ku(d, t), qu(d, M, t), od(d, t), Uu(d, y, t), Gu(d, b, t), nd(d, b, y, t), ad(d, y, t);
    var P = j(function(T) {
      var S;
      if ((S = c.current) === null || S === void 0 || S.call(c, T), !T.defaultPrevented && T.key === "Escape" && t.hideOnEsc) {
        if (!t.hide) {
          process.env.NODE_ENV !== "production" && _e(!0, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", d.current);
          return;
        }
        T.stopPropagation(), t.hide();
      }
    }, [t.hideOnEsc, t.hide]), O = j(function(T) {
      var S;
      (S = v.current) === null || S === void 0 || S.call(v, T), f(T);
    }, [f]), x = j(function(T) {
      return T = g(T), t.modal && !m && (T = /* @__PURE__ */ Fe(Tt, null, T)), i && (T = i(T)), // Prevents Menu > Dialog > Menu to behave as a sub menu
      /* @__PURE__ */ Fe(tt.Provider, {
        value: null
      }, T);
    }, [g, t.modal, m, i]);
    return w({
      ref: Ke(d, n),
      role: "dialog",
      tabIndex: s ?? -1,
      "aria-modal": p,
      "data-dialog": !0,
      onKeyDown: P,
      onBlur: O,
      wrapElement: x
    }, u);
  }
});
be({
  as: "div",
  useHook: uo,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Kt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog"), xt(t, r, n);
  }
});
var sd = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], lo = sd, ud = lo, dd = ud, co = ge({
  name: "Popover",
  compose: uo,
  keys: lo,
  useOptions: function(t) {
    var r = t.modal, n = r === void 0 ? !1 : r, a = ne(t, ["modal"]);
    return w({
      modal: n
    }, a);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.style, o = ne(r, ["ref", "style"]);
    return w({
      ref: Ke(t.unstable_popoverRef, n),
      style: w(w({}, t.unstable_popoverStyles), a)
    }, o);
  }
});
be({
  as: "div",
  useHook: co,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Kt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover"), xt(t, r, n);
  }
});
var fo = ge({
  name: "Disclosure",
  compose: ka,
  keys: eo,
  useProps: function(t, r) {
    var n = r.onClick, a = r["aria-controls"], o = ne(r, ["onClick", "aria-controls"]), i = ae(n), s = a ? a + " " + t.baseId : t.baseId, u = j(function(d) {
      var l, m;
      (l = i.current) === null || l === void 0 || l.call(i, d), !d.defaultPrevented && ((m = t.toggle) === null || m === void 0 || m.call(t));
    }, [t.toggle]);
    return w({
      "aria-expanded": !!t.visible,
      "aria-controls": s,
      onClick: u
    }, o);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: fo
});
var mo = ge({
  name: "DialogDisclosure",
  compose: fo,
  keys: Yu,
  useProps: function(t, r) {
    var n = r.ref, a = r.onClick, o = ne(r, ["ref", "onClick"]), i = re(null), s = ae(a), u = ce(!1), d = u[0], l = u[1], m = t.unstable_disclosureRef;
    nt(function() {
      var c = i.current;
      process.env.NODE_ENV !== "production" && _e(!c, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), m && !m.current && (m.current = c);
      var v = !(m != null && m.current) || m.current === c;
      l(!!t.visible && v);
    }, [t.visible, m]);
    var b = j(function(c) {
      var v;
      (v = s.current) === null || v === void 0 || v.call(s, c), !c.defaultPrevented && m && (m.current = c.currentTarget);
    }, [m]);
    return w({
      ref: Ke(i, n),
      "aria-haspopup": "dialog",
      "aria-expanded": d,
      onClick: b
    }, o);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: mo
});
var ld = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], cd = [].concat(ld, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), vo = cd, fd = vo, ho = fd, po = ho, md = po, vd = md, bo = vd, hd = bo;
function pd(e, t, r) {
  var n = t.items, a = n === void 0 ? [] : n, o = t.move;
  r === void 0 && (r = 500);
  var i = ce(""), s = i[0], u = i[1];
  ue(function() {
    if (s) {
      var d = setTimeout(function() {
        return u("");
      }, r), l = a.find(function(m) {
        return !!(m.ref.current && m.ref.current.textContent && m.ref.current.textContent.toLowerCase().startsWith(s));
      });
      return l && o(l.id), function() {
        return clearTimeout(d);
      };
    }
  }, [s, a, o, r]), ue(function() {
    var d = e.current;
    if (d) {
      var l = function(b) {
        var c;
        if (!(b.key.length > 1) && !b.shiftKey && !b.metaKey && !b.ctrlKey && !b.altKey) {
          var v = b.target, f = (c = v.getAttribute) === null || c === void 0 ? void 0 : c.call(v, "role"), h = v === d, y = f && f.indexOf("menuitem") !== -1 && Da(v, "[role=menu],[role=menubar]") === d;
          !h && !y || /^[a-z0-9_-]$/i.test(b.key) && (b.stopPropagation(), b.preventDefault(), u(function(M) {
            return "" + M + b.key;
          }));
        }
      };
      return d.addEventListener("keydown", l), function() {
        return d.removeEventListener("keydown", l);
      };
    }
  }, [e, u]);
}
var go = ge({
  name: "MenuBar",
  compose: Na,
  keys: ho,
  useProps: function(t, r) {
    var n = r.ref, a = r.wrapElement, o = r.role, i = o === void 0 ? "menubar" : o, s = ne(r, ["ref", "wrapElement", "role"]), u = re(null), d = ku(u, i, t);
    pd(u, t);
    var l = j(function(m) {
      return m = d(m), a ? a(m) : m;
    }, [d, a]);
    return w({
      ref: Ke(u, n),
      role: i,
      "aria-orientation": t.orientation,
      wrapElement: l
    }, s);
  }
});
be({
  as: "div",
  useHook: go,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Kt(!r["aria-label"] && !r["aria-labelledby"] && r.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), xt(t, r, n);
  }
});
function bd(e) {
  return Ne(function() {
    var t;
    return e == null || (t = e.split("-")) === null || t === void 0 ? void 0 : t[0];
  }, [e]);
}
var gd = ge({
  name: "Menu",
  compose: [go, co],
  keys: vo,
  useOptions: function(t) {
    var r = Ce(tt), n = (r == null ? void 0 : r.role) === "menubar";
    return w(w({
      unstable_autoFocusOnHide: !n,
      modal: !1
    }, t), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: !1,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: !1
    });
  },
  useProps: function(t, r) {
    for (var n = r.onKeyDown, a = ne(r, ["onKeyDown"]), o = ae(n), i = Ce(tt), s = !!i, u = i; u && u.role !== "menubar"; )
      u = u.parent;
    var d = u || {}, l = d.next, m = d.previous, b = d.orientation, c = b === "horizontal", v = bd(t.placement), f = j(function(h) {
      var y;
      if ((y = o.current) === null || y === void 0 || y.call(o, h), !h.defaultPrevented) {
        if (h.key === "Escape") {
          var M;
          s || h.stopPropagation(), (M = t.hide) === null || M === void 0 || M.call(t);
        } else if (s && !Vr(h)) {
          var g = c && v !== "left" ? l : v === "left" && t.hide, p = c && v !== "right" ? m : v === "right" && t.hide, P = {
            ArrowRight: g,
            ArrowLeft: p
          }, O = P[h.key];
          O && (h.preventDefault(), s && h.stopPropagation(), O());
        }
      }
    }, [s, c, l, m, v, t.hide]);
    return w({
      role: "menu",
      onKeyDown: f
    }, a);
  }
}), yd = be({
  as: "div",
  useHook: gd,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Kt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), xt(t, r, n);
  }
});
function wd(e) {
  e === void 0 && (e = {});
  var t = ht(e), r = t.orientation, n = r === void 0 ? "horizontal" : r, a = t.unstable_values, o = a === void 0 ? {} : a, i = ne(t, ["orientation", "unstable_values"]), s = ce(o), u = s[0], d = s[1], l = bs(w(w({}, i), {}, {
    orientation: n
  }));
  return w(w({}, l), {}, {
    unstable_values: u,
    unstable_setValue: j(function(m, b) {
      d(function(c) {
        var v;
        return w(w({}, c), {}, (v = {}, v[m] = typeof b == "function" ? b(c) : b, v));
      });
    }, [])
  });
}
var Hr = ge({
  name: "PopoverDisclosure",
  compose: mo,
  keys: dd,
  useProps: function(t, r) {
    var n = r.ref, a = ne(r, ["ref"]);
    return w({
      ref: Ke(t.unstable_referenceRef, n)
    }, a);
  }
});
be({
  as: "button",
  memo: !0,
  useHook: Hr
});
function an(e) {
  var t = e == null ? void 0 : e.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return t == null ? void 0 : t.current;
}
var Md = function() {
}, Ed = ge({
  name: "MenuButton",
  compose: Hr,
  keys: po,
  propsAreEqual: function(t, r) {
    t.unstable_popoverStyles, t.unstable_arrowStyles, t.currentId, t.unstable_moves;
    var n = ne(t, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.currentId, r.unstable_moves;
    var a = ne(r, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    return Hr.unstable_propsAreEqual(n, a);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onClick, o = r.onKeyDown, i = r.onFocus, s = r.onMouseEnter, u = r.onMouseDown, d = ne(r, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), l = Ce(tt), m = re(null), b = re(!1), c = t.placement.split("-"), v = c[0], f = !!l, h = (l == null ? void 0 : l.role) === "menubar", y = t.disabled || d["aria-disabled"], M = ae(a), g = ae(o), p = ae(i), P = ae(s), O = ae(u), x = j(function(D) {
      var _;
      if (D.key === "Escape") {
        var I;
        (I = t.hide) === null || I === void 0 || I.call(t);
      } else if (!y) {
        var C = t.first && function() {
          return setTimeout(t.first);
        }, W = t.last && function() {
          return setTimeout(t.last);
        }, G = {
          Enter: C,
          " ": C,
          ArrowUp: (v === "top" || v === "bottom") && W,
          ArrowRight: v === "right" && C,
          ArrowDown: (v === "bottom" || v === "top") && C,
          ArrowLeft: v === "left" && C
        }, ee = G[D.key];
        if (ee) {
          var te;
          D.preventDefault(), D.stopPropagation(), (te = t.show) === null || te === void 0 || te.call(t), ee();
          return;
        }
      }
      (_ = g.current) === null || _ === void 0 || _.call(g, D);
    }, [y, t.hide, t.first, t.last, v, t.show]), T = j(function(D) {
      var _;
      if ((_ = P.current) === null || _ === void 0 || _.call(P, D), !D.defaultPrevented && l) {
        var I = D.currentTarget;
        h ? an(l.children) && I.focus() : setTimeout(function() {
          if (Ut(I)) {
            var C;
            (C = t.show) === null || C === void 0 || C.call(t);
          }
        }, 200);
      }
    }, [l, h, t.show]), S = j(function(D) {
      var _;
      b.current = !0, (_ = O.current) === null || _ === void 0 || _.call(O, D);
    }, []), E = j(function(D) {
      var _;
      if ((_ = p.current) === null || _ === void 0 || _.call(p, D), !D.defaultPrevented && !y && h && !b.current) {
        var I;
        (I = t.show) === null || I === void 0 || I.call(t);
      }
    }, [h, y, t.show]), A = j(function(D) {
      var _;
      if ((_ = M.current) === null || _ === void 0 || _.call(M, D), !D.defaultPrevented) {
        if (f && !h) {
          var I;
          (I = t.show) === null || I === void 0 || I.call(t);
        } else {
          var C;
          if ((C = t.toggle) === null || C === void 0 || C.call(t), b.current && !h && !t.visible) {
            var W;
            (W = t.move) === null || W === void 0 || W.call(t, null);
          }
        }
        b.current = !1;
      }
    }, [f, h, t.show, t.toggle, t.visible, t.move]);
    return w({
      ref: Ke(m, n),
      "aria-haspopup": "menu",
      onKeyDown: x,
      onMouseEnter: T,
      onMouseDown: S,
      onFocus: E,
      onClick: A
    }, d);
  },
  useComposeOptions: function(t) {
    return w(w({}, t), {}, {
      // Toggling is handled by MenuButton
      toggle: Md
    });
  }
}), Pd = be({
  as: "button",
  memo: !0,
  useHook: Ed
});
function rr(e, t, r) {
  return Math.abs((e.x * (t.y - r.y) + t.x * (r.y - e.y) + r.x * (e.y - t.y)) / 2);
}
function Sd(e, t, r, n) {
  var a = rr(t, r, n), o = rr(e, r, n), i = rr(t, e, n), s = rr(t, r, e);
  return a === o + i + s;
}
function Od(e, t) {
  var r = t.getBoundingClientRect(), n = r.top, a = r.right, o = r.bottom, i = r.left, s = i > e.clientX ? i : a;
  return [{
    x: s,
    y: n
  }, {
    x: s,
    y: o
  }];
}
function Dd(e, t) {
  var r = ae(t), n = re(null), a = re(null), o = re(null), i = re(0), s = re(0), u = j(function(m) {
    if (e != null && e.children.length) {
      a.current = null, o.current = null;
      var b = an(e.children);
      if (b) {
        var c = Od(m, b);
        a.current = c[0], o.current = c[1];
      }
    }
  }, [e == null ? void 0 : e.children]), d = j(function(m) {
    var b = i.current !== m.clientX || s.current !== m.clientY;
    if (m.isTrusted && !b)
      return !0;
    var c = Math.abs(i.current - m.clientX);
    i.current = m.clientX, s.current = m.clientY;
    var v = function() {
      return a.current && o.current;
    };
    return m.type === "mouseleave" && !v() && u(m), v() ? c && n.current && Sd({
      x: m.clientX,
      y: m.clientY
    }, n.current, a.current, o.current) : !1;
  }, [u]), l = j(function(m) {
    var b;
    (b = r.current) === null || b === void 0 || b.call(r, m), !m.defaultPrevented && (e == null ? void 0 : e.role) !== "menubar" && (n.current = {
      x: m.clientX,
      y: m.clientY
    }, u(m));
  }, [e == null ? void 0 : e.role, u]);
  return {
    onMouseEnter: l,
    isMouseInTransitToSubmenu: d
  };
}
function on(e) {
  var t = e.relatedTarget;
  return (t == null ? void 0 : t.nodeType) === Node.ELEMENT_NODE ? e.relatedTarget : e.toElement || null;
}
function _d(e) {
  var t = on(e);
  return t ? He(e.currentTarget, t) : !1;
}
function Td(e, t) {
  if (!(t != null && t.length))
    return !1;
  var r = on(e);
  if (!r)
    return !1;
  var n = an(t);
  return n && He(n, r);
}
function Cd(e, t) {
  var r = on(e);
  return r ? t == null ? void 0 : t.some(function(n) {
    return n.ref.current && He(n.ref.current, r);
  }) : !1;
}
var xd = ge({
  name: "MenuItem",
  compose: Wr,
  keys: bo,
  propsAreEqual: function(t, r) {
    t.unstable_popoverStyles, t.unstable_arrowStyles, t.visible;
    var n = ne(t, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.visible;
    var a = ne(r, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    return Wr.unstable_propsAreEqual(n, a);
  },
  useProps: function(t, r) {
    var n = r.onMouseEnter, a = r.onMouseMove, o = r.onMouseLeave, i = ne(r, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), s = Ce(tt), u = ae(a), d = ae(o), l = Dd(s, n), m = l.onMouseEnter, b = l.isMouseInTransitToSubmenu, c = j(function(f) {
      var h, y;
      (h = u.current) === null || h === void 0 || h.call(u, f), !f.defaultPrevented && (s == null ? void 0 : s.role) !== "menubar" && (b(f) || Ut(f.currentTarget) || (y = t.move) === null || y === void 0 || y.call(t, f.currentTarget.id));
    }, [t.move]), v = j(function(f) {
      var h;
      if ((h = d.current) === null || h === void 0 || h.call(d, f), !f.defaultPrevented && (s == null ? void 0 : s.role) !== "menubar" && !_d(f) && !Td(f, s == null ? void 0 : s.children) && !Cd(f, t.items)) {
        var y;
        if (b(f))
          return;
        (y = t.move) === null || y === void 0 || y.call(t, null);
      }
    }, [s == null ? void 0 : s.role, s == null ? void 0 : s.children, t.items, t.move]);
    return w({
      role: "menuitem",
      onMouseEnter: m,
      onMouseMove: c,
      onMouseLeave: v
    }, i);
  }
}), kd = be({
  as: "button",
  memo: !0,
  useHook: xd
}), Ad = ["orientation"], yo = ge({
  name: "Separator",
  compose: Xt,
  keys: Ad,
  useOptions: function(t) {
    var r = t.orientation, n = r === void 0 ? "horizontal" : r, a = ne(t, ["orientation"]);
    return w({
      orientation: n
    }, a);
  },
  useProps: function(t, r) {
    return w({
      role: "separator",
      "aria-orientation": t.orientation
    }, r);
  }
});
be({
  as: "hr",
  memo: !0,
  useHook: yo
});
var $d = ge({
  name: "MenuSeparator",
  compose: yo,
  keys: hd,
  useOptions: function(t) {
    var r = t.orientation, n = r === void 0 ? "vertical" : r, a = ne(t, ["orientation"]);
    return w({
      orientation: n === "vertical" ? "horizontal" : "vertical"
    }, a);
  }
}), Vn = be({
  as: "hr",
  memo: !0,
  useHook: $d
});
function Wd(e) {
  e === void 0 && (e = {});
  var t = Ce(tt), r = ht(e), n = r.orientation, a = n === void 0 ? "vertical" : n, o = r.gutter, i = o === void 0 ? 0 : o, s = ne(r, ["orientation", "gutter"]), u = s.placement || (t && t.orientation === "vertical" ? "right-start" : "bottom-start"), d = wd(w(w({}, s), {}, {
    orientation: a
  })), l = Tu(w(w({}, s), {}, {
    placement: u,
    gutter: i
  }));
  return ue(function() {
    l.visible || d.reset();
  }, [l.visible, d.reset]), w(w({}, d), l);
}
function Rd(e) {
  var t = e.children, r = e.unstable_system;
  return /* @__PURE__ */ Fe(Ur.Provider, {
    value: r
  }, t);
}
var Id = {};
function wo(e) {
  var t = e.unstable_prefix, r = e.unstable_system, n = r === void 0 ? Id : r, a = e.children;
  return /* @__PURE__ */ Fe(es, {
    prefix: t
  }, /* @__PURE__ */ Fe(Rd, {
    unstable_system: n
  }, a));
}
const Mo = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ Y(ii, { i18n: t, children: e }), sn = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return si(t);
}, jd = () => {
  const { t: e } = sn("label");
  return /* @__PURE__ */ Y("div", { "data-testid": "default-loading-fallback", children: e("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
const Nd = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, $t = (e, t, r) => {
  let n;
  const a = Nd[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function L(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const Fd = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Hd = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ld = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zd = {
  date: L({
    formats: Fd,
    defaultWidth: "full"
  }),
  time: L({
    formats: Hd,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Ld,
    defaultWidth: "full"
  })
}, Yd = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, pt = (e, t, r, n) => Yd[e];
function F(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[o];
  };
}
const Bd = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Kd = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ud = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Xd = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Vd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Qd = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, bt = {
  ordinalNumber: Qd,
  era: F({
    values: Bd,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Kd,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Ud,
    defaultWidth: "wide"
  }),
  day: F({
    values: Xd,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Vd,
    defaultWidth: "wide",
    formattingValues: qd,
    defaultFormattingWidth: "wide"
  })
};
function H(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    const i = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(s) ? Jd(s, (m) => m.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Gd(s, (m) => m.test(i))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(d)
    ) : d;
    const l = t.slice(i.length);
    return { value: d, rest: l };
  };
}
function Gd(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function Jd(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Ue(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const s = t.slice(a.length);
    return { value: i, rest: s };
  };
}
const Zd = /^(\d+)(th|st|nd|rd)?/i, el = /\d+/i, tl = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, rl = {
  any: [/^b/i, /^(a|c)/i]
}, nl = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, al = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ol = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, il = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, sl = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ul = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, dl = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ll = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gt = {
  ordinalNumber: Ue({
    matchPattern: Zd,
    parsePattern: el,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: tl,
    defaultMatchWidth: "wide",
    parsePatterns: rl,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: nl,
    defaultMatchWidth: "wide",
    parsePatterns: al,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: ol,
    defaultMatchWidth: "wide",
    parsePatterns: il,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: sl,
    defaultMatchWidth: "wide",
    parsePatterns: ul,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: dl,
    defaultMatchWidth: "any",
    parsePatterns: ll,
    defaultParseWidth: "any"
  })
}, Eo = {
  code: "en-US",
  formatDistance: $t,
  formatLong: zd,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let cl = {};
function Qt() {
  return cl;
}
const Po = 6048e5, fl = 864e5;
function Le(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function qn(e) {
  const t = Le(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Qn(e) {
  const t = Le(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function ml(e, t) {
  const r = qn(e), n = qn(t), a = +r - Qn(r), o = +n - Qn(n);
  return Math.round((a - o) / fl);
}
function ct(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function vl(e) {
  const t = Le(e), r = ct(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function hl(e) {
  const t = Le(e);
  return ml(t, vl(t)) + 1;
}
function ft(e, t) {
  var s, u, d, l;
  const r = Qt(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : u.weekStartsOn) ?? r.weekStartsOn ?? ((l = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = Le(e), o = a.getDay(), i = (o < n ? 7 : 0) + o - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function lr(e) {
  return ft(e, { weekStartsOn: 1 });
}
function So(e) {
  const t = Le(e), r = t.getFullYear(), n = ct(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = lr(n), o = ct(e, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const i = lr(o);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
}
function pl(e) {
  const t = So(e), r = ct(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), lr(r);
}
function bl(e) {
  const t = Le(e), r = +lr(t) - +pl(t);
  return Math.round(r / Po) + 1;
}
function Oo(e, t) {
  var l, m, b, c;
  const r = Le(e), n = r.getFullYear(), a = Qt(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((c = (b = a.locale) == null ? void 0 : b.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, i = ct(e, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = ft(i, t), u = ct(e, 0);
  u.setFullYear(n, 0, o), u.setHours(0, 0, 0, 0);
  const d = ft(u, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= d.getTime() ? n : n - 1;
}
function gl(e, t) {
  var s, u, d, l;
  const r = Qt(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((l = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, a = Oo(e, t), o = ct(e, 0);
  return o.setFullYear(a, 0, n), o.setHours(0, 0, 0, 0), ft(o, t);
}
function yl(e, t) {
  const r = Le(e), n = +ft(r, t) - +gl(r, t);
  return Math.round(n / Po) + 1;
}
function de(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const Ge = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return de(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : de(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return de(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return de(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return de(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return de(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return de(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return de(a, t.length);
  }
}, yt = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Gn = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return Ge.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const a = Oo(e, n), o = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const i = o % 100;
      return de(i, 2);
    }
    return t === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : de(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = So(e);
    return de(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return de(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return de(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return de(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ge.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return de(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const a = yl(e, n);
    return t === "wo" ? r.ordinalNumber(a, { unit: "week" }) : de(a, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = bl(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : de(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : Ge.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = hl(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : de(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return de(o, 2);
      case "eo":
        return r.ordinalNumber(o, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return de(o, t.length);
      case "co":
        return r.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return de(a, t.length);
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = yt.noon : n === 0 ? a = yt.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = yt.evening : n >= 12 ? a = yt.afternoon : n >= 4 ? a = yt.morning : a = yt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return Ge.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : Ge.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : de(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ge.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ge.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ge.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Zn(n);
      case "XXXX":
      case "XX":
        return ot(n);
      case "XXXXX":
      case "XXX":
      default:
        return ot(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Zn(n);
      case "xxxx":
      case "xx":
        return ot(n);
      case "xxxxx":
      case "xxx":
      default:
        return ot(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Jn(n, ":");
      case "OOOO":
      default:
        return "GMT" + ot(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Jn(n, ":");
      case "zzzz":
      default:
        return "GMT" + ot(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return de(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return de(n, t.length);
  }
};
function Jn(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? r + String(a) : r + String(a) + t + de(o, 2);
}
function Zn(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + de(Math.abs(e) / 60, 2) : ot(e, t);
}
function ot(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = de(Math.trunc(n / 60), 2), o = de(n % 60, 2);
  return r + a + t + o;
}
const ea = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Do = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, wl = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return ea(e, t);
  let o;
  switch (n) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", ea(n, t)).replace("{{time}}", Do(a, t));
}, Ml = {
  p: Do,
  P: wl
}, El = /^D+$/, Pl = /^Y+$/, Sl = ["D", "DD", "YY", "YYYY"];
function Ol(e) {
  return El.test(e);
}
function Dl(e) {
  return Pl.test(e);
}
function _l(e, t, r) {
  const n = Tl(e, t, r);
  if (console.warn(n), Sl.includes(e))
    throw new RangeError(n);
}
function Tl(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Cl(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function xl(e) {
  if (!Cl(e) && typeof e != "number")
    return !1;
  const t = Le(e);
  return !isNaN(Number(t));
}
const kl = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Al = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $l = /^'([^]*?)'?$/, Wl = /''/g, Rl = /[a-zA-Z]/;
function Il(e, t, r) {
  var l, m, b, c, v, f, h, y;
  const n = Qt(), a = (r == null ? void 0 : r.locale) ?? n.locale ?? Eo, o = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((m = (l = r == null ? void 0 : r.locale) == null ? void 0 : l.options) == null ? void 0 : m.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((c = (b = n.locale) == null ? void 0 : b.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, i = (r == null ? void 0 : r.weekStartsOn) ?? ((f = (v = r == null ? void 0 : r.locale) == null ? void 0 : v.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((y = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : y.weekStartsOn) ?? 0, s = Le(e);
  if (!xl(s))
    throw new RangeError("Invalid time value");
  let u = t.match(Al).map((M) => {
    const g = M[0];
    if (g === "p" || g === "P") {
      const p = Ml[g];
      return p(M, a.formatLong);
    }
    return M;
  }).join("").match(kl).map((M) => {
    if (M === "''")
      return { isToken: !1, value: "'" };
    const g = M[0];
    if (g === "'")
      return { isToken: !1, value: jl(M) };
    if (Gn[g])
      return { isToken: !0, value: M };
    if (g.match(Rl))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: M };
  });
  a.localize.preprocessor && (u = a.localize.preprocessor(s, u));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return u.map((M) => {
    if (!M.isToken)
      return M.value;
    const g = M.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && Dl(g) || !(r != null && r.useAdditionalDayOfYearTokens) && Ol(g)) && _l(g, t, String(e));
    const p = Gn[g[0]];
    return p(s, g, a.localize, d);
  }).join("");
}
function jl(e) {
  const t = e.match($l);
  return t ? t[1].replace(Wl, "'") : e;
}
function Nl() {
  return Object.assign({}, Qt());
}
function ta(e, t, r) {
  const n = ft(e, r), a = ft(t, r);
  return +n == +a;
}
function ra(e, t, r) {
  const n = Nl(), a = Ll(e, r.timeZone, r.locale ?? n.locale);
  return "formatToParts" in a ? Fl(a, t) : Hl(a, t);
}
function Fl(e, t) {
  const r = e.formatToParts(t);
  for (let n = r.length - 1; n >= 0; --n)
    if (r[n].type === "timeZoneName")
      return r[n].value;
}
function Hl(e, t) {
  const r = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(r);
  return n ? n[0].substr(1) : "";
}
function Ll(e, t, r) {
  return new Intl.DateTimeFormat(r ? [r.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function zl(e, t) {
  const r = Xl(t);
  return "formatToParts" in r ? Bl(r, e) : Kl(r, e);
}
const Yl = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Bl(e, t) {
  try {
    const r = e.formatToParts(t), n = [];
    for (let a = 0; a < r.length; a++) {
      const o = Yl[r[a].type];
      o !== void 0 && (n[o] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (r) {
    if (r instanceof RangeError)
      return [NaN];
    throw r;
  }
}
function Kl(e, t) {
  const r = e.format(t), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [
    parseInt(n[3], 10),
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[4], 10),
    parseInt(n[5], 10),
    parseInt(n[6], 10)
  ];
}
const Er = {}, na = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Ul = na === "06/25/2014, 00:00:00" || na === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function Xl(e) {
  return Er[e] || (Er[e] = Ul ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), Er[e];
}
function _o(e, t, r, n, a, o, i) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(e, t, r), s.setUTCHours(n, a, o, i), s;
}
const aa = 36e5, Vl = 6e4, Pr = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function un(e, t, r) {
  if (!e)
    return 0;
  let n = Pr.timezoneZ.exec(e);
  if (n)
    return 0;
  let a, o;
  if (n = Pr.timezoneHH.exec(e), n)
    return a = parseInt(n[1], 10), oa(a) ? -(a * aa) : NaN;
  if (n = Pr.timezoneHHMM.exec(e), n) {
    a = parseInt(n[2], 10);
    const i = parseInt(n[3], 10);
    return oa(a, i) ? (o = Math.abs(a) * aa + i * Vl, n[1] === "+" ? -o : o) : NaN;
  }
  if (Gl(e)) {
    t = new Date(t || Date.now());
    const i = r ? t : ql(t), s = Lr(i, e);
    return -(r ? s : Ql(t, s, e));
  }
  return NaN;
}
function ql(e) {
  return _o(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function Lr(e, t) {
  const r = zl(e, t), n = _o(r[0], r[1] - 1, r[2], r[3] % 24, r[4], r[5], 0).getTime();
  let a = e.getTime();
  const o = a % 1e3;
  return a -= o >= 0 ? o : 1e3 + o, n - a;
}
function Ql(e, t, r) {
  let a = e.getTime() - t;
  const o = Lr(new Date(a), r);
  if (t === o)
    return t;
  a -= o - t;
  const i = Lr(new Date(a), r);
  return o === i ? o : Math.max(o, i);
}
function oa(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
const ia = {};
function Gl(e) {
  if (ia[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), ia[e] = !0, !0;
  } catch {
    return !1;
  }
}
const Jl = 60 * 1e3, Zl = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = Sr(r.timeZone, e);
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return sa(n);
      case "XXXX":
      case "XX":
        return Et(n);
      case "XXXXX":
      case "XXX":
      default:
        return Et(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = Sr(r.timeZone, e);
    switch (t) {
      case "x":
        return sa(n);
      case "xxxx":
      case "xx":
        return Et(n);
      case "xxxxx":
      case "xxx":
      default:
        return Et(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = Sr(r.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ec(n, ":");
      case "OOOO":
      default:
        return "GMT" + Et(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return ra("short", e, r);
      case "zzzz":
      default:
        return ra("long", e, r);
    }
  }
};
function Sr(e, t) {
  const r = e ? un(e, t, !0) / Jl : (t == null ? void 0 : t.getTimezoneOffset()) ?? 0;
  if (Number.isNaN(r))
    throw new RangeError("Invalid time zone specified: " + e);
  return r;
}
function cr(e, t) {
  const r = e < 0 ? "-" : "";
  let n = Math.abs(e).toString();
  for (; n.length < t; )
    n = "0" + n;
  return r + n;
}
function Et(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = cr(Math.floor(n / 60), 2), o = cr(Math.floor(n % 60), 2);
  return r + a + t + o;
}
function sa(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + cr(Math.abs(e) / 60, 2) : Et(e, t);
}
function ec(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), o = n % 60;
  return o === 0 ? r + String(a) : r + String(a) + t + cr(o, 2);
}
function ua(e) {
  const t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), +e - +t;
}
const tc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Or = 36e5, da = 6e4, rc = 2, Se = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: tc
};
function To(e, t = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = t.additionalDigits == null ? rc : Number(t.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (Object.prototype.toString.call(e) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const n = nc(e), { year: a, restDateString: o } = ac(n.date, r), i = oc(o, a);
  if (i === null || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (i) {
    const s = i.getTime();
    let u = 0, d;
    if (n.time && (u = ic(n.time), u === null || isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || t.timeZone) {
      if (d = un(n.timeZone || t.timeZone, new Date(s + u)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = ua(new Date(s + u)), d = ua(new Date(s + u + d));
    return new Date(s + u + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function nc(e) {
  const t = {};
  let r = Se.dateTimePattern.exec(e), n;
  if (r ? (t.date = r[1], n = r[3]) : (r = Se.datePattern.exec(e), r ? (t.date = r[1], n = r[2]) : (t.date = null, n = e)), n) {
    const a = Se.timeZone.exec(n);
    a ? (t.time = n.replace(a[1], ""), t.timeZone = a[1].trim()) : t.time = n;
  }
  return t;
}
function ac(e, t) {
  if (e) {
    const r = Se.YYY[t], n = Se.YYYYY[t];
    let a = Se.YYYY.exec(e) || n.exec(e);
    if (a) {
      const o = a[1];
      return {
        year: parseInt(o, 10),
        restDateString: e.slice(o.length)
      };
    }
    if (a = Se.YY.exec(e) || r.exec(e), a) {
      const o = a[1];
      return {
        year: parseInt(o, 10) * 100,
        restDateString: e.slice(o.length)
      };
    }
  }
  return {
    year: null
  };
}
function oc(e, t) {
  if (t === null)
    return null;
  let r, n, a;
  if (!e || !e.length)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  let o = Se.MM.exec(e);
  if (o)
    return r = /* @__PURE__ */ new Date(0), n = parseInt(o[1], 10) - 1, ca(t, n) ? (r.setUTCFullYear(t, n), r) : /* @__PURE__ */ new Date(NaN);
  if (o = Se.DDD.exec(e), o) {
    r = /* @__PURE__ */ new Date(0);
    const i = parseInt(o[1], 10);
    return dc(t, i) ? (r.setUTCFullYear(t, 0, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Se.MMDD.exec(e), o) {
    r = /* @__PURE__ */ new Date(0), n = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10);
    return ca(t, n, i) ? (r.setUTCFullYear(t, n, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (o = Se.Www.exec(e), o)
    return a = parseInt(o[1], 10) - 1, fa(a) ? la(t, a) : /* @__PURE__ */ new Date(NaN);
  if (o = Se.WwwD.exec(e), o) {
    a = parseInt(o[1], 10) - 1;
    const i = parseInt(o[2], 10) - 1;
    return fa(a, i) ? la(t, a, i) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function ic(e) {
  let t, r, n = Se.HH.exec(e);
  if (n)
    return t = parseFloat(n[1].replace(",", ".")), Dr(t) ? t % 24 * Or : NaN;
  if (n = Se.HHMM.exec(e), n)
    return t = parseInt(n[1], 10), r = parseFloat(n[2].replace(",", ".")), Dr(t, r) ? t % 24 * Or + r * da : NaN;
  if (n = Se.HHMMSS.exec(e), n) {
    t = parseInt(n[1], 10), r = parseInt(n[2], 10);
    const a = parseFloat(n[3].replace(",", "."));
    return Dr(t, r, a) ? t % 24 * Or + r * da + a * 1e3 : NaN;
  }
  return null;
}
function la(e, t, r) {
  t = t || 0, r = r || 0;
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, o = t * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + o), n;
}
const sc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], uc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Co(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ca(e, t, r) {
  if (t < 0 || t > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const n = Co(e);
    if (n && r > uc[t] || !n && r > sc[t])
      return !1;
  }
  return !0;
}
function dc(e, t) {
  if (t < 1)
    return !1;
  const r = Co(e);
  return !(r && t > 366 || !r && t > 365);
}
function fa(e, t) {
  return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function Dr(e, t, r) {
  return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || r != null && (r < 0 || r >= 60));
}
const lc = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function cc(e, t, r = {}) {
  t = String(t);
  const n = t.match(lc);
  if (n) {
    const a = To(r.originalDate || e, r);
    t = n.reduce(function(o, i) {
      if (i[0] === "'")
        return o;
      const s = o.indexOf(i), u = o[s - 1] === "'", d = o.replace(i, "'" + Zl[i[0]](a, i, r) + "'");
      return u ? d.substring(0, s - 1) + d.substring(s + 1) : d;
    }, t);
  }
  return Il(e, t, r);
}
function fc(e, t, r) {
  e = To(e, r);
  const n = un(t, e, !0), a = new Date(e.getTime() - n), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
}
function ma(e, t, r, n) {
  return n = {
    ...n,
    timeZone: t,
    originalDate: e
  }, cc(fc(e, t, { timeZone: n.timeZone }), r, n);
}
const mc = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, vc = (e, t, r) => {
  let n;
  const a = mc[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " siden" : n;
}, hc = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, pc = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, bc = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, gc = {
  date: L({
    formats: hc,
    defaultWidth: "full"
  }),
  time: L({
    formats: pc,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: bc,
    defaultWidth: "full"
  })
}, yc = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, wc = (e, t, r, n) => yc[e], Mc = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Ec = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Pc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Sc = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, Oc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Dc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, _c = (e, t) => Number(e) + ".", Tc = {
  ordinalNumber: _c,
  era: F({
    values: Mc,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Ec,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Pc,
    defaultWidth: "wide"
  }),
  day: F({
    values: Sc,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Oc,
    defaultWidth: "wide",
    formattingValues: Dc,
    defaultFormattingWidth: "wide"
  })
}, Cc = /^(\d+)(\.)?/i, xc = /\d+/i, kc = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Ac = {
  any: [/^f/i, /^(v|e)/i]
}, $c = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Wc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Ic = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jc = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Nc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Fc = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, Hc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, Lc = {
  ordinalNumber: Ue({
    matchPattern: Cc,
    parsePattern: xc,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: kc,
    defaultMatchWidth: "wide",
    parsePatterns: Ac,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: $c,
    defaultMatchWidth: "wide",
    parsePatterns: Wc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: Rc,
    defaultMatchWidth: "wide",
    parsePatterns: Ic,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: jc,
    defaultMatchWidth: "wide",
    parsePatterns: Nc,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: Fc,
    defaultMatchWidth: "any",
    parsePatterns: Hc,
    defaultParseWidth: "any"
  })
}, zc = {
  code: "da",
  formatDistance: vc,
  formatLong: gc,
  formatRelative: wc,
  localize: Tc,
  match: Lc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, va = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Yc = (e, t, r) => {
  let n;
  const a = r != null && r.addSuffix ? va[e].withPreposition : va[e].standalone;
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : "vor " + n : n;
}, Bc = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Kc = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Uc = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Xc = {
  date: L({
    formats: Bc,
    defaultWidth: "full"
  }),
  time: L({
    formats: Kc,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Uc,
    defaultWidth: "full"
  })
}, Vc = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, qc = (e, t, r, n) => Vc[e], Qc = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, Gc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, zr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, Jc = {
  narrow: zr.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: zr.wide
}, Zc = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, ef = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, tf = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, rf = (e) => Number(e) + ".", nf = {
  ordinalNumber: rf,
  era: F({
    values: Qc,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Gc,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: zr,
    formattingValues: Jc,
    defaultWidth: "wide"
  }),
  day: F({
    values: Zc,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: ef,
    defaultWidth: "wide",
    formattingValues: tf,
    defaultFormattingWidth: "wide"
  })
}, af = /^(\d+)(\.)?/i, of = /\d+/i, sf = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, uf = {
  any: [/^v/i, /^n/i]
}, df = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, lf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cf = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, ff = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, mf = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, vf = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, hf = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, pf = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, bf = {
  ordinalNumber: Ue({
    matchPattern: af,
    parsePattern: of,
    valueCallback: (e) => parseInt(e)
  }),
  era: H({
    matchPatterns: sf,
    defaultMatchWidth: "wide",
    parsePatterns: uf,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: df,
    defaultMatchWidth: "wide",
    parsePatterns: lf,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: cf,
    defaultMatchWidth: "wide",
    parsePatterns: ff,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: mf,
    defaultMatchWidth: "wide",
    parsePatterns: vf,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: hf,
    defaultMatchWidth: "wide",
    parsePatterns: pf,
    defaultParseWidth: "any"
  })
}, gf = {
  code: "de",
  formatDistance: Yc,
  formatLong: Xc,
  formatRelative: qc,
  localize: nf,
  match: bf,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, yf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, wf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Mf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ef = {
  date: L({
    formats: yf,
    defaultWidth: "full"
  }),
  time: L({
    formats: wf,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Mf,
    defaultWidth: "full"
  })
}, Pf = {
  code: "en-AU",
  formatDistance: $t,
  formatLong: Ef,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Sf = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, Of = (e, t, r) => {
  let n;
  const a = Sf[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Df = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, _f = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Tf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cf = {
  date: L({
    formats: Df,
    defaultWidth: "full"
  }),
  time: L({
    formats: _f,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Tf,
    defaultWidth: "full"
  })
}, xf = {
  code: "en-CA",
  formatDistance: Of,
  formatLong: Cf,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, kf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Af = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $f = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Wf = {
  date: L({
    formats: kf,
    defaultWidth: "full"
  }),
  time: L({
    formats: Af,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: $f,
    defaultWidth: "full"
  })
}, Rf = {
  code: "en-GB",
  formatDistance: $t,
  formatLong: Wf,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, If = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, jf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Nf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ff = {
  date: L({
    formats: If,
    defaultWidth: "full"
  }),
  time: L({
    formats: jf,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Nf,
    defaultWidth: "full"
  })
}, Hf = {
  code: "en-IN",
  formatDistance: $t,
  formatLong: Ff,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
}, Lf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, zf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Yf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Bf = {
  date: L({
    formats: Lf,
    defaultWidth: "full"
  }),
  time: L({
    formats: zf,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Yf,
    defaultWidth: "full"
  })
}, Kf = {
  code: "en-NZ",
  formatDistance: $t,
  formatLong: Bf,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Uf = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, Xf = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qf = {
  date: L({
    formats: Uf,
    defaultWidth: "full"
  }),
  time: L({
    formats: Xf,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Vf,
    defaultWidth: "full"
  })
}, Qf = {
  code: "en-ZA",
  formatDistance: $t,
  formatLong: qf,
  formatRelative: pt,
  localize: bt,
  match: gt,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
}, Gf = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, Jf = (e, t, r) => {
  let n;
  const a = Gf[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
}, Zf = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, em = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, tm = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rm = {
  date: L({
    formats: Zf,
    defaultWidth: "full"
  }),
  time: L({
    formats: em,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: tm,
    defaultWidth: "full"
  })
}, nm = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, am = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, om = (e, t, r, n) => t.getHours() !== 1 ? am[e] : nm[e], im = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, sm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, um = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, dm = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, lm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, cm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, fm = (e, t) => Number(e) + "º", mm = {
  ordinalNumber: fm,
  era: F({
    values: im,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: sm,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: F({
    values: um,
    defaultWidth: "wide"
  }),
  day: F({
    values: dm,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: lm,
    defaultWidth: "wide",
    formattingValues: cm,
    defaultFormattingWidth: "wide"
  })
}, vm = /^(\d+)(º)?/i, hm = /\d+/i, pm = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, bm = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, gm = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, ym = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wm = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Mm = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Em = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, Pm = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Sm = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Om = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, Dm = {
  ordinalNumber: Ue({
    matchPattern: vm,
    parsePattern: hm,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: H({
    matchPatterns: pm,
    defaultMatchWidth: "wide",
    parsePatterns: bm,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: gm,
    defaultMatchWidth: "wide",
    parsePatterns: ym,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: wm,
    defaultMatchWidth: "wide",
    parsePatterns: Mm,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: Em,
    defaultMatchWidth: "wide",
    parsePatterns: Pm,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: Sm,
    defaultMatchWidth: "any",
    parsePatterns: Om,
    defaultParseWidth: "any"
  })
}, _m = {
  code: "es",
  formatDistance: Jf,
  formatLong: rm,
  formatRelative: om,
  localize: mm,
  match: Dm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Tm = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, Cm = (e, t, r) => {
  let n;
  const a = Tm[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + n : "il y a " + n : n;
}, xm = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, km = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Am = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $m = {
  date: L({
    formats: xm,
    defaultWidth: "full"
  }),
  time: L({
    formats: km,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Am,
    defaultWidth: "full"
  })
}, Wm = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, Rm = (e, t, r, n) => Wm[e], Im = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, jm = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, Nm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, Fm = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, Hm = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Lm = (e, t) => {
  const r = Number(e), n = t == null ? void 0 : t.unit;
  if (r === 0)
    return "0";
  const a = ["year", "week", "hour", "minute", "second"];
  let o;
  return r === 1 ? o = n && a.includes(n) ? "ère" : "er" : o = "ème", r + o;
}, zm = ["MMM", "MMMM"], Ym = {
  preprocessor: (e, t) => e.getDate() === 1 || !t.some(
    (n) => n.isToken && zm.includes(n.value)
  ) ? t : t.map(
    (n) => n.isToken && n.value === "do" ? { isToken: !0, value: "d" } : n
  ),
  ordinalNumber: Lm,
  era: F({
    values: Im,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: jm,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Nm,
    defaultWidth: "wide"
  }),
  day: F({
    values: Fm,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Hm,
    defaultWidth: "wide"
  })
}, Bm = /^(\d+)(ième|ère|ème|er|e)?/i, Km = /\d+/i, Um = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, Xm = {
  any: [/^av/i, /^ap/i]
}, Vm = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, qm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Gm = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Jm = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Zm = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, ev = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, tv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, rv = {
  ordinalNumber: Ue({
    matchPattern: Bm,
    parsePattern: Km,
    valueCallback: (e) => parseInt(e)
  }),
  era: H({
    matchPatterns: Um,
    defaultMatchWidth: "wide",
    parsePatterns: Xm,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: Vm,
    defaultMatchWidth: "wide",
    parsePatterns: qm,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: Qm,
    defaultMatchWidth: "wide",
    parsePatterns: Gm,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: Jm,
    defaultMatchWidth: "wide",
    parsePatterns: Zm,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: ev,
    defaultMatchWidth: "any",
    parsePatterns: tv,
    defaultParseWidth: "any"
  })
}, nv = {
  code: "fr",
  formatDistance: Cm,
  formatLong: $m,
  formatRelative: Rm,
  localize: Ym,
  match: rv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, av = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, ov = (e, t, r) => {
  let n;
  const a = av[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + n : n + " fa" : n;
}, iv = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, sv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, uv = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dv = {
  date: L({
    formats: iv,
    defaultWidth: "full"
  }),
  time: L({
    formats: sv,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: uv,
    defaultWidth: "full"
  })
}, dn = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function lv(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + dn[e] + " scorso alle' p";
  }
}
function ha(e) {
  return "'" + dn[e] + " alle' p";
}
function cv(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + dn[e] + " prossimo alle' p";
  }
}
const fv = {
  lastWeek: (e, t, r) => {
    const n = e.getDay();
    return ta(e, t, r) ? ha(n) : lv(n);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, t, r) => {
    const n = e.getDay();
    return ta(e, t, r) ? ha(n) : cv(n);
  },
  other: "P"
}, mv = (e, t, r, n) => {
  const a = fv[e];
  return typeof a == "function" ? a(t, r, n) : a;
}, vv = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, hv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, pv = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, bv = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, gv = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, yv = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, wv = (e, t) => {
  const r = Number(e);
  return String(r);
}, Mv = {
  ordinalNumber: wv,
  era: F({
    values: vv,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: hv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: pv,
    defaultWidth: "wide"
  }),
  day: F({
    values: bv,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: gv,
    defaultWidth: "wide",
    formattingValues: yv,
    defaultFormattingWidth: "wide"
  })
}, Ev = /^(\d+)(º)?/i, Pv = /\d+/i, Sv = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, Ov = {
  any: [/^a/i, /^(d|e)/i]
}, Dv = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, _v = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Tv = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, Cv = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, xv = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, kv = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, Av = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, $v = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, Wv = {
  ordinalNumber: Ue({
    matchPattern: Ev,
    parsePattern: Pv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: Sv,
    defaultMatchWidth: "wide",
    parsePatterns: Ov,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: Dv,
    defaultMatchWidth: "wide",
    parsePatterns: _v,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: Tv,
    defaultMatchWidth: "wide",
    parsePatterns: Cv,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: xv,
    defaultMatchWidth: "wide",
    parsePatterns: kv,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: Av,
    defaultMatchWidth: "any",
    parsePatterns: $v,
    defaultParseWidth: "any"
  })
}, Rv = {
  code: "it",
  formatDistance: ov,
  formatLong: dv,
  formatRelative: mv,
  localize: Mv,
  match: Wv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Iv = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, jv = (e, t, r) => {
  let n;
  const a = Iv[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + n : n + " geleden" : n;
}, Nv = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, Fv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Hv = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Lv = {
  date: L({
    formats: Nv,
    defaultWidth: "full"
  }),
  time: L({
    formats: Fv,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Hv,
    defaultWidth: "full"
  })
}, zv = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Yv = (e, t, r, n) => zv[e], Bv = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Kv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Uv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Xv = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, Vv = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, qv = (e, t) => Number(e) + "e", Qv = {
  ordinalNumber: qv,
  era: F({
    values: Bv,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Kv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Uv,
    defaultWidth: "wide"
  }),
  day: F({
    values: Xv,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Vv,
    defaultWidth: "wide"
  })
}, Gv = /^(\d+)e?/i, Jv = /\d+/i, Zv = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, eh = {
  any: [/^v/, /^n/]
}, th = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, rh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nh = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, ah = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, oh = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, ih = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, sh = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, uh = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, dh = {
  ordinalNumber: Ue({
    matchPattern: Gv,
    parsePattern: Jv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: Zv,
    defaultMatchWidth: "wide",
    parsePatterns: eh,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: th,
    defaultMatchWidth: "wide",
    parsePatterns: rh,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: nh,
    defaultMatchWidth: "wide",
    parsePatterns: ah,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: oh,
    defaultMatchWidth: "wide",
    parsePatterns: ih,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: sh,
    defaultMatchWidth: "any",
    parsePatterns: uh,
    defaultParseWidth: "any"
  })
}, lh = {
  code: "nl",
  formatDistance: jv,
  formatLong: Lv,
  formatRelative: Yv,
  localize: Qv,
  match: dh,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, ch = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, fh = (e, t, r) => {
  let n;
  const a = ch[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + n : "há " + n : n;
}, mh = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, vh = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, hh = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ph = {
  date: L({
    formats: mh,
    defaultWidth: "full"
  }),
  time: L({
    formats: vh,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: hh,
    defaultWidth: "full"
  })
}, bh = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, gh = (e, t, r, n) => {
  const a = bh[e];
  return typeof a == "function" ? a(t) : a;
}, yh = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, wh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Mh = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Eh = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, Ph = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, Sh = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, Oh = (e, t) => Number(e) + "º", Dh = {
  ordinalNumber: Oh,
  era: F({
    values: yh,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: wh,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Mh,
    defaultWidth: "wide"
  }),
  day: F({
    values: Eh,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Ph,
    defaultWidth: "wide",
    formattingValues: Sh,
    defaultFormattingWidth: "wide"
  })
}, _h = /^(\d+)(º|ª)?/i, Th = /\d+/i, Ch = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, xh = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i
  ]
}, kh = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, Ah = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $h = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Wh = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Rh = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, Ih = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, jh = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, Nh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, Fh = {
  ordinalNumber: Ue({
    matchPattern: _h,
    parsePattern: Th,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: Ch,
    defaultMatchWidth: "wide",
    parsePatterns: xh,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: kh,
    defaultMatchWidth: "wide",
    parsePatterns: Ah,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: $h,
    defaultMatchWidth: "wide",
    parsePatterns: Wh,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: Rh,
    defaultMatchWidth: "wide",
    parsePatterns: Ih,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: jh,
    defaultMatchWidth: "any",
    parsePatterns: Nh,
    defaultParseWidth: "any"
  })
}, Hh = {
  code: "pt",
  formatDistance: fh,
  formatLong: ph,
  formatRelative: gh,
  localize: Dh,
  match: Fh,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Lh = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, zh = (e, t, r) => {
  let n;
  const a = Lh[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "em " + n : "há " + n : n;
}, Yh = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Bh = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kh = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Uh = {
  date: L({
    formats: Yh,
    defaultWidth: "full"
  }),
  time: L({
    formats: Bh,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Kh,
    defaultWidth: "full"
  })
}, Xh = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Vh = (e, t, r, n) => {
  const a = Xh[e];
  return typeof a == "function" ? a(t) : a;
}, qh = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Qh = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Gh = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Jh = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, Zh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, ep = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, tp = (e, t) => {
  const r = Number(e);
  return (t == null ? void 0 : t.unit) === "week" ? r + "ª" : r + "º";
}, rp = {
  ordinalNumber: tp,
  era: F({
    values: qh,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Qh,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Gh,
    defaultWidth: "wide"
  }),
  day: F({
    values: Jh,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Zh,
    defaultWidth: "wide",
    formattingValues: ep,
    defaultFormattingWidth: "wide"
  })
}, np = /^(\d+)[ºªo]?/i, ap = /\d+/i, op = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, ip = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, sp = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, up = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dp = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, lp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, cp = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, fp = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, mp = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, vp = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, hp = {
  ordinalNumber: Ue({
    matchPattern: np,
    parsePattern: ap,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: op,
    defaultMatchWidth: "wide",
    parsePatterns: ip,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: sp,
    defaultMatchWidth: "wide",
    parsePatterns: up,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: dp,
    defaultMatchWidth: "wide",
    parsePatterns: lp,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: cp,
    defaultMatchWidth: "wide",
    parsePatterns: fp,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: mp,
    defaultMatchWidth: "any",
    parsePatterns: vp,
    defaultParseWidth: "any"
  })
}, pp = {
  code: "pt-BR",
  formatDistance: zh,
  formatLong: Uh,
  formatRelative: Vh,
  localize: rp,
  match: hp,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, bp = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, gp = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], yp = (e, t, r) => {
  let n;
  const a = bp[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace(
    "{{count}}",
    t < 13 ? gp[t] : String(t)
  ), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " sedan" : n;
}, wp = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Mp = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ep = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Pp = {
  date: L({
    formats: wp,
    defaultWidth: "full"
  }),
  time: L({
    formats: Mp,
    defaultWidth: "full"
  }),
  dateTime: L({
    formats: Ep,
    defaultWidth: "full"
  })
}, Sp = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, Op = (e, t, r, n) => Sp[e], Dp = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, _p = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, Tp = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Cp = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, xp = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, kp = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, Ap = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, $p = {
  ordinalNumber: Ap,
  era: F({
    values: Dp,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: _p,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Tp,
    defaultWidth: "wide"
  }),
  day: F({
    values: Cp,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: xp,
    defaultWidth: "wide",
    formattingValues: kp,
    defaultFormattingWidth: "wide"
  })
}, Wp = /^(\d+)(:a|:e)?/i, Rp = /\d+/i, Ip = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, jp = {
  any: [/^f/i, /^[ev]/i]
}, Np = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, Fp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Hp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, Lp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, zp = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, Yp = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Bp = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, Kp = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, Up = {
  ordinalNumber: Ue({
    matchPattern: Wp,
    parsePattern: Rp,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: H({
    matchPatterns: Ip,
    defaultMatchWidth: "wide",
    parsePatterns: jp,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: Np,
    defaultMatchWidth: "wide",
    parsePatterns: Fp,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: H({
    matchPatterns: Hp,
    defaultMatchWidth: "wide",
    parsePatterns: Lp,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: zp,
    defaultMatchWidth: "wide",
    parsePatterns: Yp,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: Bp,
    defaultMatchWidth: "any",
    parsePatterns: Kp,
    defaultParseWidth: "any"
  })
}, Xp = {
  code: "sv",
  formatDistance: yp,
  formatLong: Pp,
  formatRelative: Op,
  localize: $p,
  match: Up,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, me = {
  da: zc,
  de: gf,
  enAU: Pf,
  enCA: xf,
  enGB: Rf,
  enIN: Hf,
  enNZ: Kf,
  enUS: Eo,
  enZA: Qf,
  es: _m,
  fr: nv,
  it: Rv,
  nl: lh,
  pt: Hh,
  ptBR: pp,
  sv: Xp
}, Je = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: me.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: me.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: me.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: me.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: me.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: me.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: me.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: me.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: me.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: me.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: me.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Vp = [Je.IT.name, Je.ES.name, Je.BR.name], xo = [
  { id: 18, name: "AMERICAN FOOTBALL", translationFile: "american_football" },
  { id: 11, name: "ATHLETICS", translationFile: "athletics" },
  { id: 23, name: "AUSSIE RULES", translationFile: "aussie_rules" },
  { id: 32, name: "BADMINTON", translationFile: "badminton" },
  { id: 48, name: "BANDY", translationFile: "bandy" },
  { id: 46, name: "BASEBALL", translationFile: "baseball" },
  { id: 47, name: "BASKETBALL", translationFile: "basketball" },
  { id: 28, name: "BETTYPE", translationFile: "bettype" },
  { id: 31, name: "BOWLS", translationFile: "bowls" },
  { id: 10, name: "BOXING", translationFile: "boxing" },
  { id: 76, name: "CASINO", translationFile: "casino" },
  { id: 19, name: "CRICKET", translationFile: "cricket" },
  { id: 14, name: "CYCLING", translationFile: "cycling" },
  { id: 21, name: "DARTS", translationFile: "darts" },
  { id: 49, name: "DUMMY", translationFile: "dummy" },
  { id: 33, name: "EQUESTRIAN", translationFile: "equestrian" },
  { id: 34, name: "FINANCIAL", translationFile: "financial" },
  { id: 29, name: "FLOORBALL", translationFile: "floorball" },
  { id: 2, name: "FOOTBALL", translationFile: "football" },
  { id: 24, name: "GAELIC SPORTS", translationFile: "gaelic_sports" },
  { id: 6, name: "GOLF", translationFile: "golf" },
  { id: 5, name: "GREYHOUNDS", translationFile: "greyhounds" },
  { id: 35, name: "HANDBALL", translationFile: "handball" },
  { id: 74, name: "HARNESS RACING", translationFile: "harness_racing" },
  { id: 36, name: "HOCKEY", translationFile: "hockey" },
  { id: 3, name: "HORSE RACING", translationFile: "horse_racing" },
  { id: 45, name: "ICE HOCKEY", translationFile: "ice_hockey" },
  { id: 0, name: "LABEL", translationFile: "label" },
  { id: 27, name: "MENU", translationFile: "menu" },
  { id: 17, name: "MOTOR SPORT", translationFile: "motor_sport" },
  { id: 37, name: "NETBALL", translationFile: "netball" },
  { id: 62, name: "OLYMPICS", translationFile: "olympics" },
  { id: 26, name: "OTHER SPORTS", translationFile: "other_sports" },
  { id: 25, name: "POKER", translationFile: "poker" },
  { id: 68, name: "POLITICS", translationFile: "politics" },
  { id: 20, name: "POOL", translationFile: "pool" },
  { id: 22, name: "ROWING", translationFile: "rowing" },
  { id: 30, name: "RUGBY LEAGUE", translationFile: "rugby_league" },
  { id: 9, name: "RUGBY UNION", translationFile: "rugby_union" },
  { id: 8, name: "SNOOKER", translationFile: "snooker" },
  { id: 15, name: "SPECIALS", translationFile: "specials" },
  { id: 38, name: "SWIMMING", translationFile: "swimming" },
  { id: 39, name: "TABLE TENNIS", translationFile: "table_tennis" },
  { id: 7, name: "TENNIS", translationFile: "tennis" },
  { id: 40, name: "TROTTING", translationFile: "trotting" },
  { id: 71, name: "TV", translationFile: "tv" },
  { id: 61, name: "VIRTUAL FOOTBALL", translationFile: "virtual_football" },
  { id: 58, name: "VIRTUAL MOTORSPORT", translationFile: "virtual_motorsport" },
  { id: 41, name: "VOLLEYBALL", translationFile: "volleyball" },
  { id: 42, name: "WATER POLO", translationFile: "water_polo" },
  { id: 43, name: "WINTER SPORTS", translationFile: "winter_sports" },
  { id: 44, name: "YACHTING", translationFile: "yachting" }
], qp = (e) => {
  var t;
  return (t = xo.find((r) => r.id === e)) == null ? void 0 : t.translationFile;
};
/*! js-cookie v3.0.8 | MIT */
function nr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      n !== "__proto__" && (e[n] = r[n]);
  }
  return e;
}
var Qp = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Yr(e, t) {
  function r(a, o, i) {
    if (!(typeof document > "u")) {
      i = nr({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var u in i)
        i[u] && (s += "; " + u, i[u] !== !0 && (s += "=" + i[u].split(";")[0]));
      return document.cookie = a + "=" + e.write(o, a) + s;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], i = {}, s = 0; s < o.length; s++) {
        var u = o[s].split("="), d = u.slice(1).join("=");
        try {
          var l = decodeURIComponent(u[0]);
          if (l in i || (i[l] = e.read(d, l)), a === l)
            break;
        } catch {
        }
      }
      return a ? i[a] : i;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, o) {
        r(
          a,
          "",
          nr({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Yr(this.converter, nr({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Yr(nr({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
Yr(Qp, { path: "/" });
rt(void 0);
const Gp = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx/sports-catalogue`;
function pa(e) {
  const t = [" v ", " at "];
  for (const r of t) {
    const n = e.split(r);
    if (n.length === 2) {
      const [a, o] = n.map((i) => i.trim());
      return r === " v " ? { away: o, first: a, home: a, second: o, separator: r, success: !0 } : { away: a, first: a, home: o, second: o, separator: r, success: !0 };
    }
  }
  return {
    away: "",
    first: "",
    home: "",
    second: "",
    separator: "",
    success: !1
  };
}
const Jp = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function ko(e, t) {
  if (!t && typeof window > "u")
    return e;
  try {
    const r = new URL(t || window.location.href), n = new URLSearchParams(r.search), a = [];
    for (const s of Jp) {
      const u = n.get(s);
      u !== null && a.push([s, u]);
    }
    if (a.length === 0)
      return e;
    const o = e.startsWith("http://") || e.startsWith("https://"), i = o ? new URL(e) : new URL(e, r.origin);
    for (const [s, u] of a)
      i.searchParams.has(s) || i.searchParams.set(s, u);
    return o ? i.toString() : i.pathname + i.search + i.hash;
  } catch {
    return e;
  }
}
const Zp = "application/json", Ao = "Content-Type", wt = Symbol(), $o = Symbol();
function ba(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === Ao.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function ga(e) {
  return /^application\/.*json.*/.test(e);
}
const dt = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [a, o]) => {
    const i = e[a];
    return Array.isArray(i) && Array.isArray(o) ? n[a] = r ? [...i, ...o] : o : typeof i == "object" && typeof o == "object" ? n[a] = dt(i, o, r) : n[a] = o, n;
  }, { ...e });
}, Ct = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const a = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !a)
      throw new Error(e + " is not defined");
    return r && a ? new a(...n) : a;
  }
};
function eb(e, t = !1) {
  Ct.options = t ? e : dt(Ct.options, e);
}
function tb(e, t = !1) {
  Ct.polyfills = t ? e : dt(Ct.polyfills, e);
}
function rb(e) {
  Ct.errorType = e;
}
const nb = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class Wo extends Error {
}
const ab = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((g, p) => p.beforeRequest && p.beforeRequest(g, e._options, t) || g, e);
  const { _url: r, _options: n, _config: a, _catchers: o, _resolvers: i, _middlewares: s, _addons: u } = e, d = new Map(o), l = dt(a.options, n);
  let m = r;
  const b = nb(s)((g, p) => (m = g, a.polyfill("fetch")(g, p)))(r, l), c = new Error(), v = b.catch((g) => {
    throw { [wt]: g };
  }).then((g) => {
    var p;
    if (!g.ok) {
      const P = new Wo();
      if (P.cause = c, P.stack = P.stack + `
CAUSE: ` + c.stack, P.response = g, P.status = g.status, P.url = m, g.type === "opaque")
        throw P;
      const O = a.errorType === "json" || ((p = g.headers.get("Content-Type")) === null || p === void 0 ? void 0 : p.split(";")[0]) === "application/json";
      return (a.errorType ? O ? g.text() : g[a.errorType]() : Promise.resolve(g.body)).then((T) => {
        if (P.message = typeof T == "string" ? T : g.statusText, T)
          if (O && typeof T == "string") {
            P.text = T;
            try {
              P.json = JSON.parse(T);
            } catch {
            }
          } else
            P[a.errorType] = T;
        throw P;
      });
    }
    return g;
  }), f = (g) => g.catch((p) => {
    const P = Object.prototype.hasOwnProperty.call(p, wt), O = P ? p[wt] : p, x = (O == null ? void 0 : O.status) && d.get(O.status) || d.get(O == null ? void 0 : O.name) || P && d.has(wt) && d.get(wt);
    if (x)
      return x(O, e);
    const T = d.get($o);
    if (T)
      return T(O, e);
    throw O;
  }), h = (g) => (p) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ f(g ? v.then((P) => P && P[g]()).then((P) => p ? p(P) : P) : v.then((P) => p ? p(P) : P)), y = {
    _wretchReq: e,
    _fetchReq: b,
    _sharedState: t,
    res: h(null),
    json: h("json"),
    blob: h("blob"),
    formData: h("formData"),
    arrayBuffer: h("arrayBuffer"),
    text: h("text"),
    error(g, p) {
      return d.set(g, p), this;
    },
    badRequest(g) {
      return this.error(400, g);
    },
    unauthorized(g) {
      return this.error(401, g);
    },
    forbidden(g) {
      return this.error(403, g);
    },
    notFound(g) {
      return this.error(404, g);
    },
    timeout(g) {
      return this.error(408, g);
    },
    internalError(g) {
      return this.error(500, g);
    },
    fetchError(g) {
      return this.error(wt, g);
    }
  }, M = u.reduce((g, p) => ({
    ...g,
    ...typeof p.resolver == "function" ? p.resolver(g) : p.resolver
  }), y);
  return i.reduce((g, p) => p(g, e), M);
}, ob = {
  _url: "",
  _options: {},
  _config: Ct,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : dt(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : dt(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: dt(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [Ao]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher($o, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const a = ba(n._options.headers), o = this._config.polyfill("FormData", !1), i = typeof r == "object" && !(o && r instanceof o) && (!n._options.headers || !a || ga(a));
    return n = r ? i ? n.json(r, a) : n.body(r) : n, ab(n._deferred.reduce((s, u) => u(s, s._url, s._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = ba(this._options.headers);
    return this.content(t || ga(r) && r || Zp).body(JSON.stringify(e));
  }
};
function mt(e = "", t = {}) {
  return { ...ob, _url: e, _options: t };
}
mt.default = mt;
mt.options = eb;
mt.errorType = rb;
mt.polyfills = tb;
mt.WretchError = Wo;
class ib extends Error {
  constructor(r, n, a, o, i) {
    super(r);
    Xe(this, "statusCode");
    Xe(this, "endpoint");
    Xe(this, "args");
    Xe(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = a, this.args = o, this.response = i;
  }
}
class ln extends ib {
  constructor(t, r, n, a) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, a), this.name = "Api4xxError";
  }
}
class sb extends ln {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class ub extends ln {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class db {
  constructor(t = {}) {
    Xe(this, "logger");
    Xe(this, "notFoundLogLevel");
    Xe(this, "badRequestLogLevel");
    Xe(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: a } = t;
    if (a === 404) {
      const o = new sb(r, n, t);
      return this.log(this.notFoundLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    if (a === 400) {
      const o = new ub(r, n, t);
      return this.log(this.badRequestLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    if (a >= 400 && a < 500) {
      const o = new ln(a, r, n, t);
      return this.log(this.other4xxLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    throw t;
  }
}
const lb = (e, t) => {
  const r = new db(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
}, Ro = async (e = Gp(), t, r) => {
  const { repub: n, subeventId: a } = t, o = new URL(`${e}/v1/subevent-header/${a}`);
  return lb(
    mt(o.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        repub: n,
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, Io = ({ repub: e, subeventId: t }) => [
  "subevent-header",
  e,
  t
], cb = () => /* @__PURE__ */ Y(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 24 24",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Y(
      "path",
      {
        d: "M12 10.545l5.818-5.818c.402-.401 1.053-.401 1.455 0 .401.402.401 1.053 0 1.455L13.455 12l5.818 5.818c.401.402.401 1.053 0 1.455-.402.401-1.053.401-1.455 0L12 13.455l-5.818 5.818c-.402.401-1.053.401-1.455 0-.401-.402-.401-1.053 0-1.455L10.545 12 4.727 6.182c-.401-.402-.401-1.053 0-1.455.402-.401 1.053-.401 1.455 0L12 10.545z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  }
), fb = "_dropdownPillButton_g7z5b_1", mb = "_dropdownPillIconWrapper_g7z5b_22", vb = "_dropdownPanel_g7z5b_31", hb = "_dropdownTitleWrapper_g7z5b_41", pb = "_dropdownTitle_g7z5b_41", bb = "_dropdownItem_g7z5b_56", gb = "_dropdownItemActive_g7z5b_68", yb = "_dropdownCloseButton_g7z5b_77", wb = "_dropdownMenuSeparator_g7z5b_84", ze = {
  dropdownPillButton: fb,
  dropdownPillIconWrapper: mb,
  dropdownPanel: vb,
  dropdownTitleWrapper: hb,
  dropdownTitle: pb,
  dropdownItem: bb,
  dropdownItemActive: gb,
  dropdownCloseButton: yb,
  dropdownMenuSeparator: wb
}, jo = wa(
  ({ disclosure: e, menu: t, menuItems: r, menuProps: n, title: a, ...o }, i) => {
    const s = () => /* @__PURE__ */ Y(Pd, { ref: i, ...t, ...o, ...e.props, children: (l) => pr(e, {
      ...l,
      id: "menu-button",
      key: "menu-button"
    }) }), u = /* @__PURE__ */ Ae(cn, { children: [
      /* @__PURE__ */ Ae("div", { className: ze.dropdownTitleWrapper, children: [
        /* @__PURE__ */ Y("h4", { className: ze.dropdownTitle, "data-testid": "dropdown-title", children: a }),
        /* @__PURE__ */ Y("button", { className: ze.dropdownCloseButton, onClick: t.toggle, children: /* @__PURE__ */ Y(cb, {}) })
      ] }),
      /* @__PURE__ */ Y(Vn, { className: ze.dropdownMenuSeparator })
    ] }), d = () => /* @__PURE__ */ Ae(yd, { ...t, ...n, ref: i, children: [
      u,
      r.map((l, m) => l.type === Vn ? pr(l, {
        ...t,
        ...l.props,
        id: "menu-separator",
        key: `menu-separator-${m}`
      }) : /* @__PURE__ */ Fe(kd, { ...t, ...l.props, id: m, key: l.key || m, ref: i }, (b) => pr(l, {
        ...b,
        id: `menu-item-${m}`,
        key: `menu-item-${m}`
      })))
    ] });
    return /* @__PURE__ */ Ae(cn, { children: [
      s(),
      d()
    ] });
  }
);
jo.displayName = "Dropdown";
const Mb = (e) => {
  const t = re(!0);
  ue(() => {
    if (t.current) {
      t.current = !1;
      return;
    }
    e();
  }, [e]);
};
var Eb = typeof Rt == "object" && Rt && Rt.Object === Object && Rt, Pb = typeof self == "object" && self && self.Object === Object && self;
Eb || Pb || Function("return this")();
rt({
  pageUrl: ""
});
function ya({
  ariaLabel: e,
  baseId: t,
  button: r,
  buttonText: n,
  items: a,
  onClick: o,
  onHide: i,
  onShow: s,
  placement: u,
  renderItem: d,
  title: l
}) {
  const m = Wd({
    baseId: t || void 0,
    gutter: 7,
    placement: u || "bottom"
  }), { visible: b } = m, c = j(() => {
    b && s ? s() : !b && i && i();
  }, [i, s, b]);
  Mb(c);
  const v = Ne(() => r || /* @__PURE__ */ Y("button", { className: ze.dropdownPillButton, children: n }), [r, n]), f = Ne(() => a.map((y, M) => {
    const g = M === 0, p = {
      ...g ? {} : { onClick: () => o(y) }
    };
    return (
      // Key is applied by Reakit in <Dropdown /> component so we can
      // ignore here:
      // eslint-disable-next-line react/jsx-key
      /* @__PURE__ */ Y(
        "div",
        {
          className: `${ze.dropdownItem}${g ? ` ${ze.dropdownItemActive}` : ""}`,
          ...p,
          "data-testid": "dropdown-item",
          children: d(y, M)
        }
      )
    );
  }), [a, o, d]);
  return /* @__PURE__ */ Y(
    jo,
    {
      "data-testid": "dropdown-menu",
      disclosure: v,
      menu: m,
      menuItems: f,
      menuProps: {
        "aria-label": e,
        className: ze.dropdownPanel
      },
      title: l
    }
  );
}
const _r = () => /* @__PURE__ */ Y(
  "svg",
  {
    fill: "currentColor",
    height: "100%",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 6 12",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Y(
      "path",
      {
        clipRule: "evenodd",
        d: "M0.409017 6.69364C0.0361104 6.30639 0.0361104 5.6936 0.409017 5.30635L4.4669 1.09239C4.69078 0.859913 5.06296 0.859913 5.28683 1.09239C5.49907 1.31279 5.49907 1.66156 5.28683 1.88196L1.32131 6L5.28683 10.118C5.49907 10.3384 5.49907 10.6872 5.28683 10.9076C5.06296 11.1401 4.69078 11.1401 4.4669 10.9076L0.409017 6.69364Z",
        fillRule: "evenodd"
      }
    )
  }
), Sb = "_subeventHeaderWrapper_1s8el_1", Ob = "_subeventHeaderInnerWrapper_1s8el_6", Db = "_breadcrumbIcon_1s8el_19", _b = "_subeventEventLinkWrapper_1s8el_27", Tb = "_subeventEventLink_1s8el_27", Cb = "_subeventHeaderContentContainer_1s8el_61", xb = "_subeventTitle_1s8el_79", kb = "_subeventTitleMobileDropdown_1s8el_89", Ab = "_subeventTitleMobile_1s8el_89", $b = "_dropdownButtonWrapper_1s8el_111", Wb = "_dropdownIcon_1s8el_118", Rb = "_subeventMenuWrapper_1s8el_127", Ib = "_relatedSubeventContainer_1s8el_136", jb = "_relatedSubeventDatetime_1s8el_142", Nb = "_relatedSubeventNameContainer_1s8el_151", Fb = "_relatedSubeventName_1s8el_151", Hb = "_subeventHeaderTextWrapper_1s8el_168", Lb = "_subeventDatetime_1s8el_190", zb = "_subeventDatetimeWrapper_1s8el_205", Yb = "_offersPresentIcon_1s8el_216", Bb = "_matchStatsNewIcon_1s8el_223", Kb = "_inPlayIcon_1s8el_231", Ub = "_menuDivider_1s8el_246", Xb = "_liveStatsHeaderFallback_1s8el_258", Vb = "_desktopOnly_1s8el_267", qb = "_mobileOnly_1s8el_276", ve = {
  subeventHeaderWrapper: Sb,
  subeventHeaderInnerWrapper: Ob,
  breadcrumbIcon: Db,
  subeventEventLinkWrapper: _b,
  subeventEventLink: Tb,
  subeventHeaderContentContainer: Cb,
  subeventTitle: xb,
  subeventTitleMobileDropdown: kb,
  subeventTitleMobile: Ab,
  dropdownButtonWrapper: $b,
  dropdownIcon: Wb,
  subeventMenuWrapper: Rb,
  relatedSubeventContainer: Ib,
  relatedSubeventDatetime: jb,
  relatedSubeventNameContainer: Nb,
  relatedSubeventName: Fb,
  subeventHeaderTextWrapper: Hb,
  "change-match-dropdown": "_change-match-dropdown_1s8el_1",
  subeventDatetime: Lb,
  subeventDatetimeWrapper: zb,
  offersPresentIcon: Yb,
  matchStatsNewIcon: Bb,
  inPlayIcon: Kb,
  menuDivider: Ub,
  liveStatsHeaderFallback: Xb,
  desktopOnly: Vb,
  mobileOnly: qb
}, Qb = ({ breadcrumb: e, categoryGroupId: t, eventName: r, requestUrl: n }) => {
  const a = qp(t), { t: o } = sn([a ?? "label"]);
  return /* @__PURE__ */ Y(
    "a",
    {
      className: `${ve.subeventEventLink} ogm-subevent-header__breadcrumb`,
      "data-testid": "event-name",
      href: ko(e.url, n),
      title: e.name,
      children: o(r, { ns: a })
    }
  );
}, Gb = ({ dataApiEndpoint: e, i18n: t, ...r }) => {
  const { data: n } = ti({
    queryFn: () => Ro(e, r, {
      logger: console
    }),
    queryKey: Io(r)
  }), { dropdownText: a, overrideTitle: o, repub: i, requestUrl: s, timeZone: u } = r, {
    breadcrumbs: d = [],
    eventName: l = "",
    inRunning: m = !1,
    relatedSubevents: b = [],
    subeventName: c = "",
    subeventStartTime: v = ""
  } = n || {}, f = u ?? Je[i].dateProperties.timezone, h = xo.find((N) => N.id === (n == null ? void 0 : n.categoryGroupId)), M = [(h == null ? void 0 : h.translationFile) || "", "label", "bettype"], { t: g } = sn(M), p = j(
    (N) => {
      const U = pa(N);
      return U.success ? `${g(U.first)}${U.separator}${g(U.second)}`.trim() : g(N);
    },
    [g]
  ), P = pa(c), O = t == null ? void 0 : t.exists("CX_SUBEVENT_HEADER_PREFIX", { fallbackLng: [], ns: "label" }), x = P.success && O ? g("CX_SUBEVENT_HEADER_PREFIX", { ns: "label" }) : "", T = Vp.includes(i), S = o && o !== c, E = T ? p(c) : c, D = `${x} ${S ? o : E}`.trim(), _ = Ne(
    () => [
      {
        subeventName: c,
        subeventStartTime: v,
        subeventUrl: ""
      },
      ...b.map((N) => ({
        subeventName: N.subeventName || N.name,
        subeventStartTime: N.subeventStartTime || N.startTime,
        subeventUrl: N.subeventUrl || N.url
      }))
    ].map((N) => ({
      ...N,
      id: N.subeventName
    })),
    [b, c, v]
  ), I = d[d.length - 2], C = (N) => {
    const U = "subeventUrl" in N ? N.subeventUrl : N.url;
    window.location.href = ko(U);
  }, W = j((N) => {
    document.body.style.overflow = N ? "hidden" : "visible";
  }, []), G = j(() => {
    W(!1);
  }, [W]), ee = j(() => {
    W(!0);
  }, [W]), te = j(
    (N) => N ? ma(N, f, Je[i].dateProperties.format.timeDateShort, {
      locale: Je[i].dateProperties.locale
    }) : "",
    [f, i]
  ), fe = j(
    (N) => N ? ma(N, f, Je[i].dateProperties.format.timeDateFull, {
      locale: Je[i].dateProperties.locale
    }) : "",
    [f, i]
  ), oe = Ne(
    () => /* @__PURE__ */ Ae("button", { className: ze.dropdownPillButton, "data-label": a, children: [
      a,
      /* @__PURE__ */ Y("span", { className: ze.dropdownPillIconWrapper, children: /* @__PURE__ */ Y(_r, {}) })
    ] }),
    [a]
  ), ie = Ne(
    () => /* @__PURE__ */ Ae("h1", { className: ve.subeventTitleMobile, "data-label": a, children: [
      `${D} `,
      /* @__PURE__ */ Y("span", { className: ve.dropdownButtonWrapper, children: /* @__PURE__ */ Y("span", { className: ve.dropdownIcon, children: /* @__PURE__ */ Y(_r, {}) }) })
    ] }),
    [D, a]
  ), pe = j(
    (N) => {
      const U = "subeventStartTime" in N ? N.subeventStartTime : N.startTime, J = "subeventName" in N ? N.subeventName : N.name, ye = T ? p(J) : J;
      return /* @__PURE__ */ Ae("div", { className: ve.relatedSubeventContainer, children: [
        /* @__PURE__ */ Y("span", { className: ve.relatedSubeventDatetime, children: te(U) }),
        /* @__PURE__ */ Y("div", { className: ve.relatedSubeventNameContainer, children: /* @__PURE__ */ Y("span", { className: ve.relatedSubeventName, children: ye }) })
      ] });
    },
    [T, p, te]
  );
  return n ? /* @__PURE__ */ Y(Mo, { i18nInstance: t, children: /* @__PURE__ */ Y(wo, { children: /* @__PURE__ */ Y("div", { className: ve.subeventHeaderWrapper, "data-testid": "subevent-header", children: /* @__PURE__ */ Ae("div", { className: ve.subeventHeaderInnerWrapper, children: [
    !!I && /* @__PURE__ */ Ae("div", { className: ve.subeventEventLinkWrapper, children: [
      /* @__PURE__ */ Y("span", { className: ve.breadcrumbIcon, children: /* @__PURE__ */ Y(_r, {}) }),
      /* @__PURE__ */ Y(
        Qb,
        {
          breadcrumb: I,
          categoryGroupId: n.categoryGroupId,
          eventName: l,
          requestUrl: s
        }
      )
    ] }),
    /* @__PURE__ */ Y("div", { className: ve.subeventBodyWrapper, id: "subevent-header", children: /* @__PURE__ */ Ae("div", { className: ve.subeventHeaderContentContainer, children: [
      /* @__PURE__ */ Ae("div", { className: `${ve.subeventHeaderTextWrapper} ogm-subevent-header__title`, children: [
        /* @__PURE__ */ Y("div", { className: ve.desktopOnly, children: /* @__PURE__ */ Ae("h1", { className: ve.subeventTitle, "data-testid": "subevent-title", children: [
          D,
          m && /* @__PURE__ */ Y("span", { className: ve.inPlayIcon, children: g("CX_MATCHES_COUPON_LIVE", { ns: "label" }) })
        ] }) }),
        /* @__PURE__ */ Y("div", { className: ve.desktopOnly, children: /* @__PURE__ */ Y(
          ya,
          {
            ariaLabel: a,
            baseId: "change-match-dropdown-desktop",
            button: oe,
            buttonText: a,
            items: _,
            onClick: C,
            onHide: G,
            onShow: ee,
            placement: "bottom",
            renderItem: pe,
            title: l
          }
        ) }),
        /* @__PURE__ */ Y("div", { className: ve.mobileOnly, children: /* @__PURE__ */ Y(
          ya,
          {
            ariaLabel: a,
            baseId: "change-match-dropdown-mobile",
            button: ie,
            buttonText: a,
            items: _,
            onClick: C,
            onHide: G,
            onShow: ee,
            placement: "bottom-start",
            renderItem: pe,
            title: l
          }
        ) })
      ] }),
      /* @__PURE__ */ Y("div", { className: ve.subeventDatetimeWrapper, children: /* @__PURE__ */ Y(
        "time",
        {
          className: ve.subeventDatetime,
          "data-testid": "subevent-date",
          dateTime: fe(v),
          children: fe(v)
        }
      ) })
    ] }) })
  ] }) }) }) }) : null;
}, Tr = {
  desktop: 1024,
  desktopLg: 1360,
  desktopMd: 1200,
  phoneLg: 600,
  phoneSm: 320,
  tablet: 768
};
function Jb(e = {}) {
  var t;
  return new ei.QueryClient({
    ...e,
    defaultOptions: {
      ...e.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(r) {
          return r * 100;
        },
        ...(t = e.defaultOptions) == null ? void 0 : t.queries
      }
    }
  });
}
const sg = async (e, t) => {
  const r = Jb(), { nocache: n } = e;
  try {
    await r.prefetchQuery({
      queryFn: () => Ro(t, e, { nocache: n }),
      queryKey: Io(e)
    });
  } catch {
  }
  return {
    dehydratedState: ri(r)
  };
}, Zb = (e) => new oi({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      staleTime: e ? 0 : 1 / 0
    }
  }
});
function ug({ dehydratedState: e, deviceType: t, nocache: r, ...n }) {
  const [a] = ce(() => {
    const s = Zb(r);
    return ni(s, e), s;
  }), o = /* @__PURE__ */ Y(wo, { children: /* @__PURE__ */ Y(ai, { client: a, children: /* @__PURE__ */ Y(Mo, { i18nInstance: n.i18n, children: /* @__PURE__ */ Y(Zo, { fallback: /* @__PURE__ */ Y(jd, {}), children: /* @__PURE__ */ Y(Gb, { ...n }) }) }) }) });
  if (typeof window < "u")
    return o;
  const i = t === "MOBILE" ? Tr.phoneSm : t === "TABLET" ? Tr.tablet : Tr.desktop;
  return /* @__PURE__ */ Y(di.Context.Provider, { value: { width: i }, children: o });
}
export {
  ug as SubeventHeaderWithQuery,
  sg as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
